'use strict';

var homeRoute = '/';
var signinRoute = '/signin';
var adminDashboardRoute = '/admin-dashboard';
var adminRegistrationRoute = '/admin-registration';

var calendarRoute = '/calendar';
var adminCategoryTypes = '/admin/category_types';
var adminCategories = '/admin/categories/:category_type_id/:category_type_name';
var adminSubCategories = '/admin/sub_categories/:category_id/:category_name/:category_type_id/:category_type_name';

var adminComplianceDocumentTypes = '/admin/compliance_document_types';
var adminComplianceDocumentTemplates = '/admin/compliance_document_templates/:document_type_id/:document_type_name';

var adminFSPList = '/admin/fsp_list';
var adminFSPReportGenerate = '/admin/fsp_report_generate';
var adminFSPReportHistory = '/admin/fsp_report_history/:fsp_id/:fsp_name';
var adminFSPDetails = '/admin/fsp_list/:fsp_id';
var adminFSPProfileChange = '/admin/fsp_profile_change/:fsp_id';

//FSP SETTINGS
var adminFSPComplianceDocuments = '/admin/compliance_documents/:fsp_id/:fsp_name';
var adminFSPRiskProfile = '/admin/risk_profile/:fsp_id/:fsp_name';
var adminFSPClients = '/admin/clients/:fsp_id/:fsp_name';
var adminFSPShareholders = '/admin/shareholders/:fsp_id/:fsp_name';
var adminFSPDirectors = '/admin/directors/:fsp_id/:fsp_name';
var adminFSPComplianceBreaches = '/admin/compliance_breaches/:fsp_id/:fsp_name';
var adminFSPKeyIndividuals = '/admin/key_individuals/:fsp_id/:fsp_name';
var adminFSPAuditors = '/admin/auditors/:fsp_id/:fsp_name';
var adminFSPThirdPartyAdministrators = '/admin/third_party_administrators/:fsp_id/:fsp_name';
var adminFSPThirdPartyProviders = '/admin/third_party_providers/:fsp_id/:fsp_name';
var adminFSPThirdPartyLISPs = '/admin/third_party_lisps/:fsp_id/:fsp_name';
var adminFSPContactPersons = '/admin/contact_persons/:fsp_id/:fsp_name';
var adminFSPRepresentatives = '/admin/representatives/:fsp_id/:fsp_name';
var adminFSPScopeOfLicensing = '/admin/scope_of_licensing/:fsp_id/:fsp_name';
var adminFSBSubmissionDates = '/admin/submission_dates/:fsp_id/:fsp_name';

var fspReport = '/report/:fsp_report_id';

//LISTS
var adminRiskMatrices = '/admin/risk_matrices/:fsp_id/:fsp_name';
var adminRegRiskMatrix = '/admin/regulatory_risk_matrix/:fsp_id/:fsp_name';
var adminMktRiskMatrix = '/admin/market_risk_matrix/:fsp_id/:fsp_name';
var adminOperationalRiskMatrix = '/admin/operational_risk_matrix/:fsp_id/:fsp_name';
var adminExternalAuditorsList = '/admin/external_auditors/:fsp_id/:fsp_name';
var adminExternalAuditorDetails = '/admin/external_auditors/item/:fsp_id/:fsp_name/:item_id';

var adminFSPProfileChangeDetails = '/admin/fsp_profile_change_details/:profile_change_id/:fsp_id';
var adminFSPFollowUpProfileChange = '/admin/fsp_follow_up_profile_change/:profile_change_id/:fsp_id';
var adminFSBSubmitProfileChange = '/admin/fsb_submit_profile_change/:profile_change_id/:fsp_id';

var adminFSPDocuments = '/admin/fsp_documents/:fsp_id/:category_type_code/:document_type_title';
var adminFSPDocumentTree = '/admin/fsp_document_tree/:fsp_id/:fsp_name';

var adminEmailTemplates = '/admin/email_templates';
var adminFollowUpEmailTemplates = '/admin/follow_up_email_templates';
var adminFSCASubmissionReminderEmailTemplates = '/admin/fsca_submission_reminder_email_templates';
var adminFSBEmailTemplates = '/admin/fsb_email_templates';
var adminReportEmailTemplates = '/admin/report_email_templates';
var adminRecycleBin = '/admin/recycle_bin';
var authTwoFactorRoute = '/two_factor_auth';

var currentTab = localStorage.currentTab ? localStorage.currentTab : '';

// User Roles
var ROLE_SUPER_ADMIN = 'super_admin';
var ROLE_ADMIN = 'admin';
var ROLE_FSP = 'fsp';

angular.module('ics', ['firebase', 'ui.router', 'mwl.calendar']).config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode(true);
}]).config(function ($httpProvider) {
    $httpProvider.interceptors.push('responseObserver');
}).config(function ($stateProvider, $urlRouterProvider) {

    $stateProvider.state('home', {
        url: homeRoute,
        templateUrl: '/static/partials/home/home.html',
        controller: 'HomeController'
    })

    /* .state('signin', {
        url: signinRoute,
        templateUrl: '/static/partials/signin/signin.html',
        controller: 'AuthController'
    })*/

    .state('admin-dashboard', {
        url: adminDashboardRoute,
        templateUrl: '/static/partials/admin/dashboard.html',
        controller: 'AdminDashboardController'
    }).state('admin-registration', {
        url: adminRegistrationRoute,
        templateUrl: '/static/partials/admin/admin_registration.html',
        controller: 'AdminRegistrationController'
    }).state('admin-category-types', {
        url: adminCategoryTypes,
        templateUrl: '/static/partials/admin/category_types.html',
        controller: 'CategoryTypesAdminController'
    }).state('admin-recycle-bin', {
        url: adminRecycleBin,
        templateUrl: '/static/partials/admin/recycle_bin.html',
        controller: 'RecycleBinController'
    }).state('calendar', {
        url: calendarRoute,
        templateUrl: '/static/partials/admin/calendar.html',
        controller: 'CalendarController'
    }).state('admin-categories', {
        url: adminCategories,
        templateUrl: '/static/partials/admin/categories.html',
        controller: 'CategoriesAdminController'
    }).state('admin-sub-categories', {
        url: adminSubCategories,
        templateUrl: '/static/partials/admin/sub_categories.html',
        controller: 'SubCategoriesAdminController'
    }).state('admin-compliance-document-types', {
        url: adminComplianceDocumentTypes,
        templateUrl: '/static/partials/admin/compliance_document_types.html',
        controller: 'ComplianceDocumentTypesAdminController'
    }).state('admin-compliance-templates', {
        url: adminComplianceDocumentTemplates,
        templateUrl: '/static/partials/admin/compliance_document_templates.html',
        controller: 'ComplianceDocTemplatesAdminController'
    }).state('admin-email-templates', {
        url: adminEmailTemplates,
        templateUrl: '/static/partials/admin/email_templates.html',
        controller: 'EmailTemplatesAdminController'
    }).state('admin-follow-up-email-templates', {
        url: adminFollowUpEmailTemplates,
        templateUrl: '/static/partials/admin/follow_up_email_templates.html',
        controller: 'FollowUpEmailTemplatesAdminController'
    }).state('admin-fsca-submission-reminder-email-templates', {
        url: adminFSCASubmissionReminderEmailTemplates,
        templateUrl: '/static/partials/admin/fsca_submission_reminder_email_templates.html',
        controller: 'FCSASubmissionReminderEmailTemplatesAdminController'
    }).state('admin-fsb-email-templates', {
        url: adminFSBEmailTemplates,
        templateUrl: '/static/partials/admin/fsb_email_templates.html',
        controller: 'FSBEmailTemplatesAdminController'
    }).state('admin-report-email-templates', {
        url: adminReportEmailTemplates,
        templateUrl: '/static/partials/admin/report_email_templates.html',
        controller: 'ReportEmailTemplatesAdminController'
    }).state('admin-fsp-list', {
        url: adminFSPList,
        templateUrl: '/static/partials/admin/financial_service_providers.html',
        controller: 'FSPController'
    }).state('admin-fsp-report-generate', {
        url: adminFSPReportGenerate,
        templateUrl: '/static/partials/admin/fsp_report_generate.html',
        controller: 'FSPReportGenerateController'
    }).state('admin-fsp-report-history', {
        url: adminFSPReportHistory,
        templateUrl: '/static/partials/admin/fsp_report_history.html',
        controller: 'FSPReportHistoryController'
    }).state('admin-fsp-details', {
        url: adminFSPDetails,
        templateUrl: '/static/partials/admin/financial_service_provider_details.html',
        controller: 'FSPDetailsController'
    }).state('admin-fsp-profile-change', {
        url: adminFSPProfileChange,
        templateUrl: '/static/partials/admin/fsp_profile_change.html',
        controller: 'FSPProfileChangeController'
    }).state('admin-fsp-profile-change-details', {
        url: adminFSPProfileChangeDetails,
        templateUrl: '/static/partials/admin/fsp_profile_change_details.html',
        controller: 'FSPProfileChangeDetailsController'
    }).state('admin-fsp-follow-up-profile-change', {
        url: adminFSPFollowUpProfileChange,
        templateUrl: '/static/partials/admin/fsp_follow_up_profile_change.html',
        controller: 'FSPFollowUpProfileChangeController'
    }).state('admin-fbp-submit-profile-change', {
        url: adminFSBSubmitProfileChange,
        templateUrl: '/static/partials/admin/fsb_submit_profile_change.html',
        controller: 'SubmitProfileChangeController'
    }).state('admin-fsp-document-tree', {
        url: adminFSPDocumentTree,
        templateUrl: '/static/partials/admin/fsp_document_tree.html',
        controller: 'FSPDocumentTreeAdminController'
    }).state('admin-fsp-documents', {
        url: adminFSPDocuments,
        templateUrl: '/static/partials/admin/fsp_docs_list.html',
        controller: 'FSPDocsAdminController'
    }).state('admin-fsp-compliance-documents', {
        url: adminFSPComplianceDocuments,
        templateUrl: '/static/partials/admin/fsp_compliance_documents.html',
        controller: 'FSPComplianceDocumentsAdminController'
    }).state('admin-fsp-risk-profile', {
        url: adminFSPRiskProfile,
        templateUrl: '/static/partials/admin/fsp_risk_profile.html',
        controller: 'FSPRiskProfileAdminController'
    }).state('signin', {
        url: '/signin',
        templateUrl: '/static/partials/signin/signin.html',
        controller: 'AuthController'
    }).state('forgot-password', {
        url: '/forgot-password',
        templateUrl: '/static/partials/signin/forgot_password.html',
        controller: 'AuthController'
    }).state('fsp-team-member-sign-up', {
        url: '/fsp-member-sign-up/:token_id',
        templateUrl: '/static/partials/fsp/team_member_sign_up.html',
        controller: 'FSPTeamMemberSignUpController'
    })

    //SETTINGS


    .state('fsp-clients-list', {
        url: adminFSPClients,
        templateUrl: '/static/partials/admin/fsp_clients_list.html',
        controller: 'FSPClientsAdminController'
    }).state('fsp-shareholders-list', {
        url: adminFSPShareholders,
        templateUrl: '/static/partials/admin/fsp_shareholders_list.html',
        controller: 'FSPShareholdersAdminController'
    }).state('fsp-directors-list', {
        url: adminFSPDirectors,
        templateUrl: '/static/partials/admin/fsp_directors_list.html',
        controller: 'FSPDirectorsAdminController'
    }).state('fsp-compliance-breaches-list', {
        url: adminFSPComplianceBreaches,
        templateUrl: '/static/partials/admin/fsp_compliance_breaches_list.html',
        controller: 'FSPComplianceBreachesAdminController'
    }).state('fsp-report', {
        url: fspReport,
        templateUrl: '/static/partials/admin/fsp_report.html',
        controller: 'FSPReportController'
    }).state('fsp-key-individuals-list', {
        url: adminFSPKeyIndividuals,
        templateUrl: '/static/partials/admin/fsp_key_individuals_list.html',
        controller: 'FSPKeyIndividualsAdminController'
    }).state('fsp-auditors-list', {
        url: adminFSPAuditors,
        templateUrl: '/static/partials/admin/fsp_auditors_list.html',
        controller: 'FSPAuditorsAdminController'
    }).state('fsp-contact-persons-list', {
        url: adminFSPContactPersons,
        templateUrl: '/static/partials/admin/fsp_contact_persons_list.html',
        controller: 'FSPContactPersonsAdminController'
    }).state('fsp-representatives-list', {
        url: adminFSPRepresentatives,
        templateUrl: '/static/partials/admin/fsp_representatives_list.html',
        controller: 'FSPRepresentativesAdminController'
    }).state('fsb-submission-dates', {
        url: adminFSBSubmissionDates,
        templateUrl: '/static/partials/admin/fsb_submission_dates.html',
        controller: 'FSBSubmissionDatesAdminController'
    }).state('fsp-scope-of-licensing', {
        url: adminFSPScopeOfLicensing,
        templateUrl: '/static/partials/admin/fsp_scope_of_licensing.html',
        controller: 'FSPScopeOfLicensingAdminController'
    }).state('fsp-third-party-administrators-list', {
        url: adminFSPThirdPartyAdministrators,
        templateUrl: '/static/partials/admin/fsp_third_party_administrators_list.html',
        controller: 'FSPThirdPartyAdministratorsAdminController'
    }).state('fsp-third-party-providers-list', {
        url: adminFSPThirdPartyProviders,
        templateUrl: '/static/partials/admin/fsp_third_party_providers_list.html',
        controller: 'FSPThirdPartyProvidersAdminController'
    }).state('fsp-third-party-lisps-list', {
        url: adminFSPThirdPartyLISPs,
        templateUrl: '/static/partials/admin/fsp_third_party_lisps_list.html',
        controller: 'FSPThirdPartyLispsAdminController'
    })

    //LISTS

    .state('risk-matrices', {
        url: adminRiskMatrices,
        templateUrl: '/static/partials/admin/lists/risk_matrices.html',
        controller: 'RiskMatricesAdminController'
    }).state('reg-risk-matrix', {
        url: adminRegRiskMatrix,
        templateUrl: '/static/partials/admin/lists/regulatory_risk_matrix.html',
        controller: 'RegRiskMatrixAdminController'
    }).state('mkt-risk-matrix', {
        url: adminMktRiskMatrix,
        templateUrl: '/static/partials/admin/lists/market_risk_matrix.html',
        controller: 'MarketRiskMatrixAdminController'
    }).state('operational-risk-matrix', {
        url: adminOperationalRiskMatrix,
        templateUrl: '/static/partials/admin/lists/operational_risk_matrix.html',
        controller: 'OperationalRiskMatrixAdminController'
    }).state('external-auditor-list', {
        url: adminExternalAuditorsList,
        templateUrl: '/static/partials/admin/lists/external_auditor_list.html',
        controller: 'ExternalAuditorListAdminController'
    }).state('external-auditor-details', {
        url: adminExternalAuditorDetails,
        templateUrl: '/static/partials/admin/lists/external_auditor_details.html',
        controller: 'ExternalAuditorDetailsAdminController'
    }).state('two_factor_auth', {
        url: authTwoFactorRoute,
        templateUrl: '/static/partials/signin/two_factor_auth.html',
        controller: 'TwoFactorAuthController'
    });

    // catch all routes
    $urlRouterProvider.otherwise(homeRoute);
});
'use strict';

var utils = function () {

    var DURATION_IN_SECONDS = {
        epochs: ['year', 'month', 'day', 'hour', 'minute'],
        year: 31536000,
        month: 2592000,
        day: 86400,
        hour: 3600,
        minute: 60
    };

    function getDuration(seconds) {
        var epoch = void 0,
            interval = void 0;

        for (var i = 0; i < DURATION_IN_SECONDS.epochs.length; i++) {
            epoch = DURATION_IN_SECONDS.epochs[i];
            interval = Math.floor(seconds / DURATION_IN_SECONDS[epoch]);
            if (interval >= 1) {
                return { interval: interval, epoch: epoch };
            }
        }
    }

    return {

        chunkArray: function chunkArray(arr, size) {
            var newArr = [];
            for (var i = 0; i < arr.length; i += size) {
                newArr.push(arr.slice(i, i + size));
            }
            return newArr;
        },

        sanitizeURL: function sanitizeURL(url) {

            if (url != null && url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
                return "https://" + url;
            }

            return url;
        },

        timeSince: function timeSince(date) {
            var seconds = Math.floor((new Date() - new Date(date)) / 1000);
            var duration = getDuration(seconds);
            if (!duration) {
                return 'just now';
            }
            var suffix = duration.interval > 1 || duration.interval === 0 ? 's' : '';
            return duration.interval + ' ' + duration.epoch + suffix + ' ago';
        }

    };
}();
'use strict';

angular.module('ics').controller('BaseAdminController', function ($state, $rootScope, $scope, $window, FirebaseAuthService, FirebaseStorageService) {

    $scope.errorMessage = '';
    $scope.uploadedFileNames = [];
    $scope.visitorId = "";

    angular.element(function () {

        $(document).ready(function () {

            // Materialise SideNav
            $('.toggle-side-nav').sideNav({
                menuWidth: 179
            });
            $('.close-side-nav').on('click', function () {
                $('toggle-side-nav').sideNav('hide');
            });

            // Materialise Tabs
            $('ul.tabs').tabs({
                onShow: function onShow(tab) {
                    currentTab = $(tab)[0].id;
                    localStorage.setItem('currentTab', currentTab);
                }
            });
            if (currentTab !== '') {
                $('ul.tabs').tabs('select_tab', currentTab);
            }

            var fpCookieValue = getCookie("ics-visitor-id");
            if (fpCookieValue) {
                $scope.visitorId = fpCookieValue;
                console.log($scope.visitorId);
            } else {
                // Get the visitor identifier when you need it.
                fpPromise.then(function (fp) {
                    return fp.get();
                }).then(function (result) {
                    console.log(result.visitorId);
                    $scope.visitorId = result.visitorId;
                    setCookie("ics-visitor-id", result.visitorId, 999);
                });
            }
        });
    });

    $scope.checkErrStatus = function (error) {
        console.log('checkErrStatus');
        console.log(error);
        if (error.status === 403) {
            return $scope.signOut();
        }
        $scope.errorMessage = error.data || error.message || error;
        console.log('$scope.errorMessage set');
        $scope.$applyAsync();
        if ($scope.processing) {
            $scope.processing = false;
        }
    };

    $scope.removeAttachment = function (index, attachments) {
        var filesUploadedIndex = $scope.uploadedFileNames.findIndex(function (item) {
            return item === attachments[index].file_name;
        });
        if (filesUploadedIndex !== -1) {
            $scope.uploadedFileNames.splice(filesUploadedIndex, 1);
        }
        attachments.splice(index, 1);
    };

    $scope.fileUploader = function (e) {
        var _this = this;

        var fileNames = [],
            firebasePromises = [];

        if (!e.target.files || e.target.files.length === 0) {
            return;
        }

        var _loop = function _loop() {
            var file = e.target.files[i];
            console.log(file);
            if (!file || !file.name) {
                return 'continue';
            }
            if ($scope.uploadedFileNames.find(function (item) {
                return item === file.name;
            })) {
                return 'continue';
            }
            $scope.uploadedFileNames.push(file.name);
            fileNames.push(file.name);
            firebasePromises.push(FirebaseStorageService.uploadFileToCloudStorage(_this.folder, file, null));
        };

        for (var i = 0; i < e.target.files.length; i++) {
            var _ret = _loop();

            if (_ret === 'continue') continue;
        }

        if (firebasePromises.length === 0) {
            return;
        }

        $('.file-field #uploading-document').removeClass('ng-hide');

        Promise.all(firebasePromises).then(function (storageInfos) {

            for (var _i = 0; _i < storageInfos.length; _i++) {

                _this.attachments.push({
                    file_name: fileNames[_i],
                    file_url: storageInfos[_i].downloadUrl
                });
            }

            $scope.$broadcast('filesUploaded', _this.attachments);
            $('.file-field #uploading-document').addClass('ng-hide');
        }).catch(function (err) {
            $('.file-field #uploading-document').addClass('ng-hide');
            $scope.checkErrStatus(err);
        });
    };

    $scope.signOut = function () {
        console.log('sign out');
        FirebaseAuthService.signOut().then(function () {
            $rootScope.loggedInUserRole = {};
            $rootScope.isAuthenticated = false;
            $scope.isSuperAdmin = false;
            $scope.isAdmin = false;
            $scope.isFSP = false;
            currentTab = '';
            localStorage.removeItem('currentTab');
            $state.transitionTo('signin');
        }, function (error) {
            //console.error('Sign out error', error);
        });
    };

    $scope.padNumber = function (value) {
        var item = parseInt(value, 10);
        if (item < 10) {
            return '0' + item;
        }
        return item + '';
    };

    $scope.historyBack = function () {
        $window.history.back();
    };

    //materialize boilerplate
    setTimeout(function () {

        $(document).ready(function () {

            $('.modal').modal({
                complete: function complete(args) {
                    console.log('complete');
                }
            });

            $('select').material_select();
        });
    }, 500);
});
'use strict';

angular.module('ics').controller('AdminDashboardController', function ($scope, $rootScope, $state, $controller, FirebaseAuthService, AdminService) {

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    getSuperAdminList();
    function getSuperAdminList() {
        FirebaseAuthService.getUserToken().then(function (tokenId) {
            return AdminService.getSuperAdminList(tokenId, $scope.visitorId);
        }).then(function (response) {
            $scope.adminUsers = response.data.admin_users;
            $scope.$applyAsync();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }
});
'use strict';

angular.module('ics').controller('AdminRegistrationController', function ($scope, $state, FirebaseAuthService, AdminService) {

    $scope.formData = {};
    $scope.error_message = '';
    $scope.processing = false;
    $scope.firebaseAuthService = FirebaseAuthService;

    $scope.signUp = function () {

        $scope.error_message = '';
        $scope.processing = true;

        FirebaseAuthService.signOut().then(function () {
            return FirebaseAuthService.createUserWithEmailAndPassword($scope.formData.email_address, $scope.formData.password, $scope.formData.first_name, $scope.formData.last_name);
        }).then(function (token) {
            return AdminService.signupAdminUser($scope.formData.first_name, $scope.formData.last_name, 'super_admin', token);
        }).then(function (res) {
            return FirebaseAuthService.signInWithCustomToken(res.data.token);
        }).then(function () {
            $scope.processing = false;
            $state.transitionTo('admin-dashboard');
        }).catch(function (e) {
            $scope.processing = false;
            $scope.$apply(function () {
                $scope.error_message = e.message;
            });
            console.log('error encountered');
            console.log(e);
        });
    };
});
"use strict";

angular.module('ics').directive("ngFormCommit", [function () {
    return {
        require: "form",
        link: function link($scope, $el, $attr, $form) {
            $form.commit = function () {
                $el[0].submit();
            };
        }
    };
}]);
'use strict';

angular.module('ics').factory('AdminService', function ($http) {

    var service = {

        signupAdminUser: function signupAdminUser(first_name, last_name, role, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/admin/new_user',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'first_name': first_name,
                    'last_name': last_name,
                    'role': role
                }
            };

            return $http(req);
        },

        getSuperAdminList: function getSuperAdminList(firebaseTokenId, visitorId) {
            var req = {
                method: 'GET',
                url: '/api/admin/super_admin',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };
            return $http(req);
        }
    };

    return service;
});
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('AuthController', function ($scope, $rootScope, $controller, $state, FirebaseAuthService, TwoFactorAuthService) {

    //angular.extend(this, $controller('BaseAdminController', {$scope: $scope}));

    $rootScope.err = {
        message: 'rytr '
    };
    $scope.reset_email_sent = false;
    $rootScope.isAuthenticated = false;
    $scope.awaitingOTP = false;
    $rootScope.awaitingOTP = false;
    $scope.sentOTP = false;

    $scope.signIn = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email, password) {
            var idToken, res, _res;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;


                            $rootScope.err.message = '';
                            $scope.processing = true;

                            _context.next = 5;
                            return firebase.auth().signInWithEmailAndPassword(email, password);

                        case 5:
                            _context.next = 7;
                            return firebase.auth().currentUser.getToken( /* forceRefresh */true);

                        case 7:
                            idToken = _context.sent;
                            _context.next = 10;
                            return FirebaseAuthService.createCustomToken(idToken);

                        case 10:
                            res = _context.sent;
                            //generate custom token on server, containing user's roles and 2fa status, and sign in with this custom token
                            $rootScope.loggedInUserRole = res.role;
                            $rootScope.twoFARequired = res.two_fa_required;
                            FirebaseAuthService.saveTwoFaRequired(res);
                            console.log(res);

                            if (!res.two_fa_required) {
                                _context.next = 24;
                                break;
                            }

                            $scope.processing = false;
                            $rootScope.show_loading = true;
                            _context.next = 20;
                            return TwoFactorAuthService.setupTwoFactorAuthentication(idToken);

                        case 20:
                            _res = _context.sent;

                            FirebaseAuthService.performDuo2FARedirect(_res);
                            _context.next = 26;
                            break;

                        case 24:
                            $scope.processing = false;
                            $scope.proceedToNextPage();

                        case 26:
                            // $rootScope.processing = false;
                            $rootScope.err.message = '';
                            $scope.$apply();
                            $rootScope.$apply();
                            console.log('$scope.awaitingOTP=' + $scope.awaitingOTP);

                            _context.next = 41;
                            break;

                        case 32:
                            _context.prev = 32;
                            _context.t0 = _context['catch'](0);

                            $scope.processing = false;
                            $rootScope.isAuthenticated = false;
                            $rootScope.err = {
                                message: _context.t0
                            };
                            alert('An error has occurred, please try again: ' + _context.t0);
                            $scope.$apply();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();

                        case 41:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 32]]);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();

    $scope.sendPasswordResetEmail = function (email) {
        firebase.auth().sendPasswordResetEmail(email);
        $scope.reset_email_sent = true;
    };

    // Invoked if user does not have Authy installed and asks for OTP to be sent to them
    $scope.requestOneTimePin = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($event) {
            var tokenId;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;

                            $event.preventDefault();
                            $scope.processing = true;
                            _context2.next = 5;
                            return FirebaseAuthService.getUserToken();

                        case 5:
                            tokenId = _context2.sent;
                            _context2.next = 8;
                            return TwoFactorAuthService.requestOneTimePin(tokenId, $scope.visitorId);

                        case 8:
                            $scope.sentOTP = true;
                            $scope.processing = false;
                            $scope.$apply();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();
                            _context2.next = 24;
                            break;

                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](0);

                            $scope.processing = false;
                            $rootScope.isAuthenticated = false;
                            $rootScope.err = {
                                message: _context2.t0
                            };
                            alert('An error has occurred, please try again: ' + _context2.t0);
                            $scope.$apply();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();

                        case 24:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 15]]);
        }));

        return function (_x3) {
            return _ref2.apply(this, arguments);
        };
    }();

    $scope.confirmOTP = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(otp) {
            var visitorId, fp, idToken, twoFAToken, res;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;


                            $rootScope.err.message = '';
                            $scope.processing = true;

                            // Retrieve the visitor Id
                            visitorId = getCookie("ics-visitor-id");

                            if (visitorId) {
                                _context3.next = 13;
                                break;
                            }

                            _context3.next = 7;
                            return fpPromise;

                        case 7:
                            fp = _context3.sent;
                            _context3.next = 10;
                            return fp.get();

                        case 10:
                            result = _context3.sent;

                            visitorId = result.visitorId;
                            setCookie("ics-visitor-id", result.visitorId, 999);

                        case 13:
                            _context3.next = 15;
                            return firebase.auth().currentUser.getToken( /* forceRefresh */true);

                        case 15:
                            idToken = _context3.sent;
                            _context3.next = 18;
                            return TwoFactorAuthService.verifyOneTimePin(idToken, otp, visitorId);

                        case 18:
                            twoFAToken = _context3.sent;

                            setCookie("ics-2fa-auth-token", twoFAToken, 999);
                            _context3.next = 22;
                            return FirebaseAuthService.createCustomToken(idToken);

                        case 22:
                            res = _context3.sent;
                            //generate custom token on server, containing user's roles and 2fa status, and sign in with this custom token
                            $rootScope.loggedInUserRole = res.role;

                            $scope.awaitingOTP = false;
                            $rootScope.awaitingOTP = false;
                            $scope.processing = false;
                            $rootScope.err.message = '';
                            $scope.proceedToNextPage();

                            _context3.next = 40;
                            break;

                        case 31:
                            _context3.prev = 31;
                            _context3.t0 = _context3['catch'](0);

                            $scope.processing = false;
                            $rootScope.isAuthenticated = false;
                            $rootScope.err = {
                                message: _context3.t0
                            };
                            alert('An error has occurred, please try again: ' + _context3.t0);
                            $scope.$apply();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();

                        case 40:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 31]]);
        }));

        return function (_x4) {
            return _ref3.apply(this, arguments);
        };
    }();

    $scope.proceedToNextPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this = this;

        var tokenId;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        window.localStorage.removeItem('associated_fsps');

                        if (!($rootScope.loggedInUserRole.entity_role === ROLE_SUPER_ADMIN || $rootScope.loggedInUserRole.entity_role === ROLE_ADMIN)) {
                            _context5.next = 6;
                            break;
                        }

                        $rootScope.isAuthenticated = true;
                        $state.transitionTo('admin-dashboard');

                        _context5.next = 16;
                        break;

                    case 6:
                        if (!($rootScope.loggedInUserRole.entity_role === ROLE_FSP)) {
                            _context5.next = 14;
                            break;
                        }

                        $rootScope.isAuthenticated = true;
                        _context5.next = 10;
                        return FirebaseAuthService.getUserToken();

                    case 10:
                        tokenId = _context5.sent;


                        setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                            var res, activeFSPs;
                            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                while (1) {
                                    switch (_context4.prev = _context4.next) {
                                        case 0:
                                            _context4.next = 2;
                                            return FirebaseAuthService.getContactPersonAssociatedFsps(tokenId, $scope.visitorId);

                                        case 2:
                                            res = _context4.sent;

                                            if (res && res.data && res.data.associated_fsps && res.data.associated_fsps) {
                                                activeFSPs = res.data.associated_fsps.filter(function (item) {
                                                    return !!item.active;
                                                });

                                                if (activeFSPs.length) {
                                                    window.localStorage.setItem('associated_fsps', JSON.stringify(activeFSPs));
                                                    $state.transitionTo('admin-fsp-details', { fsp_id: activeFSPs[0].id });
                                                }
                                            }

                                        case 4:
                                        case 'end':
                                            return _context4.stop();
                                    }
                                }
                            }, _callee4, _this);
                        })), 500);

                        _context5.next = 16;
                        break;

                    case 14:

                        $rootScope.isAuthenticated = false;
                        $state.transitionTo('home');

                    case 16:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));
});
'use strict';

angular.module('ics').factory('FirebaseAuthService', function ($http, $state, $rootScope) {

    var userRoles = [];
    var userFirebaseToken = '';
    var processingToken = false;

    firebase.auth().onAuthStateChanged(function (user) {
        if (user && !processingToken) {
            //the user must be logged in, and we must not be retrieving his/her token
            processingToken = true;
            firebase.auth().currentUser.getToken().then(function (token) {
                if (token === userFirebaseToken) {
                    //thus token is identical to the one stored in memory, don't get user's roles!
                    return;
                }
                userFirebaseToken = token;

                try {

                    localStorage.setItem('user_custom_firebase_token', token);
                    // get decoded token so we can set our userRoles from NodeJS server
                    var req = {
                        method: 'POST',
                        url: '/api/auth/user_role',
                        timeout: 8000,
                        data: {
                            'token': token
                        }
                    };
                    $http(req).then(function (res) {
                        // extract roles from decoded token into an array to be used by controllers

                        if (res && res.data && res.data.role) {

                            var role = res.data.role;
                            localStorage.setItem('ics_user_role', JSON.stringify(role));
                            $rootScope.$broadcast('user-role-loaded', role);
                        }
                        processingToken = false;
                    }, function (err) {
                        console.log(err);
                    });
                } catch (e) {
                    console.log(e);
                }
            });
        } else {
            processingToken = false;
        }
    });

    return {

        getUserRole: function getUserRole() {
            return userRole;
        },

        getLoggedInUserRole: function getLoggedInUserRole() {
            var userRole = {};
            //put in try catch in case this value has not yet been set in localStorage
            try {
                userRole = JSON.parse(localStorage.ics_user_role);
                this.setTwoFaRequiredAfterCallback();
            } catch (exception) {
                console.log(exception);
                userRole = this.getRoleFromCookie();
                if (userRole !== null) {
                    if (userRole.entity_role !== 'fsp') {
                        this.requestRedirect();
                    }
                }
            }
            return {
                userRole: userRole
            };
        },

        setTwoFaRequiredAfterCallback: function setTwoFaRequiredAfterCallback() {
            if (getCookie('duo_token') !== '') {
                var twoFaRequired = { 'two_fa_required': true };
                this.saveTwoFaRequired(twoFaRequired);
            }
        },

        saveTwoFaRequired: function saveTwoFaRequired(res) {
            localStorage.setItem('two_fa_required', JSON.stringify(res));
        },

        getTwoFaRequired: function getTwoFaRequired() {
            var getTwoFaRequired = void 0;
            if (localStorage.getItem('two_fa_required')) {
                getTwoFaRequired = JSON.parse(localStorage.two_fa_required);
                return getTwoFaRequired.two_fa_required;
            } else {
                return false;
            }
        },

        performDuo2FARedirect: function performDuo2FARedirect(res) {
            try {
                var auth = res && res.data && res.data.authenticate;
                var uri = res && res.data && res.data.result;
                if (auth) {
                    window.location = uri;
                } else {
                    $state.transitionTo('signin');
                }
            } catch (err) {
                alert('An error has occurred, please try again: ' + err);
                $rootScope.$apply();
                $rootScope.$applyAsync();
            } finally {
                $rootScope.show_loading = false;
            }
        },

        getRoleFromCookie: function getRoleFromCookie() {
            var userRole = void 0;
            if (getCookie('duo_token') !== '') {
                var res = this.signInWithCustomToken(getCookie('custom_token'));
                localStorage.setItem('user_custom_firebase_token', getCookie('custom_token'));

                userRole = {
                    'entity_id': getCookie('entity_id'),
                    'entity_role': getCookie('entity_role'),
                    'entity_type': getCookie('entity_type'),
                    'id': getCookie('id')
                };

                $rootScope.currentState = 'signin';
                var twoFaReq = { 'two_fa_required': true };
                localStorage.setItem('two_fa_required', JSON.stringify(twoFaReq));
                localStorage.setItem('ics_user_role', JSON.stringify(userRole));
            } else {
                userRole = null;
            }
            return userRole;
        },

        signOut: function signOut() {
            localStorage.removeItem('user_custom_firebase_token');
            localStorage.removeItem('ics_user_role');
            localStorage.removeItem('pitchin_user_roles');
            localStorage.removeItem('two_fa_required');

            for (var key in localStorage) {
                if (key.substring(0, 9) == 'firebase:') {
                    localStorage.removeItem(key);
                }
            }

            return firebase.auth().signOut();
        },

        getUserToken: function getUserToken() {
            var _this = this;

            return new Promise(function (resolve, reject) {

                var currentTimeStamp = new Date().getTime();
                var currentAccessToken = '';

                try {

                    for (var key in localStorage) {
                        if (key.startsWith("firebase:authUser:")) {

                            var json = JSON.parse(localStorage[key]);
                            var expirationTime = json['stsTokenManager']['expirationTime'];
                            currentAccessToken = json['stsTokenManager']['accessToken'];

                            if (currentTimeStamp < expirationTime) {
                                resolve(currentAccessToken);
                            } else {
                                resolve(firebase.auth().currentUser.getToken(true));
                            }
                        }
                    }

                    resolve();
                } catch (exception) {
                    console.log(exception);
                    _this.signOut().then(function () {
                        $state.transitionTo('signin');
                    });
                }
            });
        },


        createCustomToken: function createCustomToken(firebaseTokenId, visitorId) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'GET',
                    url: '/api/auth/create_custom_token',
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    if (res && res.data && res.data.token) {
                        _this2.signInWithCustomToken(res.data.token).then(function () {
                            resolve({
                                role: res.data.role,
                                two_fa_required: !!res.data.two_fa_required
                            });
                        }, function (err) {
                            reject(err);
                        });
                    } else {
                        reject('not token received');
                    }
                }, function (err) {
                    reject(err);
                });
            });
        },

        getContactPersonAssociatedFsps: function getContactPersonAssociatedFsps(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_contact_person_associated_fsps',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        requestRedirect: function requestRedirect() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var token = _this3.getUserToken();

                var req = {
                    method: 'GET',
                    url: '/admin-dashboard',
                    headers: {
                        'x-firebase-token': token,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                return $http(req);
            });
        },

        createUserRole: function createUserRole(firebaseTokenId, firebaseUserId, entityId, entityType, role) {
            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'POST',
                    url: '/api/auth/create_user_role',
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    data: {
                        firebase_user_id: firebaseUserId,
                        entity_id: entityId,
                        entity_type: entityType,
                        role: role
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    resolve();
                }, function (err) {
                    reject(err);
                });
            });
        },

        createUserWithEmailAndPassword: function createUserWithEmailAndPassword(email, password, first_name, last_name) {
            var promise = new Promise(function (resolve, reject) {

                firebase.auth().createUserWithEmailAndPassword(email, password).then(function (res) {

                    var user = firebase.auth().currentUser;

                    user.updateProfile({
                        displayName: first_name + ' ' + last_name
                    }).then(function (res) {

                        resolve(user.getToken());
                    });
                }).catch(function (err) {
                    reject(err);
                });
            });

            return promise;
        },

        createUserWithEmailAndPasswordReturnUid: function createUserWithEmailAndPasswordReturnUid(email, password, name) {
            var promise = new Promise(function (resolve, reject) {

                firebase.auth().createUserWithEmailAndPassword(email, password).then(function (res) {

                    var user = firebase.auth().currentUser;

                    user.updateProfile({
                        displayName: name
                    }).then(function (res) {

                        resolve(user.uid);
                    });
                }).catch(function (err) {
                    reject(err);
                });
            });

            return promise;
        },

        signInWithCustomToken: function signInWithCustomToken(token) {
            localStorage.removeItem('user_custom_firebase_token');
            localStorage.removeItem('ics_user_role');

            var promise = new Promise(function (resolve, reject) {

                //log in using the new custom token
                firebase.auth().signInWithCustomToken(token).then(function (res) {

                    firebase.auth().currentUser.getToken(true).then(function (token) {

                        localStorage.setItem('user_custom_firebase_token', token);
                        resolve();
                    });
                }).catch(function (err) {

                    reject(err);
                });
            });

            return promise;
        }

    };
});
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('TwoFactorAuthController', function ($scope, $rootScope, $controller, $state, FirebaseAuthService, TwoFactorAuthService) {

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.awaitingOTP = false;
    $scope.sentOTP = false;
    $scope.validatedSuccess = false;

    $scope.setupTwoFactor = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee($event) {
            var tokenId, res;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            $event.preventDefault();
                            $scope.processing = true;
                            $scope.errorMessage = '';

                            _context.next = 6;
                            return FirebaseAuthService.getUserToken();

                        case 6:
                            tokenId = _context.sent;
                            _context.next = 9;
                            return TwoFactorAuthService.setupTwoFactorAuthentication(tokenId);

                        case 9:
                            res = _context.sent;

                            $scope.processing = false;
                            $scope.errorMessage = '';
                            $rootScope.twoFARequired = true;
                            $rootScope.show_loading = true;
                            $scope.$apply();
                            $scope.$applyAsync();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();
                            window.location = res && res.data && res.data.result;

                            _context.next = 24;
                            break;

                        case 21:
                            _context.prev = 21;
                            _context.t0 = _context['catch'](0);

                            $scope.checkErrStatus(_context.t0);

                        case 24:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 21]]);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    // Invoked if user does not have Authy installed and asks for OTP to be sent to them
    $scope.requestOneTimePin = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($event) {
            var tokenId;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;

                            $event.preventDefault();
                            $scope.processing = true;
                            $scope.errorMessage = '';

                            _context2.next = 6;
                            return FirebaseAuthService.getUserToken();

                        case 6:
                            tokenId = _context2.sent;
                            _context2.next = 9;
                            return TwoFactorAuthService.requestOneTimePin(tokenId, $scope.visitorId);

                        case 9:
                            $scope.sentOTP = true;
                            $scope.processing = false;

                            _context2.next = 16;
                            break;

                        case 13:
                            _context2.prev = 13;
                            _context2.t0 = _context2['catch'](0);

                            $scope.checkErrStatus(_context2.t0);

                        case 16:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 13]]);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    $scope.confirmOTP = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(otp) {
            var visitorId, fp, idToken, twoFAToken;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;


                            $scope.processing = true;
                            $scope.errorMessage = '';

                            // Retrieve the visitor Id
                            visitorId = getCookie("ics-visitor-id");

                            if (visitorId) {
                                _context3.next = 13;
                                break;
                            }

                            _context3.next = 7;
                            return fpPromise;

                        case 7:
                            fp = _context3.sent;
                            _context3.next = 10;
                            return fp.get();

                        case 10:
                            result = _context3.sent;

                            visitorId = result.visitorId;
                            setCookie("ics-visitor-id", result.visitorId, 999);

                        case 13:
                            _context3.next = 15;
                            return firebase.auth().currentUser.getToken( /* forceRefresh */true);

                        case 15:
                            idToken = _context3.sent;
                            _context3.next = 18;
                            return TwoFactorAuthService.verifyOneTimePin(idToken, otp, visitorId);

                        case 18:
                            twoFAToken = _context3.sent;


                            setCookie("ics-2fa-auth-token", twoFAToken, 999);
                            $rootScope.twoFARequired = true;
                            $scope.processing = false;
                            $scope.awaitingOTP = false;
                            $scope.errorMessage = 'Thank you, 2FA has been setup on your account.';
                            $scope.$apply();
                            $rootScope.$apply();

                            _context3.next = 31;
                            break;

                        case 28:
                            _context3.prev = 28;
                            _context3.t0 = _context3['catch'](0);

                            $scope.checkErrStatus(_context3.t0);

                        case 31:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 28]]);
        }));

        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();

    $scope.cancelTwoFactorAuthentication = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4($event) {
            var tokenId, twoFaReq;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;


                            $event.preventDefault();
                            $scope.errorMessage = '';
                            $scope.processing = true;

                            _context4.next = 6;
                            return FirebaseAuthService.getUserToken();

                        case 6:
                            tokenId = _context4.sent;
                            _context4.next = 9;
                            return TwoFactorAuthService.cancelTwoFactorAuthentication(tokenId);

                        case 9:
                            $scope.processing = false;
                            $scope.errorMessage = '';
                            $scope.awaitingOTP = false;
                            $scope.sentOTP = false;
                            $scope.validatedSuccess = false;
                            $rootScope.twoFARequired = false;
                            twoFaReq = { 'two_fa_required': false };

                            FirebaseAuthService.saveTwoFaRequired(twoFaReq);
                            $scope.errorMessage = 'Thank you, two factor authentication has been cancelled on your account.';
                            $scope.$apply();
                            $scope.$applyAsync();
                            $rootScope.$apply();
                            $rootScope.$applyAsync();

                            _context4.next = 27;
                            break;

                        case 24:
                            _context4.prev = 24;
                            _context4.t0 = _context4['catch'](0);

                            $scope.checkErrStatus(_context4.t0);

                        case 27:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 24]]);
        }));

        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
});
'use strict';

angular.module('ics').factory('TwoFactorAuthService', function ($http, $state, $rootScope) {

    return {

        requestOneTimePin: function requestOneTimePin(firebaseTokenId) {
            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'GET',
                    url: '/api/two_factor_auth/send_otp',
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    resolve(res);
                }, function (err) {
                    reject(err);
                });
            });
        },

        verifyOneTimePin: function verifyOneTimePin(firebaseTokenId, otp, visitorId) {
            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'GET',
                    url: '/api/two_factor_auth/verify/' + otp + '/' + visitorId,
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    if (res && res.data && res.data.result) {
                        resolve(res.data.result);
                    }
                    reject("One time pin could not be validated");
                }, function (err) {
                    reject(err);
                });
            });
        },

        setupTwoFactorAuthentication: function setupTwoFactorAuthentication(firebaseTokenId) {
            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'GET',
                    url: '/api/two_factor_auth/setup',
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    console.log(res);
                    resolve(res);
                }, function (err) {
                    reject(err);
                });
            });
        },

        cancelTwoFactorAuthentication: function cancelTwoFactorAuthentication(firebaseTokenId) {
            return new Promise(function (resolve, reject) {

                var req = {
                    method: 'GET',
                    url: '/api/two_factor_auth/cancel',
                    headers: {
                        'x-firebase-token': firebaseTokenId,
                        'Content-Type': 'application/json'
                    },
                    timeout: 8000
                };
                $http(req).then(function (res) {
                    console.log(res);
                    resolve(res);
                }, function (err) {
                    reject(err);
                });
            });
        }

    };
});
'use strict';

angular.module('ics').directive('fileUpload', [function () {
    return {
        link: function link(scope, element, attrs) {
            // Modified from https://developer.mozilla.org/en-US/docs/Web/API/FileReader
            var fileReader = new FileReader();

            scope.file = {};

            fileReader.onload = function (fileReaderEvent) {
                scope.$apply(function () {
                    scope.file.data = fileReaderEvent.target.result;
                });
            };

            var load_file = function load_file(fileInput) {
                if (fileInput.files.length === 0) {
                    return;
                }

                var file = fileInput.files[0];
                scope.file = file;
                fileReader.readAsDataURL(file);
                scope.$apply();
            };

            element[0].onchange = function () {
                load_file(element[0]);
            };
        },
        restrict: 'A'
    };
}]);
'use strict';

angular.module('ics').factory('FirebaseStorageService', function ($http) {

    var storageRef = firebase.storage().ref(); //for firebase storage upload

    return {

        uploadFileToCloudStorage: function uploadFileToCloudStorage(location, file, listener) {

            /**RECEIVES A FILE FROM FILE INPUT AND SAVES TO FIREBASE STORAGE. RETURNS PROMISE CONTAINING FILE IMAGE URL**/
            console.log(file);

            return new Promise(function (resolve, reject) {

                var uploadTask = storageRef.child('' + location + file.name).put(file);

                // Listen for state changes, errors, and completion of the upload.
                uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                function (snapshot) {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                    console.log('Upload is ' + progress + '% done');
                    if (!!listener) listener(progress);
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED:
                            // or 'paused'
                            console.log('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING:
                            // or 'running'
                            console.log('Upload is running');
                            break;
                    }
                }, function (error) {
                    switch (error.code) {
                        case 'storage/unauthorized':
                            console.log('User doesn\'t have permission to access the object');
                            reject('User doesn\'t have permission to access the object');
                            break;

                        case 'storage/canceled':
                            console.log('User canceled the upload');
                            reject('User canceled the upload');
                            break;
                        case 'storage/unknown':
                            console.log('Unknown error occurred, inspect error.serverResponse');
                            reject('Unknown error occurred, inspect error.serverResponse');
                            break;
                    }
                }, function () {
                    // Upload completed successfully, now we can get the download URL
                    var downloadURL = uploadTask.snapshot.downloadURL;
                    resolve({
                        gsPath: uploadTask.toString(),
                        downloadUrl: downloadURL
                    });
                });
            });
        }

    };
});
'use strict';

angular.module('ics').factory('responseObserver', function responseObserver($q, $location) {
    return {
        'responseError': function responseError(errorResponse) {
            switch (errorResponse.status) {
                case 403:
                    $location.url('/');
                    break;
                case 500:
                    //$location.url('/');
                    break;
                case 404:
                    $location.url('/');
                    break;
            }
            return $q.reject(errorResponse);
        }
    };
});
'use strict';

angular.module('ics').controller('HomeController', function ($state, $scope, $rootScope, $controller) {

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    if ($rootScope.loggedInUserRole && $rootScope.loggedInUserRole.userRole !== null) {
        $state.transitionTo('admin-dashboard');
    } else {
        $state.transitionTo('signin');
    }
});
'use strict';

angular.module('ics').controller('NavController', function ($scope, $rootScope, $controller, $state, $timeout, FirebaseAuthService) {

    $scope.firebaseAuthService = FirebaseAuthService;
    $scope.state = $state;
    /*$rootScope.isSuperAdmin = false;
    $rootScope.isAdmin = false;
    $rootScope.isFSP = false;*/

    /*if ($rootScope.isAuthenticated == undefined) {
        $rootScope.isAuthenticated = false;
    }*/

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    console.log($rootScope.isAuthenticated);

    $scope.$on('user-role-loaded', function (event, args) {
        $rootScope.loggedInUserRole = FirebaseAuthService.getLoggedInUserRole();

        if ($rootScope.loggedInUserRole && $rootScope.loggedInUserRole.userRole !== null) {

            $rootScope.isAuthenticated = true;
            if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_SUPER_ADMIN.toUpperCase()) {
                $rootScope.isSuperAdmin = true;
            } else if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_ADMIN.toUpperCase()) {
                $rootScope.isAdmin = true;
            } else if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_FSP.toUpperCase()) {
                $rootScope.isFSP = true;
            }
        } else {
            $rootScope.isAuthenticated = false;
        }
        console.log($rootScope.isAuthenticated);
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        $rootScope.processing = true;
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {

        if ($rootScope.loggedInUserRole == undefined) {
            $rootScope.loggedInUserRole = FirebaseAuthService.getLoggedInUserRole();

            if ($rootScope.loggedInUserRole && $scope.loggedInUserRole.userRole !== null) {

                $rootScope.isAuthenticated = true;
                $rootScope.twoFARequired = FirebaseAuthService.getTwoFaRequired();
                if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_SUPER_ADMIN.toUpperCase()) {
                    $rootScope.isSuperAdmin = true;
                } else if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_ADMIN.toUpperCase()) {
                    $rootScope.isAdmin = true;
                } else if ($rootScope.loggedInUserRole.userRole.entity_role.toUpperCase() === ROLE_FSP.toUpperCase()) {
                    $rootScope.isFSP = true;
                }
            } else {
                $rootScope.isAuthenticated = false;
            }
        }

        $timeout(function () {

            $rootScope.previousState = fromState.name;
            $rootScope.currentState = toState.name;

            //console.log('Previous state:'+$rootScope.previousState);
            //console.log('Current state:'+$rootScope.currentState);

            console.log($rootScope.isAuthenticated);

            if ($rootScope.currentState == 'signin' && $rootScope.isAuthenticated) {
                $state.transitionTo('admin-dashboard');
            } else if ($rootScope.currentState == 'signin' || $rootScope.currentState == 'forgot-password' || $rootScope.currentState == 'admin-registration') {
                $rootScope.isAuthenticated = false;
            } else if ($rootScope.currentState == 'admin-dashboard' && !$rootScope.isAuthenticated) {
                $state.transitionTo('signin');
            }

            //Apply bg-grey background to main container
            $(document).ready(function () {
                if ($('main .bg-grey-1').length > 0) {
                    $('body').addClass('bg-grey-1');
                } else {
                    $('body').removeClass('bg-grey-1');
                }
            });

            $rootScope.processing = false;
        }, 1000);
    });
});
'use strict';

angular.module('ics').controller('CalendarController', function ($scope, $controller, CalendarService, FirebaseAuthService) {

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.calendarView = 'month';
    $scope.viewDate = new Date();
    $scope.calendarTitle = 'Reminder Calendar';
    $scope.editing = false;
    $scope.hour = 0;
    $scope.minute = 0;
    $scope.reminderId = null;

    $scope.hour = $scope.padNumber(new Date().getHours());
    $scope.minute = '00';

    $scope.hours = Array.from({ length: 24 }, function (v, i) {
        return $scope.padNumber(i);
    });
    $scope.minutes = ['00', '15', '30', '45'];

    var $dateInput = $('#reminder_date').pickadate({
        selectMonths: true,
        selectYears: 100,
        format: "yyyy-mm-dd",
        onSet: function onSet(context) {
            $scope.viewDate = new Date(context.select);
        }
    });
    var datePicker = $dateInput.pickadate('picker');

    function init() {

        datePicker.set('select', $scope.viewDate);
        FirebaseAuthService.getUserToken().then(function (tokenId) {

            // retrieve the last date stored in local storage
            if (typeof Storage !== "undefined") {
                var lastRetrievedDate = localStorage.getItem("ics-reminder-last-date");
                if (lastRetrievedDate) {
                    $scope.viewDate = new Date(lastRetrievedDate);
                    localStorage.removeItem("ics-reminder-last-date");
                }
            }

            $scope.token = tokenId;
            retrieveReminders();
            $('select').material_select();
        });
    }

    init();

    function retrieveReminders() {

        CalendarService.getReminders($scope.token).then(function (reminders) {

            $scope.reminders = reminders.data.reminders;
            $scope.reminders.forEach(function (reminder) {

                reminder.actions = [{
                    label: "<i style='font-size:16px;color:#FFFFFF;' class='material-icons'>mode_edit</i>",
                    onClick: function onClick(args) {
                        editReminder(args.calendarEvent);
                    }
                }, {
                    label: "<i style='font-size:16px;color:#FFFFFF;' class='material-icons'>delete</i>",
                    onClick: function onClick(args) {
                        deleteReminder(args.calendarEvent);
                    }
                }];

                reminder.startsAt = new Date(reminder.startsAt);
                reminder.startsAt = moment(reminder.startsAt).add(-reminder.startsAt.getTimezoneOffset(), 'm').toDate();

                if (moment(reminder.startsAt).valueOf() > moment().valueOf()) {

                    reminder.color = {
                        primary: '#D02C33',
                        secondary: '#e27a7e'
                    };
                } else {

                    reminder.color = {
                        primary: '#979797',
                        secondary: '#bbbbbb'
                    };
                }
            });
            console.log($scope.reminders);
            $scope.$applyAsync();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    function editReminder(calendarEvent) {
        $scope.reminderId = calendarEvent.id;
        $scope.viewDate = calendarEvent.startsAt;

        $scope.reminderTitle = calendarEvent.title;
        $scope.reminderDescription = calendarEvent.description;
        $scope.hour = $scope.padNumber($scope.viewDate.getHours());
        $scope.minute = $scope.padNumber($scope.viewDate.getMinutes());
        $scope.editing = true;
    }

    function deleteReminder(calendarEvent) {

        $('#modalConfirmHeader').html('DELETING REMINDER');
        $('#modalConfirmText').html('Are you sure you want to delete this reminder?');

        var deleteCallback = function deleteCallback() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                CalendarService.deleteReminder(_this.id, tokenId, $scope.visitorId).then(function () {
                    if (typeof Storage !== 'undefined') {
                        localStorage.setItem("ics-reminder-last-date", $scope.viewDate.toString());
                    }
                    location.reload();
                });
            });
        };
        $('#modalAgreeLink').click(function () {
            deleteCallback.bind({ id: calendarEvent.id })();
            $('#are_you_sure_modal').modal('close');
        });
        $('#are_you_sure_modal').modal('open');
    };

    $scope.eventClicked = function (calendarEvent) {
        console.log(calendarEvent);
    };

    $scope.timeSpanClicked = function (calendarDate) {
        console.log(calendarDate);
        $scope.viewDate = calendarDate;
        datePicker = $dateInput.pickadate('picker');
        datePicker.set('select', $scope.viewDate);
    };

    $scope.viewDateMonthTitle = function () {
        return moment($scope.viewDate).format('MMM YYYY');
    };

    $scope.viewDateTitle = function () {
        return moment($scope.viewDate).format('DD MMM YYYY');
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveReminder();
        }
    };

    $scope.saveReminder = function () {

        $scope.viewDate.setHours(0, 0, 0, 0);
        $scope.viewDate.setHours(parseInt($scope.hour));
        $scope.viewDate.setMinutes(parseInt($scope.minute));

        console.log($scope.viewDate);

        var currentTime = new Date();

        if ($scope.viewDate.getTime() < currentTime.getTime()) {
            $('#modalInfoHeader').html('Error');
            $('#modalInfoText').html('Reminder dates cannot be in the past');
            $('#information_modal').modal('open');
            return;
        }
        if ($scope.reminderDescription && $scope.reminderDescription.trim().length === 0 && $scope.reminderTitle.trim().length === 0) {
            $('#modalInfoHeader').html('Error');
            $('#modalInfoText').html('Please provide a title or description');
            $('#information_modal').modal('open');
            return;
        }

        $scope.viewDate = moment($scope.viewDate).add($scope.viewDate.getTimezoneOffset(), 'm').toDate();

        if ($scope.reminderId) {

            CalendarService.updateReminder($scope.reminderId, moment($scope.viewDate).format('YYYY-MM-DD HH:mm'), $scope.reminderTitle, $scope.reminderDescription, $scope.token).then(function (res) {
                if (typeof Storage !== 'undefined') {
                    localStorage.setItem("ics-reminder-last-date", $scope.viewDate.toString());
                }
                location.reload();
            }).catch(function (err) {

                $('#modalInfoHeader').html('Error');
                $('#modalInfoText').html(err.message ? err.message : err);
                $('#information_modal').modal('open');
            });
        } else {

            CalendarService.createReminder(moment($scope.viewDate).format('YYYY-MM-DD HH:mm'), $scope.reminderTitle, $scope.reminderDescription, $scope.token).then(function (res) {
                if (typeof Storage !== 'undefined') {
                    localStorage.setItem("ics-reminder-last-date", $scope.viewDate.toString());
                }
                location.reload();
            }).catch(function (err) {

                $('#modalInfoHeader').html('Error');
                $('#modalInfoText').html(err.message ? err.message : err);
                $('#information_modal').modal('open');
            });
        }
    };
});
'use strict';

angular.module('ics').factory('CalendarService', function ($http) {

    var service = {

        getReminders: function getReminders(firebaseTokenId, visitorId) {
            var req = {
                method: 'GET',
                url: '/api/reminders_list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createReminder: function createReminder(reminderDate, reminderTitle, reminderDescription, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/reminder/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    reminder_date: reminderDate,
                    reminder_title: reminderTitle,
                    reminder_description: reminderDescription
                }
            };

            return $http(req);
        },

        updateReminder: function updateReminder(reminderId, reminderDate, reminderTitle, reminderDescription, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/reminder/' + reminderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    reminder_date: reminderDate,
                    reminder_title: reminderTitle,
                    reminder_description: reminderDescription
                }
            };

            return $http(req);
        },

        deleteReminder: function deleteReminder(reminderId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/reminder/' + reminderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };

    return service;
});
'use strict';

angular.module('ics').controller('CategoriesAdminController', function ($scope, $state, $controller, CategoriesService, FirebaseAuthService) {

    $scope.categoryType = '';
    $scope.categoryId = '';
    $scope.index = -1;
    $scope.code = '';
    $scope.editing = false;
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.init = function () {

        $scope.processing = true;
        $scope.categoryTypeId = $state.params.category_type_id;
        $scope.categoryTypeName = $state.params.category_type_name;
        getCategoriesList();
    };

    $scope.saveCategory = function (name, code, display_order) {

        $scope.errorMessage = '';
        $scope.processing = true;

        if (isNaN(display_order) || !isFinite(display_order)) {
            display_order = 1;
        }
        if ($scope.categoryId === '') {

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return CategoriesService.createCategory($scope.categoryTypeId, name, code, display_order, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return CategoriesService.editCategory($scope.categoryId, name, code, display_order, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteCategory = function (categoryId, index) {

        $('#modalConfirmHeader').html('Deleting Category');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return CategoriesService.deleteCategory(_this.categoryId, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ categoryId: categoryId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editCategory = function (categoryId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.categoryId = categoryId;
        $scope.index = index;
        $scope.categoryName = $scope.categoriesList[index].name;
        $scope.categoryCode = $scope.categoriesList[index].code || "";
        $scope.categoryOrder = $scope.categoriesList[index].display_order || 1;
        $scope.editing = true;
    };

    $scope.addCategory = function () {
        $('body').removeClass('bg-grey-1');
        $scope.categoryId = '';
        $scope.categoryName = '';
        $scope.categoryCode = '';
        $scope.categoryOrder = 1;
        $scope.editing = true;
        $scope.errorMessage = '';
        $scope.index = -1;
    };

    $scope.cancelSaveCategory = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function getCategoriesList() {

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            return CategoriesService.getCategoriesList($scope.categoryTypeId, tokenId, $scope.visitorId);
        }).then(function (response) {
            $scope.categoriesList = response.data.categories;
            $scope.categoriesList.sort(function (a, b) {
                return a.display_order - b.display_order;
            });
            $scope.$applyAsync();
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.addEditSubCategories = function (categoryId, categoryName) {

        $state.transitionTo('admin-sub-categories', {
            category_id: categoryId,
            category_name: categoryName,
            category_type_id: $scope.categoryTypeId,
            category_type_name: $scope.categoryTypeName
        });
    };

    function reset() {
        $scope.processing = false;
        $scope.errorMessage = '';
        $scope.categoryId = '';
        $scope.categoryName = '';
        $scope.categoryCode = '';
        $scope.categoryOrder = 1;
        $scope.index = -1;
        $scope.editing = false;
    }

    $scope.init();
});
'use strict';

angular.module('ics').controller('CategoryTypesAdminController', function ($scope, $state, $controller, $timeout, CategoryTypesService, FirebaseAuthService) {

    $scope.item = {
        categoryTypeId: '',
        categoryType: '',
        code: ''
    };

    $scope.editing = false;
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.init = function () {

        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            return CategoryTypesService.getCategoryTypesList(tokenId, $scope.visitorId);
        }).then(function (response) {
            $scope.categoryTypesList = response.data.category_types;
            $scope.$applyAsync();
            $scope.categoryTypesList.sort(function (a, b) {
                var textA = a.category_type.toUpperCase();
                var textB = b.category_type.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveCategoryType($scope.item.categoryType, $scope.item.code);
        }
    };

    $scope.saveCategoryType = function (categoryType, code) {

        $scope.errorMessage = '';
        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            if ($scope.item.categoryTypeId === '') {
                CategoryTypesService.createCategoryType(categoryType, code, tokenId, $scope.visitorId).then(location.reload()).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {
                CategoryTypesService.editCategoryType($scope.item.categoryTypeId, categoryType, code, tokenId, $scope.visitorId).then(location.reload()).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.addEditCategories = function (categoryTypeId, categoryTypeName) {

        $state.transitionTo('admin-categories', {
            category_type_id: categoryTypeId,
            category_type_name: categoryTypeName
        });
    };

    $scope.deleteCategoryType = function (categoryTypeId, index) {

        $('#modalConfirmHeader').html('Deleting Listing');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return CategoryTypesService.deleteCategoryType(_this.categoryTypeId, tokenId, $scope.visitorId);
            }).then(location.reload()).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ categoryTypeId: categoryTypeId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editCategoryType = function (categoryTypeId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item.categoryTypeId = categoryTypeId;
        $scope.item.categoryType = $scope.categoryTypesList[index].category_type;
        $scope.item.code = $scope.categoryTypesList[index].code;
        $scope.editing = true;
    };

    $scope.addCategoryType = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.categoryTypeId = '';
        $scope.item.categoryType = '';
        $scope.item.code = '';
        $scope.editing = true;
        $scope.errorMessage = '';
    };

    $scope.cancelSaveCategoryType = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.item.categoryTypeId = '';
        $scope.item.categoryType = '';
        $scope.item.code = '';
        $scope.editing = false;
        $scope.errorMessage = '';
    }

    $scope.init();
});
'use strict';

angular.module('ics').controller('SubCategoriesAdminController', function ($scope, $state, $controller, SubCategoriesService, FirebaseAuthService) {

    $scope.categoryId = '';
    $scope.categoryName = '';
    $scope.subCategoryName = '';
    $scope.subCategoryId = '';
    $scope.index = -1;
    $scope.code = '';
    $scope.editing = false;
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.init = function () {

        $scope.processing = true;
        $scope.categoryId = $state.params.category_id;
        $scope.categoryName = $state.params.category_name;
        $scope.categoryTypeId = $state.params.category_type_id;
        $scope.categoryTypeName = $state.params.category_type_name;
        getSubCategoriesList();
    };

    $scope.saveSubCategory = function (name, code, display_order) {

        $scope.errorMessage = '';
        $scope.processing = true;

        if (isNaN(display_order) || !isFinite(display_order)) {
            display_order = 1;
        }
        if ($scope.subCategoryId === '') {

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return SubCategoriesService.createSubCategory($scope.categoryId, name, code, display_order, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return SubCategoriesService.editSubCategory($scope.subCategoryId, name, code, display_order, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteSubCategory = function (subCategoryId, index) {

        $('#modalConfirmHeader').html('Deleting Sub Category');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return SubCategoriesService.deleteSubCategory(_this.subCategoryId, tokenId, $scope.visitorId);
            }).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ subCategoryId: subCategoryId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editSubCategory = function (subCategoryId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.subCategoryId = subCategoryId;
        $scope.index = index;
        $scope.subCategoryName = $scope.subCategoriesList[index].name;
        $scope.subCategoryCode = $scope.subCategoriesList[index].code || "";
        $scope.subCategoryOrder = $scope.subCategoriesList[index].display_order || 1;
        $scope.editing = true;
    };

    $scope.addSubCategory = function () {
        $('body').removeClass('bg-grey-1');
        $scope.subCategoryId = '';
        $scope.subCategoryName = '';
        $scope.subCategoryCode = '';
        $scope.subCategoryOrder = 1;
        $scope.editing = true;
        $scope.errorMessage = '';
        $scope.index = -1;
    };

    $scope.cancelSaveSubCategory = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function getSubCategoriesList() {

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            return SubCategoriesService.getSubCategoriesList($scope.categoryId, tokenId, $scope.visitorId);
        }).then(function (response) {
            $scope.subCategoriesList = response.data.sub_categories;
            $scope.subCategoriesList.sort(function (a, b) {
                return a.display_order - b.display_order;
            });
            $scope.$applyAsync();
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    function reset() {
        $scope.processing = false;
        $scope.errorMessage = '';
        $scope.subCategoryId = '';
        $scope.subCategoryName = '';
        $scope.subCategoryCode = '';
        $scope.subCategoryOrder = 1;
        $scope.index = -1;
        $scope.editing = false;
    }

    $scope.init();
});
'use strict';

angular.module('ics').factory('CategoriesService', function ($http) {

    return {

        getCategoriesList: function getCategoriesList(categoryTypeId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/category/list/' + categoryTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getCategoriesListFromCode: function getCategoriesListFromCode(categoryTypeCode, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/category/list_from_code/' + categoryTypeCode,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createCategory: function createCategory(categoryTypeId, name, code, display_order, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/category/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'category_type_id': categoryTypeId,
                    'name': name,
                    'code': code,
                    'display_order': display_order
                }
            };

            return $http(req);
        },

        editCategory: function editCategory(categoryId, name, code, display_order, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/category/' + categoryId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'name': name,
                    'code': code,
                    'display_order': display_order
                }
            };

            return $http(req);
        },

        deleteCategory: function deleteCategory(categoryId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/category/' + categoryId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').factory('CategoryTypesService', function ($http) {

    return {

        getCategoryTypesList: function getCategoryTypesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/category_type/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createCategoryType: function createCategoryType(categoryType, code, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/category_type/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'category_type': categoryType,
                    'code': code
                }
            };

            return $http(req);
        },

        editCategoryType: function editCategoryType(categoryTypeId, categoryType, code, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/category_type/' + categoryTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'category_type': categoryType,
                    'code': code
                }
            };

            return $http(req);
        },

        deleteCategoryType: function deleteCategoryType(categoryTypeId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/category_type/' + categoryTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').factory('SubCategoriesService', function ($http) {

    return {

        getSubCategoriesList: function getSubCategoriesList(categoryId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/sub_category/list/' + categoryId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getSubCategoriesListFromCode: function getSubCategoriesListFromCode(categoryCode, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/sub_category/list_from_code/' + categoryCode,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createSubCategory: function createSubCategory(categoryId, name, code, display_order, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/sub_category/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'category_id': categoryId,
                    'name': name,
                    'code': code,
                    'display_order': display_order
                }
            };

            return $http(req);
        },

        editSubCategory: function editSubCategory(subCategoryId, name, code, display_order, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/sub_category/' + subCategoryId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'name': name,
                    'code': code,
                    'display_order': display_order
                }
            };

            return $http(req);
        },

        deleteSubCategory: function deleteSubCategory(subCategoryId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/sub_category/' + subCategoryId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').controller('ComplianceDocTemplatesAdminController', function ($scope, $state, $controller, $timeout, ComplianceDocumentsService, CategoriesService, FirebaseAuthService, FirebaseStorageService) {

    $scope.index = -1;

    $scope.item = {
        documentTemplateId: '',
        templateName: '',
        profileChangeTypes: [],
        profileChangeStatuses: [],
        firebaseStorageUri: ''
    };

    $scope.editing = false;
    $scope.tokenId = "";
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;
        $scope.documentTypeId = $state.params.document_type_id;
        $scope.documentTypeName = $state.params.document_type_name;

        retrieveDocumentTemplates($scope.documentTypeId).then(function (templates) {
            $scope.documentTemplatesList = templates;
            reset();
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('profile_change_type', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeTypeCategories = res.data.categories;

                $scope.profileChangeTypeCategories.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                $timeout(function () {
                    $('select').material_select();
                });
            }).then(function () {
                CategoriesService.getCategoriesListFromCode('profile_change_status', $scope.tokenId, $scope.visitorId).then(function (res) {
                    $scope.profileChangeStatusCategories = res.data.categories;

                    $scope.profileChangeStatusCategories.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    $scope.processing = false;

                    $timeout(function () {
                        $('select').material_select();
                    });
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveDocumentTemplate($scope.item.templateName, $scope.item.profileChangeTypes, $scope.item.profileChangeStatuses, $scope.item.firebaseStorageUri);
        }
    };

    $scope.saveDocumentTemplate = function (templateName, profileChangeTypes, profileChangeStatuses, firebaseStorageUri) {

        if (templateName.length === 0 || firebaseStorageUri.length === 0) {
            alert('Please upload a file first');
            return;
        }

        $('body').addClass('bg-grey-1');
        $scope.errorMessage = '';
        $scope.processing = true;

        if ($scope.item.documentTemplateId === '') {
            ComplianceDocumentsService.createDocumentTemplate($scope.documentTypeId, templateName, profileChangeTypes, profileChangeStatuses, firebaseStorageUri, $scope.tokenId, $scope.visitorId).then($scope.init).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            ComplianceDocumentsService.editDocumentTemplate($scope.item.documentTemplateId, templateName, profileChangeTypes, profileChangeStatuses, firebaseStorageUri, $scope.tokenId, $scope.visitorId).then($scope.init).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteDocumentTemplate = function (documentTemplateId, index) {

        $('#modalConfirmHeader').html('Deleting Document Template');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            ComplianceDocumentsService.deleteDocumentTemplate(this.documentTemplateId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ documentTemplateId: documentTemplateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    function uploadInit() {
        $timeout(function () {
            $('select').material_select();

            var docUploadControl = document.getElementById("documentUpload");

            docUploadControl.addEventListener('change', function (e) {
                $scope.processing = true;
                var file = e.target.files[0];
                if (!file || !file.name) return;
                console.log($('.file-field #uploading-document'));
                $('.file-field #uploading-document').removeClass('ng-hide');
                $('.file-field .btn').addClass('ng-hide');
                FirebaseStorageService.uploadFileToCloudStorage("/compliance_document_templates/", file, null).then(function (storageInfo) {
                    $scope.item.firebaseStorageUri = storageInfo.downloadUrl;
                    $scope.processing = false;
                    $('.file-field #uploading-document').addClass('ng-hide');
                    $('.file-field .btn').removeClass('ng-hide');
                    $scope.$apply();
                }, function (errMessage) {
                    $scope.processing = false;
                    $('.file-fieldf #uploading-document').addClass('ng-hide');
                    $('.file-field .btn').removeClass('ng-hide');
                    alert(errMessage);
                });
            });
        });
    }

    $scope.editDocumentTemplate = function (documentTemplateId, index) {
        $('body').removeClass('bg-grey-1');

        $scope.item.documentTemplateId = documentTemplateId;
        $scope.item.index = index;
        $scope.item.templateName = $scope.documentTemplatesList[index].template_name;
        $scope.item.profileChangeTypes = $scope.documentTemplatesList[index].profile_change_types.map(function (category) {
            return category.id;
        });
        $scope.item.profileChangeStatuses = $scope.documentTemplatesList[index].profile_change_statuses.map(function (category) {
            return category.id;
        });
        $scope.item.firebaseStorageUri = $scope.documentTemplatesList[index].firebase_storage_uri;

        $timeout(function () {
            $('select').material_select();
        });

        uploadInit();

        $scope.editing = true;
    };

    $scope.addDocumentTemplate = function () {
        $('body').removeClass('bg-grey-1');

        $scope.item.documentTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.profileChangeTypes = [];
        $scope.item.profileChangeStatuses = [];
        $scope.item.firebaseStorageUri = '';

        $scope.editing = true;
        $scope.errorMessage = '';
        $scope.index = -1;

        $timeout(function () {
            $('select').material_select();
        });

        uploadInit();
    };

    $scope.cancelSaveDocumentTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function retrieveDocumentTemplates(documentTypeId) {
        return new Promise(function (resolve, reject) {

            ComplianceDocumentsService.getDocumentTemplatesList(documentTypeId, $scope.tokenId, $scope.visitorId).then(function (response) {
                resolve(response.data.document_templates);
                reset();
            }).catch(function (err) {
                reject(err);
            });
        });
    }

    function reset() {

        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';
        $scope.index = -1;

        $scope.item.documentTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.profileChangeTypes = [];
        $scope.item.profileChangeStatuses = [];
        $scope.item.firebaseStorageUri = '';
    }
});
'use strict';

angular.module('ics').controller('ComplianceDocumentTypesAdminController', function ($scope, $state, $controller, ComplianceDocumentTypesService, FirebaseAuthService) {

    $scope.documentTypeId = '';
    $scope.documentType = '';
    $scope.code = '';
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.init = function () {

        $scope.processing = true;

        ComplianceDocumentTypesService.getComplianceDocumentTypesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.documentTypesList = response.data.document_types;
            $scope.documentTypesList.sort(function (a, b) {
                var textA = a.document_type.toUpperCase();
                var textB = b.document_type.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.saveDocumentType = function (documentType, code) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.documentTypeId === '') {
            ComplianceDocumentTypesService.createComplianceDocumentType(documentType, code, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            ComplianceDocumentTypesService.editComplianceDocumentType($scope.documentTypeId, documentType, code, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteDocumentType = function (documentTypeId, documentType, index) {

        $('#modalConfirmHeader').html('Deleting Document Type');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            ComplianceDocumentTypesService.deleteComplianceDocumentType(this.documentTypeId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ documentTypeId: documentTypeId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.addEditDocumentTemplates = function (documentTypeId, documentTypeName) {

        $state.transitionTo('admin-compliance-templates', { document_type_id: documentTypeId, document_type_name: documentTypeName });
    };

    $scope.editDocumentType = function (documentTypeId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.documentTypeId = documentTypeId;
        $scope.documentType = $scope.documentTypesList[index].document_type;
        $scope.code = $scope.documentTypesList[index].code;
        $scope.editing = true;
    };

    $scope.addDocumentType = function () {
        $('body').removeClass('bg-grey-1');
        $scope.documentTypeId = '';
        $scope.documentType = '';
        $scope.code = '';
        $scope.editing = true;
        $scope.errorMessage = '';
    };

    $scope.cancelSaveDocumentType = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.documentTypeId = '';
        $scope.documentType = '';
        $scope.code = '';
        $scope.editing = false;
        $scope.errorMessage = '';
    }
});
'use strict';

angular.module('ics').factory('ComplianceDocumentsService', function ($http) {

    return {

        getDocumentTemplatesList: function getDocumentTemplatesList(complianceDocumentTypeId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/compliance_document_template/list/' + complianceDocumentTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getFullDocumentTemplatesList: function getFullDocumentTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/compliance_document_template/full_list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createDocumentTemplate: function createDocumentTemplate(documentTypeId, templateName, profileChangeTypes, profileChangeStatuses, firebaseStorageUri, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/compliance_document_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'document_type': documentTypeId,
                    'template_name': templateName,
                    'profile_change_types': profileChangeTypes,
                    'profile_change_statuses': profileChangeStatuses,
                    'firebase_storage_uri': firebaseStorageUri
                }
            };

            return $http(req);
        },

        editDocumentTemplate: function editDocumentTemplate(documentTemplateId, templateName, profileChangeTypes, profileChangeStatuses, firebaseStorageUri, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/compliance_document_template/' + documentTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'profile_change_types': profileChangeTypes,
                    'profile_change_statuses': profileChangeStatuses,
                    'firebase_storage_uri': firebaseStorageUri
                }
            };

            return $http(req);
        },

        deleteDocumentTemplate: function deleteDocumentTemplate(complianceDocumentTemplateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/compliance_document_template/' + complianceDocumentTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').factory('ComplianceDocumentTypesService', function ($http) {

    return {

        getComplianceDocumentTypesList: function getComplianceDocumentTypesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/compliance_document_type/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createComplianceDocumentType: function createComplianceDocumentType(documentType, code, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/compliance_document_type/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'document_type': documentType,
                    'code': code
                }
            };

            return $http(req);
        },

        editComplianceDocumentType: function editComplianceDocumentType(documentTypeId, documentType, code, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/compliance_document_type/' + documentTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'document_type': documentType,
                    'code': code
                }
            };

            return $http(req);
        },

        deleteComplianceDocumentType: function deleteComplianceDocumentType(documentTypeId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/compliance_document_type/' + documentTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').controller('EmailTemplatesAdminController', function ($scope, $state, $controller, $timeout, EmailTemplatesService, CategoriesService, FirebaseAuthService) {
    $scope.item = {
        emailTemplateId: '',
        templateName: '',
        emailSubject: '',
        emailBody: '',
        profileChangeTypes: []
    };

    $scope.editing = false;
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;

        EmailTemplatesService.getEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.emailTemplatesList = response.data.email_templates;
            $scope.emailTemplatesList.sort(function (a, b) {
                var textA = a.template_name.toUpperCase();
                var textB = b.template_name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            reset();
        }).then(function () {
            CategoriesService.getCategoriesListFromCode('profile_change_type', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeTypeCategories = res.data.categories;
                $scope.profileChangeTypeCategories.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                $timeout(function () {
                    $('select').material_select();
                    $('textarea').trigger('autoresize');
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveEmailTemplate($scope.item.templateName, $scope.item.emailSubject, $scope.item.emailBody, $scope.item.profileChangeTypes);
        }
    };

    $scope.saveEmailTemplate = function (templateName, emailSubject, emailBody, profileChangeTypes) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.emailTemplateId === '') {
            EmailTemplatesService.createEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            EmailTemplatesService.editEmailTemplate($scope.item.emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteEmailTemplate = function (emailTemplateId, index) {

        $('#modalConfirmHeader').html('Deleting Email Template');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            EmailTemplatesService.deleteEmailTemplate(this.emailTemplateId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ emailTemplateId: emailTemplateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editEmailTemplate = function (emailTemplateId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = emailTemplateId;
        $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
        $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
        $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;
        $scope.item.profileChangeTypes = $scope.emailTemplatesList[index].profile_change_types.map(function (category) {
            return category.id;
        });

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        $scope.editing = true;
    };

    $scope.addEmailTemplate = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.profileChangeTypes = [];

        $scope.editing = true;
        $scope.errorMessage = '';

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });
    };

    $scope.cancelSaveEmailTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.profileChangeTypes = [];
    }
});
'use strict';

angular.module('ics').factory('EmailTemplatesService', function ($http) {

    return {

        getEmailTemplatesList: function getEmailTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createEmailTemplate: function createEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/email_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        editEmailTemplate: function editEmailTemplate(emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        deleteEmailTemplate: function deleteEmailTemplate(emailTemplateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').controller('FSPController', function ($scope, $state, $controller, $timeout, FSPService, FirebaseStorageService, FirebaseAuthService) {

    $scope.item = {
        fspId: '',
        fsp_number: localStorage.getItem('fsp_number') || '',
        financial_year_end: localStorage.getItem('financial_year_end') || '',
        cipc_registration_number: localStorage.getItem('cipc_registration_number') || '',
        name: localStorage.getItem('name') || '',
        logo: localStorage.getItem('logo') || '',
        website: localStorage.getItem('website') || '',
        date_authorized: new Date(),
        ai_number: localStorage.getItem('ai_number') || '',
        physical_address: localStorage.getItem('physical_address') || '',
        postal_address: localStorage.getItem('postal_address') || '',
        contact_person: localStorage.getItem('contact_person') || '',
        tel: localStorage.getItem('tel') || '',
        email: localStorage.getItem('email') || '',
        compliance_officer: localStorage.getItem('compliance_officer') || '',
        separate_account: false,
        separate_account_bank_name: localStorage.getItem('separate_account_bank_name') || '',
        bank_account_details: localStorage.getItem('bank_account_details') || ''
    };

    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = '';
    $scope.title = 'Add Financial Services Provider';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    function uploadInit() {
        setTimeout(function () {
            var docUploadControl = document.getElementById("imageUpload");

            docUploadControl.addEventListener('change', function (e) {
                var file = e.target.files[0];
                if (!file || !file.name) return;
                $('.file-field #uploading-image').removeClass('ng-hide');
                $('.file-field .btn').addClass('ng-hide');
                FirebaseStorageService.uploadFileToCloudStorage("/fsp_logos/", file, null).then(function (storageInfo) {
                    $('.file-field #uploading-image').addClass('ng-hide');
                    $('.file-field .btn').removeClass('ng-hide');
                    $scope.item.logo = storageInfo.downloadUrl;
                    $scope.$apply();
                }, function (errMessage) {
                    $('.file-field #uploading-image').addClass('ng-hide');
                    $('.file-field .btn').removeClass('ng-hide');
                    alert(errMessage);
                });
            });

            // let $dateInput = $('#date_authorized').pickadate({
            //     selectMonths: true, // Creates a dropdown to control month
            //     selectYears: 100, // Creates a dropdown of 100 years to control year
            //     format: "yyyy-mm-dd"
            // });
            //
            // let datePicker = $dateInput.pickadate('picker');
            // datePicker.set('select', $scope.item.date_authorized);
        });
    }

    $scope.init = function () {

        $scope.processing = true;

        FSPService.GetFSPAllList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.fspActiveList = response.data.fsps.filter(function (fsp) {
                return fsp.active;
            });
            $scope.fspArchivedList = response.data.fsps.filter(function (fsp) {
                return !fsp.active;
            });

            $scope.fspActiveList.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            $scope.fspArchivedList.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            reset();
        }, function (reject) {
            $scope.checkErrStatus(reject);
            $scope.errorMessage = reject.message;
        });
    };

    $scope.saveToLocalStorage = function (fieldName, modelName) {
        if (Number.isNaN(parseInt($scope.fspId))) {
            localStorage.setItem(modelName, $('#' + fieldName).val());
        }
    };

    $scope.viewFSPDetails = function (fspId) {
        $state.transitionTo('admin-fsp-details', { fsp_id: fspId });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveFSP($scope.item.name, $scope.item.logo, $scope.item.website, $scope.item.fsp_number, $scope.item.cipc_registration_number, $scope.item.financial_year_end, $scope.item.date_authorized, $scope.item.ai_number, $scope.item.physical_address, $scope.item.postal_address, $scope.item.contact_person, $scope.item.tel, $scope.item.email, $scope.item.compliance_officer, $scope.item.separate_account, $scope.item.separate_account_bank_name, $scope.item.bank_account_details, $scope.item.active);
        }
    };

    $scope.saveFSP = function (name, logo, website, fsp_number, cipc_registration_number, financial_year_end, date_authorized, ai_number, physical_address, postal_address, contact_person, tel, email, compliance_officer, separate_account, separate_account_bank_name, bank_account_details, active) {

        $scope.item.date_authorized = $('#date_authorized').val();

        $scope.errorMessage = '';
        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (token) {

            $scope.token = token;

            if ($scope.item.fspId === '') {
                FSPService.createFSP(name, logo, website, fsp_number, cipc_registration_number, financial_year_end, $scope.item.date_authorized, ai_number, physical_address, postal_address, contact_person, tel, email, separate_account, separate_account_bank_name, compliance_officer, bank_account_details, active, $scope.tokenId, $scope.visitorId).then(function () {
                    $('body').addClass('bg-grey-1');
                    emptyLocalStorage();
                    location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {
                FSPService.editFSP($scope.item.fspId, name, logo, website, fsp_number, cipc_registration_number, financial_year_end, $scope.item.date_authorized, ai_number, physical_address, postal_address, contact_person, tel, email, separate_account, separate_account_bank_name, compliance_officer, bank_account_details, active, $scope.tokenId, $scope.visitorId).then(function () {
                    $('body').addClass('bg-grey-1');
                    reset();
                    $scope.init();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.deleteFSP = function (fspId, index) {

        $('#modalConfirmHeader').html('Deleting Financial Service Provider');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            $scope.processing = true;

            FSPService.deleteFSP(this.fspId, $scope.tokenId, $scope.visitorId).then(function () {
                emptyLocalStorage();
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ fspId: fspId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editFSP = function (fspId, active, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item.fspId = fspId;
        emptyLocalStorage();

        var selectedFSP = (active ? $scope.fspActiveList : $scope.fspArchivedList).find(function (item) {
            return item.id == fspId;
        });

        $scope.item.fsp_number = selectedFSP.fsp_number;
        $scope.item.cipc_registration_number = selectedFSP.cipc_registration_number;
        $scope.item.financial_year_end = selectedFSP.financial_year_end;
        $scope.item.name = selectedFSP.name;
        $scope.item.logo = selectedFSP.logo;
        $scope.item.website = selectedFSP.website;
        $scope.item.date_authorized = new Date(selectedFSP.date_authorized);
        $scope.item.ai_number = selectedFSP.ai_number;
        $scope.item.physical_address = selectedFSP.physical_address;
        $scope.item.postal_address = selectedFSP.postal_address;
        $scope.item.contact_person = selectedFSP.contact_person;
        $scope.item.tel = selectedFSP.tel;
        $scope.item.email = selectedFSP.email;
        $scope.item.compliance_officer = selectedFSP.compliance_officer || '';
        $scope.item.separate_account = selectedFSP.separate_account;
        $scope.item.separate_account_bank_name = selectedFSP.separate_account_bank_name || '';
        $scope.item.bank_account_details = selectedFSP.bank_account_details || '';
        $scope.title = 'Edit Financial Services Provider';
        $scope.item.active = selectedFSP.active;

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        uploadInit();

        $scope.editing = true;
    };

    $scope.addFSP = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.fsp_number = localStorage.getItem('fsp_number') || '';
        $scope.item.financial_year_end = localStorage.getItem('financial_year_end') || '';
        $scope.item.cipc_registration_number = localStorage.getItem('cipc_registration_number') || '';
        $scope.item.name = localStorage.getItem('name') || '';
        $scope.item.logo = localStorage.getItem('logo') || '';
        $scope.item.website = localStorage.getItem('website') || '';
        $scope.item.date_authorized = new Date();
        $scope.item.ai_number = localStorage.getItem('ai_number') || '';
        $scope.item.physical_address = localStorage.getItem('physical_address') || '';
        $scope.item.postal_address = localStorage.getItem('postal_address') || '';
        $scope.item.contact_person = localStorage.getItem('contact_person') || '';
        $scope.item.tel = localStorage.getItem('tel') || '';
        $scope.item.email = localStorage.getItem('email') || '';
        $scope.item.compliance_officer = localStorage.getItem('compliance_officer') || '';
        $scope.item.fspId = '';
        $scope.item.separate_account = false;
        $scope.item.separate_account_bank_name = localStorage.getItem('separate_account_bank_name') || '', $scope.item.bank_account_details = localStorage.getItem('bank_account_details') || '';
        $scope.item.active = true;

        $scope.editing = true;
        $scope.errorMessage = '';
        $scope.title = 'Add Financial Services Provider';

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        uploadInit();
    };

    $scope.cancelSaveFSP = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset(emptyLocalStorage) {
        $scope.processing = false;

        $scope.item.fsp_number = '';
        $scope.item.financial_year_end = '';
        $scope.item.cipc_registration_number = '';
        $scope.item.fspId = '';
        $scope.item.name = '';
        $scope.item.logo = '';
        $scope.item.website = '';
        $scope.item.date_authorized = new Date();
        $scope.item.ai_number = '';
        $scope.item.physical_address = '';
        $scope.item.physical_address = '';
        $scope.item.contact_person = '';
        $scope.item.tel = '';
        $scope.item.email = '';
        $scope.item.compliance_officer = '';
        $scope.item.separate_account = false;
        $scope.item.separate_account_bank_name = '';
        $scope.item.bank_account_details = '';
        $scope.item.active = true;

        $scope.errorMessage = '';
        $scope.editing = false;
        $scope.errorMessage = '';
        $scope.title = 'Add Financial Services Provider';

        if (emptyLocalStorage) {
            emptyLocalStorage();
        }
    }

    function emptyLocalStorage() {
        localStorage.removeItem('fsp_number');
        localStorage.removeItem('financial_year_end');
        localStorage.removeItem('cipc_registration_number');
        localStorage.removeItem('name');
        localStorage.removeItem('logo');
        localStorage.removeItem('website');
        localStorage.removeItem('ai_number');
        localStorage.removeItem('physical_address');
        localStorage.removeItem('postal_address');
        localStorage.removeItem('contact_person');
        localStorage.removeItem('tel');
        localStorage.removeItem('email');
        localStorage.removeItem('compliance_officer');
        localStorage.removeItem('bank_account_details');
        localStorage.removeItem('separate_account_bank_name');
    }
});
'use strict';

angular.module('ics').factory('FSPService', function ($http) {

    return {

        GetFSPList: function GetFSPList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },
        GetFSPAllList: function GetFSPAllList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/list_all',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        GetFSPDetails: function GetFSPDetails(fsp_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/' + fsp_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        GetFSPChangeList: function GetFSPChangeList(fsp_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/status_changes_list/' + fsp_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        GetFSPFollowUpList: function GetFSPFollowUpList(fsp_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/follow_up_list/' + fsp_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        GetFSPChangeDetails: function GetFSPChangeDetails(fsp_change_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/status_change/' + fsp_change_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        createFSP: function createFSP(name, logo, website, fsp_number, cipc_registration_number, financial_year_end, date_authorized, ai_number, physical_address, postal_address, contact_person, tel, email, separate_account, separate_account_bank_name, compliance_officer, bank_account_details, active, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/fsp/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000,
                data: {
                    cipc_registration_number: cipc_registration_number,
                    financial_year_end: financial_year_end,
                    name: name,
                    logo: logo,
                    website: website,
                    fsp_number: fsp_number,
                    date_authorized: date_authorized,
                    ai_number: ai_number,
                    physical_address: physical_address,
                    postal_address: postal_address,
                    contact_person: contact_person,
                    tel: tel,
                    email: email,
                    compliance_officer: compliance_officer,
                    bank_account_details: bank_account_details,
                    separate_account: separate_account,
                    separate_account_bank_name: separate_account_bank_name,
                    active: active
                }
            };

            return $http(req);
        },

        createFSPProfileChange: function createFSPProfileChange(fsp_id, profile_change_type, profile_change_status, followed_up_date_yn, followed_up_date, implemented_yn, implemented_on, submitted_yn, submission_date, description, notes, email_send, email_subject, email_body, email_attachments, verify_email_send, followed_up_with_fsp_yn, followed_up_with_fsp_on, followed_up_with_fsca_yn, followed_up_with_fsca_on, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/fsp/status_change/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000,
                data: {
                    fsp_id: fsp_id,
                    type: profile_change_type,
                    status: profile_change_status,
                    follow_up_yn: followed_up_date_yn,
                    followed_up_date: followed_up_date,
                    implemented_yn: implemented_yn,
                    implemented_on: implemented_on,
                    submitted_yn: submitted_yn,
                    submission_date: submission_date,
                    description: description,
                    notes: notes.substring(0, 200),
                    email_send: email_send,
                    email_subject: email_subject,
                    email_body: email_body,
                    email_attachments: email_attachments,
                    verify_email_send: verify_email_send,
                    followed_up_with_fsp_yn: followed_up_with_fsp_yn,
                    followed_up_with_fsp_on: followed_up_with_fsp_on,
                    followed_up_with_fsca_yn: followed_up_with_fsca_yn,
                    followed_up_with_fsca_on: followed_up_with_fsca_on
                }
            };

            return $http(req);
        },

        editFSPProfileChange: function editFSPProfileChange(fsp_id, fsp_status_change_id, profile_change_status, followed_up_date_yn, followed_up_date, implemented_yn, implemented_on, submitted_yn, submission_date, description, notes, email_attachments, email_subject, email_body, send_email, followed_up_with_fsp_yn, followed_up_with_fsp_on, followed_up_with_fsca_yn, followed_up_with_fsca_on, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/fsp/status_change/' + fsp_status_change_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000,
                data: {
                    fsp_id: fsp_id,
                    status: profile_change_status,
                    follow_up_yn: followed_up_date_yn,
                    followed_up_date: followed_up_date,
                    implemented_yn: implemented_yn,
                    implemented_on: implemented_on,
                    submitted_yn: submitted_yn,
                    submission_date: submission_date,
                    description: description,
                    notes: notes.substring(0, 200),
                    email_attachments: email_attachments,
                    email_subject: email_subject,
                    email_body: email_body,
                    send_email: send_email,
                    is_follow_up: false,
                    followed_up_with_fsp_yn: followed_up_with_fsp_yn,
                    followed_up_with_fsp_on: followed_up_with_fsp_on,
                    followed_up_with_fsca_yn: followed_up_with_fsca_yn,
                    followed_up_with_fsca_on: followed_up_with_fsca_on
                }
            };

            return $http(req);
        },

        followUpFSPProfileChange: function followUpFSPProfileChange(fsp_id, fsp_status_change_id, profile_change_status, followed_up_date_yn, followed_up_date, description, email_attachments, email_subject, email_body, original_email_body, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/fsp/status_change/' + fsp_status_change_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000,
                data: {
                    fsp_id: fsp_id,
                    status: profile_change_status,
                    follow_up_yn: followed_up_date_yn,
                    followed_up_date: followed_up_date,
                    description: description,
                    email_attachments: email_attachments,
                    email_subject: email_subject,
                    email_body: email_body,
                    original_email_body: original_email_body,
                    is_follow_up: true
                }
            };

            return $http(req);
        },

        editFSP: function editFSP(id, name, logo, website, fsp_number, cipc_registration_number, financial_year_end, date_authorized, ai_number, physical_address, postal_address, contact_person, tel, email, separate_account, separate_account_bank_name, compliance_officer, bank_account_details, active, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/fsp/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000,
                data: {
                    name: name,
                    logo: logo,
                    website: website,
                    fsp_number: fsp_number,
                    cipc_registration_number: cipc_registration_number,
                    financial_year_end: financial_year_end,
                    date_authorized: date_authorized,
                    ai_number: ai_number,
                    physical_address: physical_address,
                    postal_address: postal_address,
                    contact_person: contact_person,
                    tel: tel,
                    email: email,
                    compliance_officer: compliance_officer,
                    bank_account_details: bank_account_details,
                    separate_account: separate_account,
                    separate_account_bank_name: separate_account_bank_name,
                    active: active
                }
            };

            return $http(req);
        },

        deleteFSP: function deleteFSP(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/fsp/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        deleteFSPProfileChange: function deleteFSPProfileChange(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/fsp/status_change/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FollowUpEmailTemplatesAdminController', function ($scope, $state, $controller, $timeout, FollowUpEmailTemplatesService, CategoriesService, FirebaseAuthService) {

    $scope.item = {

        emailTemplateId: '',
        templateName: '',
        emailSubject: '',
        emailBody: '',
        profileChangeTypes: []

    };

    $scope.editing = false;
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.init = function () {

        $scope.processing = true;

        FollowUpEmailTemplatesService.getFollowUpEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.emailTemplatesList = response.data.follow_up_email_templates;
            reset();
        }).then(function () {
            CategoriesService.getCategoriesListFromCode('profile_change_type', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeTypeCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                    $('textarea').trigger('autoresize');
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveFollowUpEmailTemplate($scope.item.templateName, $scope.item.emailSubject, $scope.item.emailBody, $scope.item.profileChangeTypes);
        }
    };

    $scope.saveFollowUpEmailTemplate = function (templateName, emailSubject, emailBody, profileChangeTypes) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.emailTemplateId === '') {
            FollowUpEmailTemplatesService.createFollowUpEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FollowUpEmailTemplatesService.editFollowUpEmailTemplate($scope.item.emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteFollowUpEmailTemplate = function (emailTemplateId, index) {

        $('#modalConfirmHeader').html('DELETING EMAIL TEMPLATE');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FollowUpEmailTemplatesService.deleteFollowUpEmailTemplate(this.emailTemplateId, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ emailTemplateId: emailTemplateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editFollowUpEmailTemplate = function (emailTemplateId, index) {

        $('body').removeClass('bg-grey-1');

        $scope.item.emailTemplateId = emailTemplateId;
        $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
        $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
        $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;
        $scope.item.profileChangeTypes = $scope.emailTemplatesList[index].profile_change_types.map(function (category) {
            return category.id;
        });

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        $scope.editing = true;
    };

    $scope.addFollowUpEmailTemplate = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.profileChangeTypes = [];

        $scope.editing = true;
        $scope.errorMessage = '';

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });
    };

    $scope.cancelSaveFollowUpEmailTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';

        $scope.item.emailTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.profileChangeTypes = [];
    }
});
'use strict';

angular.module('ics').factory('FollowUpEmailTemplatesService', function ($http) {

    return {

        getFollowUpEmailTemplatesList: function getFollowUpEmailTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/follow_up_email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createFollowUpEmailTemplate: function createFollowUpEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/follow_up_email_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        editFollowUpEmailTemplate: function editFollowUpEmailTemplate(emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/follow_up_email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        deleteFollowUpEmailTemplate: function deleteFollowUpEmailTemplate(emailTemplateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/follow_up_email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

angular.module('ics').controller('FCSASubmissionReminderEmailTemplatesAdminController', function ($scope, $state, $controller, $timeout, FCSASubmissionReminderEmailTemplatesService, CategoriesService, FirebaseAuthService) {

    $scope.item = {

        templateId: '',
        templateName: '',
        emailSubject: '',
        emailBody: ''

    };

    $scope.editing = false;
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.init = function () {

        $scope.processing = true;

        FCSASubmissionReminderEmailTemplatesService.getTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.emailTemplatesList = response.data.templates;
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveTemplate($scope.item.templateName, $scope.item.emailSubject, $scope.item.emailBody);
        }
    };

    $scope.saveTemplate = function (templateName, emailSubject, emailBody) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.templateId === '') {
            FCSASubmissionReminderEmailTemplatesService.createTemplate(templateName, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FCSASubmissionReminderEmailTemplatesService.editTemplate($scope.item.templateId, templateName, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteTemplate = function (templateId, index) {

        $('#modalConfirmHeader').html('DELETING EMAIL TEMPLATE');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FCSASubmissionReminderEmailTemplatesService.deleteTemplate(this.templateId, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ templateId: templateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editTemplate = function (templateId, index) {

        $('body').removeClass('bg-grey-1');

        $scope.item.templateId = templateId;
        $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
        $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
        $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;

        $timeout(function () {
            $('textarea').trigger('autoresize');
        });

        $scope.editing = true;
    };

    $scope.addTemplate = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.templateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';

        $scope.editing = true;
        $scope.errorMessage = '';

        $timeout(function () {
            $('textarea').trigger('autoresize');
        });
    };

    $scope.cancelSaveTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';

        $scope.item.templateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
    }
});
'use strict';

angular.module('ics').factory('FCSASubmissionReminderEmailTemplatesService', function ($http) {

    return {

        getTemplatesList: function getTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsca_submission_reminder_email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createTemplate: function createTemplate(templateName, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/fsca_submission_reminder_email_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject
                }
            };

            return $http(req);
        },

        editTemplate: function editTemplate(templateId, templateName, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/fsca_submission_reminder_email_template/' + templateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject
                }
            };

            return $http(req);
        },

        deleteTemplate: function deleteTemplate(templateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/fsca_submission_reminder_email_template/' + templateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('RecycleBinController', function ($scope, $state, $controller, $timeout, RecycleBinService, FirebaseAuthService) {
    var init = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return retrieveRecycleBin();

                        case 3:
                            _context.next = 8;
                            break;

                        case 5:
                            _context.prev = 5;
                            _context.t0 = _context['catch'](0);

                            $scope.checkErrStatus(_context.t0);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 5]]);
        }));

        return function init() {
            return _ref.apply(this, arguments);
        };
    }();

    var retrieveRecycleBin = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var res;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return FirebaseAuthService.getUserToken();

                        case 2:
                            $scope.tokenId = _context2.sent;

                            $scope.processing = true;

                            _context2.next = 6;
                            return RecycleBinService.getRecycleBin($scope.tokenId, $scope.visitorId, $scope.limit);

                        case 6:
                            res = _context2.sent;

                            $scope.recycleBin = res.data;
                            $scope.$applyAsync();
                            $scope.processing = false;

                            $(document).ready(function () {
                                $('.tabs').tabs();
                            });

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function retrieveRecycleBin() {
            return _ref2.apply(this, arguments);
        };
    }();

    $scope.recycleBin = [];
    $scope.tokenId = '';
    $scope.processing = true;
    $scope.limit = 10;
    var now = new Date();

    $scope.days = [];
    for (var i = 1; i <= 31; i++) {
        $scope.days.push(i);
    }$scope.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    $scope.years = [];
    for (var _i = now.getFullYear() - 20; _i <= now.getFullYear() + 5; _i++) {
        $scope.years.push(_i);
    }angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    init();

    $scope.putBack = function (entityType, entityId) {

        $('#modalConfirmHeader').html('PUTTING BACK');
        $('#modalConfirmText').html('Are you sure you want to remove this item from the recycle bin?');

        var fn = function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return FirebaseAuthService.getUserToken();

                            case 3:
                                $scope.tokenId = _context3.sent;
                                _context3.next = 6;
                                return RecycleBinService.putBack(entityType, entityId, $scope.tokenId, $scope.visitorId);

                            case 6:
                                _context3.next = 8;
                                return retrieveRecycleBin();

                            case 8:
                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](0);

                                $scope.checkErrStatus(_context3.t0);

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[0, 10]]);
            }));

            return function fn() {
                return _ref3.apply(this, arguments);
            };
        }();

        var event = fn.bind({ entityType: entityType, entityId: entityId });

        $('#modalAgreeLink').click(function () {
            event();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.getAllRecycleBin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        $scope.limit = 100;
                        _context4.next = 3;
                        return retrieveRecycleBin();

                    case 3:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));
});
'use strict';

angular.module('ics').factory('RecycleBinService', function ($http) {

    return {

        getRecycleBin: function getRecycleBin(firebaseTokenId, visitorId, entityType) {

            var req = {
                method: 'GET',
                // entity_type used as integer for data limit
                url: '/api/recycle_bin/' + entityType + '/0',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 60000
            };

            return $http(req);
        },

        putBack: function putBack(entityType, entityId, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/recycle_bin/' + entityType + '/' + entityId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 60000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FSBEmailTemplatesAdminController', function ($scope, $state, $controller, $timeout, FSBEmailTemplatesService, CategoriesService, FirebaseAuthService) {
    $scope.item = {

        emailTemplateId: '',
        templateName: '',
        emailSubject: '',
        emailBody: '',
        recipientList: '',
        profileChangeTypes: []

    };

    $scope.editing = false;
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.init = function () {
        $scope.processing = true;

        FSBEmailTemplatesService.getFSBEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.emailTemplatesList = response.data.fsb_email_templates;
            reset();
        }).then(function () {
            CategoriesService.getCategoriesListFromCode('profile_change_type', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeTypeCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveEmailTemplate($scope.item.templateName, $scope.item.emailSubject, $scope.item.emailBody, $scope.item.profileChangeTypes, $scope.item.recipientList);
        }
    };

    $scope.saveEmailTemplate = function (templateName, emailSubject, emailBody, profileChangeTypes, recipientList) {
        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.emailTemplateId === '') {
            FSBEmailTemplatesService.createFSBEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, recipientList, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSBEmailTemplatesService.editFSBEmailTemplate($scope.item.emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, recipientList, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteEmailTemplate = function (emailTemplateId, index) {
        $('#modalConfirmHeader').html('Deleting Email Template');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSBEmailTemplatesService.deleteFSBEmailTemplate(this.emailTemplateId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ emailTemplateId: emailTemplateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editEmailTemplate = function (emailTemplateId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = emailTemplateId;
        $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
        $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
        $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;
        $scope.item.recipientList = $scope.emailTemplatesList[index].recipient_list || '';
        $scope.item.profileChangeTypes = $scope.emailTemplatesList[index].profile_change_types.map(function (category) {
            return category.id;
        });

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        $scope.editing = true;
    };

    $scope.addEmailTemplate = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.recipientList = '';
        $scope.item.profileChangeTypes = [];

        $scope.editing = true;
        $scope.errorMessage = '';

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });
    };

    $scope.cancelSaveEmailTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';

        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
        $scope.item.recipientList = '';
        $scope.item.profileChangeTypes = [];
    }
});
'use strict';

angular.module('ics').factory('FSBEmailTemplatesService', function ($http) {

    return {

        getFSBEmailTemplatesList: function getFSBEmailTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsb_email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createFSBEmailTemplate: function createFSBEmailTemplate(templateName, profileChangeTypes, emailSubject, emailBody, recipientList, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/fsb_email_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'recipient_list': recipientList,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        editFSBEmailTemplate: function editFSBEmailTemplate(emailTemplateId, templateName, profileChangeTypes, emailSubject, emailBody, recipientList, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/fsb_email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'recipient_list': recipientList,
                    'profile_change_types': profileChangeTypes
                }
            };

            return $http(req);
        },

        deleteFSBEmailTemplate: function deleteFSBEmailTemplate(emailTemplateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                url: '/api/fsb_email_template/' + emailTemplateId,
                timeout: 8000
            };

            return $http(req);
        }
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('SubmitProfileChangeController', function ($scope, $state, $controller, $timeout, FSPService, FirebaseAuthService, FSBEmailTemplatesService, SubmitProfileChangeService, FirebaseStorageService) {

    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = true;

    $scope.profileChangeId = '';
    $scope.attachments = [];
    $scope.email_subject = '';
    $scope.email_body = '';
    $scope.email_template = null;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.processing = true;
        $scope.profileChangeId = $state.params.profile_change_id;
        $scope.fspId = $state.params.fsp_id;

        FSPService.GetFSPChangeDetails($scope.profileChangeId, $scope.tokenId, $scope.visitorId).then(function (response) {
            return $scope.fspChangeDetails = response.data.status_change;
        }).then(function () {

            FSBEmailTemplatesService.getFSBEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
                $scope.emailTemplates = response.data.fsb_email_templates;
                $scope.processing = false;

                $timeout(function () {
                    $('select').material_select();
                    $('textarea').trigger('autoresize');
                });

                $(document).ready(function () {

                    var docUploadControl = document.getElementById("documentUpload");

                    var fileDetails = {
                        folder: "/fsp_profile_change_attachments",
                        attachments: $scope.fspChangeDetails.attachments
                    };

                    var eventDelegator = $scope.fileUploader.bind(fileDetails);
                    docUploadControl.addEventListener('change', eventDelegator);

                    $scope.$on('filesUploaded', function (event, attachments) {
                        var combined = new Set($scope.fspChangeDetails.attachments.concat(attachments));
                        $scope.fspChangeDetails.attachments = [].concat(_toConsumableArray(combined));
                        $scope.$apply();
                    });
                });
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.selectEmailTemplate = function () {
        $scope.emailTemplates.forEach(function (template) {
            if (template.id === $scope.email_template) {
                $scope.email_subject = template.email_subject;
                $scope.email_body = template.email_body;
                $scope.recipient_list = template.recipient_list;
            }
        });
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        $state.transitionTo('admin-fsp-details', { profile_change_id: $scope.profileChangeId, fsp_id: $scope.fspId });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.submitProfileChange();
        }
    };

    $scope.submitProfileChange = function () {
        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            var attachments = [];
            $scope.fspChangeDetails.attachments.forEach(function (template) {
                if (!!template.attach_to_email) {
                    attachments.push(template);
                }
            });

            SubmitProfileChangeService.submitProfileChange($scope.profileChangeId, $scope.email_subject, $scope.email_body, $scope.recipient_list, attachments, tokenId, $scope.visitorId).then(function () {
                $('#modalInfoHeader').html('Thank you');
                $('#modalInfoText').html('The profile change has been submitted.');
                $('#information_modal').modal('open');
                setTimeout(function () {
                    $('#information_modal').modal('close');
                    $scope.goBack();
                }, 2000);
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };
});
'use strict';

angular.module('ics').factory('SubmitProfileChangeService', function ($http) {

    return {

        submitProfileChange: function submitProfileChange(statusChangeId, emailSubject, emailBody, recipientList, attachments, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/fsb/submit_profile_change',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'fsp_status_change_id': statusChangeId,
                    'email_body': emailBody,
                    'email_subject': emailSubject,
                    'recipient_list': recipientList,
                    'attachments': attachments
                }
            };

            return $http(req);
        }
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPAuditorsAdminController', function ($scope, $state, $controller, $timeout, FSPAuditorsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.auditors = [];
    $scope.auditor = {
        id: 0,
        name: '',
        responsible_partner: '',
        contact_number: '',
        practice_number: '',
        // date_appointed: new Date(),
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer auditor';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveAuditors();

        setTimeout(function () {
            $(document).ready(function () {

                // let $dateInput = $('#date_appointed').pickadate({
                //     selectMonths: true, // Creates a dropdown to control month
                //     selectYears: 100, // Creates a dropdown of 100 years to control year
                //     format: "yyyy-mm-dd"
                // });
                //
                // let datePicker = $dateInput.pickadate('picker');
                // datePicker.set('select', $scope.auditor.date_appointed);

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_auditor_attachments/' + $scope.fspId,
                    attachments: $scope.auditor.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.auditor.attachments.concat(attachments));
                    $scope.auditor.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 1000);
    }

    function retrieveAuditors() {

        $scope.processing = true;
        $scope.editing = false;

        FSPAuditorsService.getAuditorsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {
            $scope.auditors = res.data.auditors;
            $scope.auditors.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            $scope.auditors.forEach(function (auditor) {
                auditor.attachments.sort(function (a, b) {
                    var textA = a.file_name.toUpperCase();
                    var textB = b.file_name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            });
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editAuditor = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit auditor';

        var auditor = $scope.auditors[index];
        $scope.auditor = {
            id: auditor.id,
            name: auditor.name,
            responsible_partner: auditor.responsible_partner,
            contact_number: auditor.contact_number,
            practice_number: auditor.practice_number,
            // date_appointed: new Date(auditor.date_appointed),
            attachments: auditor.attachments

        };
        $scope.editing = true;
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveAuditor($scope.auditor.id, $scope.auditor.name, $scope.auditor.responsible_partner, $scope.auditor.contact_number, $scope.auditor.practice_number, $scope.auditor.attachments);
        }
    };

    $scope.addAuditor = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add auditor';

        $scope.auditor = {
            id: 0,
            name: '',
            responsible_partner: '',
            contact_number: '',
            practice_number: '',
            dt: '',
            attachments: []

        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer auditor';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveAuditor = function (id, name, responsible_partner, contact_number, practice_number, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            // scope.auditor.date_appointed = $('#date_appointed').val();

            $scope.processing = true;

            if (id) {

                FSPAuditorsService.editAuditor(id, name, responsible_partner, contact_number, practice_number,
                // $scope.auditor.date_appointed,
                attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPAuditorsService.createAuditor($scope.fspId, name, responsible_partner, contact_number, practice_number,
                // $scope.auditor.date_appointed,
                attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();
        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer auditor';
    };

    $scope.deleteAuditor = function (auditorId, index) {

        $('#modalConfirmHeader').html('Deleting Auditor');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPAuditorsService.deleteAuditor(this.auditorId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ auditorId: auditorId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPAuditorsService', function ($http) {

    return {

        getAuditorsList: function getAuditorsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_auditor_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createAuditor: function createAuditor(fspId, name, responsible_partner, contact_number, practice_number,
        // date_appointed,
        attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_auditor/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    name: name,
                    responsible_partner: responsible_partner,
                    contact_number: contact_number,
                    practice_number: practice_number,
                    // date_appointed: date_appointed,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editAuditor: function editAuditor(fspAuditorId, name, responsible_partner, contact_number, practice_number,
        // date_appointed,
        attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_auditor/' + fspAuditorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    name: name,
                    responsible_partner: responsible_partner,
                    contact_number: contact_number,
                    practice_number: practice_number,
                    // date_appointed: date_appointed,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteAuditor: function deleteAuditor(fspAuditorId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_auditor/' + fspAuditorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPClientsAdminController', function ($scope, $state, $controller, $timeout, FSPClientsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.clients = [];
    $scope.client = {
        id: 0,
        name: '',
        fund: '',
        notes: '',
        type: '',
        structure: '',
        administrator: '',
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer clients';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveClients();

        setTimeout(function () {
            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_client_attachments/' + $scope.fspId,
                    attachments: $scope.client.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.client.attachments.concat(attachments));
                    $scope.client.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 500);
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveClient($scope.client.id, $scope.client.name, $scope.client.fund, $scope.client.type, $scope.client.structure, $scope.client.administrator, $scope.client.attachments, $scope.client.notes);
        }
    };

    function retrieveClients() {

        $scope.processing = true;
        $scope.editing = false;

        FSPClientsService.getClientsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.clients = res.data.clients;
            $scope.clients.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            $scope.clients.forEach(function (client) {
                client.attachments.sort(function (a, b) {
                    var textA = a.file_name.toUpperCase();
                    var textB = b.file_name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            });
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editClient = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit client';

        var client = $scope.clients[index];
        $scope.client = {
            id: client.id,
            name: client.name,
            fund: client.fund || '',
            notes: client.notes || '',
            type: client.type,
            structure: client.structure,
            administrator: client.administrator,
            attachments: client.attachments

        };
        $scope.editing = true;
    };

    $scope.addClient = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add client';

        $scope.client = {
            id: 0,
            name: '',
            fund: '',
            notes: '',
            type: '',
            structure: '',
            administrator: '',
            attachments: []

        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer clients';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveClient = function (id, name, fund, type, structure, administrator, attachments, notes) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;

            if (id) {

                FSPClientsService.editClient(id, name, fund, type, structure, administrator, attachments, notes, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPClientsService.createClient($scope.fspId, name, fund, type, structure, administrator, attachments, notes, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer clients';
    };

    $scope.deleteClient = function (clientId, index) {

        $('#modalConfirmHeader').html('DELETING CLIENT');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPClientsService.deleteClient(this.clientId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ clientId: clientId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPClientsService', function ($http) {

    return {

        getClientsList: function getClientsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_client_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createClient: function createClient(fspId, name, fund, type, structure, administrator, attachments, notes, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_client/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    name: name,
                    fund: fund,
                    notes: notes,
                    type: type,
                    structure: structure,
                    administrator: administrator,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editClient: function editClient(fspClientId, name, fund, type, structure, administrator, attachments, notes, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_client/' + fspClientId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    name: name,
                    fund: fund,
                    notes: notes,
                    type: type,
                    structure: structure,
                    administrator: administrator,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteClient: function deleteClient(fspClientId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_client/' + fspClientId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FSPComplianceBreachesAdminController', function ($scope, $state, $controller, $timeout, FSPComplianceBreachesService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.complianceBreaches = [];
    $scope.complianceBreach = {
        id: 0,
        breach_type: '',
        material: false,
        note: '',
        notification_date_na: false,
        notification_date: new Date()

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer compliance breaches';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveComplianceBreaches();

        setTimeout(function () {
            $(document).ready(function () {

                // let $dateInput = $('#date_appointed').pickadate({
                //     selectMonths: true, // Creates a dropdown to control month
                //     selectYears: 100, // Creates a dropdown of 100 years to control year
                //     format: "yyyy-mm-dd"
                // });
                //
                // let datePicker = $dateInput.pickadate('picker');
                // datePicker.set('select', $scope.director.date_appointed);

            });
        }, 1000);
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveComplianceBreach($scope.complianceBreach.id, $scope.complianceBreach.breach_type, $scope.complianceBreach.material, $scope.complianceBreach.note, $scope.complianceBreach.notification_date, $scope.complianceBreach.notification_date_na);
        }
    };

    function retrieveComplianceBreaches() {

        $scope.processing = true;
        $scope.editing = false;

        FSPComplianceBreachesService.getComplianceBreachesList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {
            console.log(res.data.compliance_breaches);
            $scope.complianceBreaches = res.data.compliance_breaches;
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editComplianceBreach = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit compliance breach';

        var complianceBreach = $scope.complianceBreaches[index];
        $scope.complianceBreach = {
            id: complianceBreach.id,
            breach_type: complianceBreach.breach_type,
            material: !!complianceBreach.material,
            note: complianceBreach.note,
            notification_date: new Date(complianceBreach.notification_date),
            notification_date_na: !!complianceBreach.notification_date_na

        };
        $scope.editing = true;
    };

    $scope.addComplianceBreach = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add compliance breach';

        $scope.complianceBreach = {
            id: 0,
            breach_type: '',
            material: false,
            note: '',
            notification_date: new Date(),
            notification_date_na: false
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer compliance breaches';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveComplianceBreach = function (id, breach_type, material, note, notification_date, notification_date_na) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            notification_date = $('#notification_date').val();

            if (Math.abs(moment(new Date(notification_date)).diff(moment(), 'years')) > 100) {
                return alert('the notification date appears to be incorrect!');
            }

            console.log(notification_date);
            $scope.processing = true;

            if (id) {

                FSPComplianceBreachesService.editComplianceBreach(id, breach_type, material, note, notification_date, notification_date_na, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPComplianceBreachesService.createComplianceBreach($scope.fspId, breach_type, material, note, notification_date, notification_date_na, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer compliance breaches';
    };

    $scope.deleteComplianceBreach = function (breachId, index) {

        $('#modalConfirmHeader').html('DELETING COMPLIANCE BREACH');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPComplianceBreachesService.deleteComplianceBreach(this.breachId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ breachId: breachId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPComplianceBreachesService', function ($http) {

    return {

        getComplianceBreachesList: function getComplianceBreachesList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_compliance_breach_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createComplianceBreach: function createComplianceBreach(fspId, breach_type, material, note, notification_date, notification_date_na, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_compliance_breach/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    breach_type: breach_type,
                    material: material,
                    note: note,
                    notification_date: notification_date,
                    notification_date_na: notification_date_na
                }
            };

            return $http(req);
        },

        editComplianceBreach: function editComplianceBreach(complianceBreachId, breach_type, material, note, notification_date, notification_date_na, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_compliance_breach/' + complianceBreachId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    breach_type: breach_type,
                    material: material,
                    note: note,
                    notification_date: notification_date,
                    notification_date_na: notification_date_na
                }
            };

            return $http(req);
        },

        deleteComplianceBreach: function deleteComplianceBreach(complianceBreachId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_compliance_breach/' + complianceBreachId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPComplianceDocumentsAdminController', function ($scope, $state, $controller, $timeout, FSPComplianceDocumentsService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.complianceDocuments = [];
    $scope.complianceDocumentNotes = '';
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        retrieveComplianceDocuments();
    });

    function retrieveComplianceDocuments() {

        $scope.processing = true;
        $scope.editing = false;

        FSPComplianceDocumentsService.getComplianceDocuments($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            var documents = res.data.compliance_documents;
            $scope.complianceDocumentNotes = res.data.compliance_document_notes || '';

            var uniqueNames = [].concat(_toConsumableArray(new Set(documents.map(function (doc) {
                return doc.name;
            }))));
            var uniqueDocuments = [];
            uniqueNames.forEach(function (uniqueName) {
                uniqueDocuments.push(documents.find(function (doc) {
                    return doc.name === uniqueName;
                }));
            });

            $scope.complianceDocuments = uniqueDocuments;
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.saveComplianceDocuments = function () {
        $scope.processing = true;
        FSPComplianceDocumentsService.saveComplianceDocuments($scope.fspId, $scope.complianceDocuments, $scope.complianceDocumentNotes || '', $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.processing = false;
            $scope.goBack();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };
});
'use strict';

angular.module('ics').factory('FSPComplianceDocumentsService', function ($http) {

    return {

        getComplianceDocuments: function getComplianceDocuments(fspId, firebaseTokenId, visitorId) {
            var time = new Date().getTime();
            var req = {
                method: 'GET',
                url: '/api/fsp_compliance_documents/' + fspId + '?timestamp=' + time,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        saveComplianceDocuments: function saveComplianceDocuments(fspId, complianceDocuments, complianceDocumentNotes, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_compliance_documents/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    compliance_documents: complianceDocuments,
                    compliance_document_notes: complianceDocumentNotes
                }
            };

            return $http(req);
        }
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPContactPersonsAdminController', function ($scope, $state, $controller, $timeout, FSPContactPersonsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.contact_persons = [];
    $scope.contact_person = {
        id: 0,
        name: '',
        last_name: '',
        notes: '',
        email: '',
        password: '',
        cell_number: '',
        tel_number: '',
        fax_number: '',
        physical_address: '',
        postal_address: '',
        receive_emails: true,
        receive_profile_change_emails: true,
        report_view_contact_persons: true,
        report_view_auditor: true,
        report_view_fsb_submissions: true,
        report_view_fsp_details: true,
        report_view_scope_of_licensing: true,
        report_view_clients: true,
        report_view_shareholders: true,
        report_view_directors: true,
        report_view_compliance_breaches: true,
        report_view_key_individuals: true,
        report_view_representatives: true,
        report_view_third_party_admins: true,
        report_view_third_party_providers: true,
        report_view_external_auditor: true,
        report_view_profile_changes: true,
        report_view_operational_risk_matrix: true,
        report_view_market_risk_matrix: true,
        report_view_regulatory_risk_matrix: true,
        report_view_compliance_documents: true,
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer contact persons';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveContactPersons();

        setTimeout(function () {
            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_contact_person_attachments/' + $scope.fspId,
                    attachments: $scope.contact_person.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.contact_person.attachments.concat(attachments));
                    $scope.contact_person.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 500);
    };

    function validatePassword(password) {

        var pRE = /(?=^.{6,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).*/;
        return pRE.test(password);
    }

    function makeId(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    function retrieveContactPersons() {

        $scope.processing = true;
        $scope.editing = false;

        FSPContactPersonsService.getContactPersonsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.contact_persons = res.data.contact_persons;
            $scope.contact_persons.sort(function (a, b) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            $scope.contact_persons.forEach(function (contact_person) {
                contact_person.attachments.sort(function (a, b) {
                    var textA = a.file_name.toUpperCase();
                    var textB = b.file_name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            });
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.submitForm = function ($form) {

        if ($form.$valid) {
            $scope.saveContactPerson($scope.contact_person.id, $scope.contact_person.name, $scope.contact_person.last_name || '', $scope.contact_person.email, $scope.contact_person.password, $scope.contact_person.cell_number, $scope.contact_person.tel_number, $scope.contact_person.fax_number, $scope.contact_person.physical_address, $scope.contact_person.postal_address, $scope.contact_person.receive_emails, $scope.contact_person.receive_profile_change_emails, $scope.contact_person.report_view_contact_persons, $scope.contact_person.report_view_auditor, $scope.contact_person.report_view_fsb_submissions, $scope.contact_person.report_view_fsp_details, $scope.contact_person.report_view_scope_of_licensing, $scope.contact_person.report_view_clients, $scope.contact_person.report_view_shareholders, $scope.contact_person.report_view_directors, $scope.contact_person.report_view_compliance_breaches, $scope.contact_person.report_view_key_individuals, $scope.contact_person.report_view_representatives, $scope.contact_person.report_view_third_party_admins, $scope.contact_person.report_view_external_auditor, $scope.contact_person.report_view_profile_changes, $scope.contact_person.report_view_operational_risk_matrix, $scope.contact_person.report_view_market_risk_matrix, $scope.contact_person.report_view_regulatory_risk_matrix, $scope.contact_person.report_view_compliance_documents, $scope.contact_person.attachments, $scope.contact_person.notes);
        }
    };

    $scope.editContactPerson = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit contact person';

        var contact_person = $scope.contact_persons[index];
        $scope.contact_person = {
            id: contact_person.id,
            name: contact_person.name,
            last_name: contact_person.last_name || '',
            password: '',
            email: contact_person.firebase_user.email,
            cell_number: contact_person.cell_number,
            tel_number: contact_person.tel_number,
            fax_number: contact_person.tel_number,
            physical_address: contact_person.physical_address,
            postal_address: contact_person.postal_address,
            receive_emails: contact_person.receive_emails || false,
            receive_profile_change_emails: contact_person.receive_profile_change_emails || false,
            report_view_contact_persons: contact_person.report_view_contact_persons || false,
            report_view_auditor: contact_person.report_view_auditor || false,
            report_view_fsb_submissions: contact_person.report_view_fsb_submissions || false,
            report_view_fsp_details: contact_person.report_view_fsp_details || false,
            report_view_scope_of_licensing: contact_person.report_view_scope_of_licensing || false,
            report_view_clients: contact_person.report_view_clients || false,
            report_view_shareholders: contact_person.report_view_shareholders || false,
            report_view_directors: contact_person.report_view_directors || false,
            report_view_compliance_breaches: contact_person.report_view_compliance_breaches || false,
            report_view_key_individuals: contact_person.report_view_key_individuals || false,
            report_view_representatives: contact_person.report_view_representatives || false,
            report_view_third_party_admins: contact_person.report_view_third_party_admins || false,
            report_view_third_party_providers: contact_person.report_view_third_party_providers || false,
            report_view_external_auditor: contact_person.report_view_external_auditor || false,
            report_view_profile_changes: contact_person.report_view_profile_changes || false,
            report_view_operational_risk_matrix: contact_person.report_view_operational_risk_matrix || false,
            report_view_market_risk_matrix: contact_person.report_view_market_risk_matrix || false,
            report_view_regulatory_risk_matrix: contact_person.report_view_regulatory_risk_matrix || false,
            report_view_compliance_documents: contact_person.report_view_compliance_documents || false,
            notes: contact_person.notes || '',
            attachments: contact_person.attachments
        };

        $scope.editing = true;
    };

    $scope.addContactPerson = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add contact person';

        $scope.contact_person = {
            id: 0,
            name: '',
            last_name: '',
            password: '',
            email: '',
            notes: '',
            cell_number: '',
            tel_number: '',
            fax_number: '',
            physical_address: '',
            postal_address: '',
            receive_emails: true,
            receive_profile_change_emails: true,
            report_view_contact_persons: true,
            report_view_auditor: true,
            report_view_fsb_submissions: true,
            report_view_fsp_details: true,
            report_view_scope_of_licensing: true,
            report_view_clients: true,
            report_view_shareholders: true,
            report_view_directors: true,
            report_view_compliance_breaches: true,
            report_view_key_individuals: true,
            report_view_representatives: true,
            report_view_third_party_admins: true,
            report_view_third_party_providers: true,
            report_view_external_auditor: true,
            report_view_profile_changes: true,
            report_view_operational_risk_matrix: true,
            report_view_market_risk_matrix: true,
            report_view_regulatory_risk_matrix: true,
            report_view_compliance_documents: true,
            attachments: []
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer contact persons';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveContactPerson = function (id, name, last_name, email, password, cell_number, tel_number, fax_number, physical_address, postal_address, receive_emails, receive_profile_change_emails, report_view_contact_persons, report_view_auditor, report_view_fsb_submissions, report_view_fsp_details, report_view_scope_of_licensing, report_view_clients, report_view_shareholders, report_view_directors, report_view_compliance_breaches, report_view_key_individuals, report_view_representatives, report_view_third_party_admins, report_view_external_auditor, report_view_profile_changes, report_view_operational_risk_matrix, report_view_market_risk_matrix, report_view_regulatory_risk_matrix, report_view_compliance_documents, attachments, notes) {

        try {

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                $scope.processing = true;

                if (id) {

                    FSPContactPersonsService.editContactPerson(id, name, last_name, email, cell_number, tel_number, fax_number, physical_address, postal_address, receive_emails, receive_profile_change_emails, report_view_contact_persons, report_view_auditor, report_view_fsb_submissions, report_view_fsp_details, report_view_scope_of_licensing, report_view_clients, report_view_shareholders, report_view_directors, report_view_compliance_breaches, report_view_key_individuals, report_view_representatives, report_view_third_party_admins, report_view_third_party_providers, report_view_external_auditor, report_view_profile_changes, report_view_operational_risk_matrix, report_view_market_risk_matrix, report_view_regulatory_risk_matrix, report_view_compliance_documents, attachments, notes, tokenId, $scope.visitorId).then(function () {
                        return location.reload();
                    }).catch(function (err) {
                        return $scope.checkErrStatus(err);
                    });
                } else {

                    if (!validatePassword(password)) {
                        alert('Please ensure the password is at least 6 digits long, and contains at least one capital letter and at least one special character');
                        $scope.processing = false;
                        return;
                    }

                    var userUid = makeId(16);

                    FSPContactPersonsService.createContactPerson($scope.fspId, name, last_name, email, userUid, cell_number, tel_number, fax_number, physical_address, postal_address, receive_emails, receive_profile_change_emails, report_view_contact_persons, report_view_auditor, report_view_fsb_submissions, report_view_fsp_details, report_view_scope_of_licensing, report_view_clients, report_view_shareholders, report_view_directors, report_view_compliance_breaches, report_view_key_individuals, report_view_representatives, report_view_third_party_admins, report_view_third_party_providers, report_view_external_auditor, report_view_profile_changes, report_view_operational_risk_matrix, report_view_market_risk_matrix, report_view_regulatory_risk_matrix, report_view_compliance_documents, attachments, notes, tokenId, $scope.visitorId).then(function () {
                        return location.reload();
                    });
                }
            });
        } catch (e) {
            $scope.checkErrStatus(e);
        }
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer contact persons';
    };

    $scope.deleteContactPerson = function (contact_personId, index) {

        $('#modalConfirmHeader').html('DELETING CONTACT PERSON');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPContactPersonsService.deleteContactPerson(this.contact_personId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ contact_personId: contact_personId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPContactPersonsService', function ($http) {

    return {

        getContactPersonsList: function getContactPersonsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_contact_person_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        getContactPersonEmailRecipients: function getContactPersonEmailRecipients(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_contact_person_email_recipients',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 30000
            };

            return $http(req);
        },

        createContactPerson: function createContactPerson(fspId, name, last_name, email, uid, cell_number, tel_number, fax_number, physical_address, postal_address, receive_emails, receive_profile_change_emails, report_view_contact_persons, report_view_auditor, report_view_fsb_submissions, report_view_fsp_details, report_view_scope_of_licensing, report_view_clients, report_view_shareholders, report_view_directors, report_view_compliance_breaches, report_view_key_individuals, report_view_representatives, report_view_third_party_admins, report_view_third_party_providers, report_view_external_auditor, report_view_profile_changes, report_view_operational_risk_matrix, report_view_market_risk_matrix, report_view_regulatory_risk_matrix, report_view_compliance_documents, attachments, notes, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_contact_person/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    name: name,
                    last_name: last_name,
                    email: email,
                    uid: uid,
                    cell_number: cell_number,
                    tel_number: tel_number,
                    fax_number: fax_number,
                    physical_address: physical_address,
                    postal_address: postal_address,
                    receive_emails: receive_emails,
                    receive_profile_change_emails: receive_profile_change_emails,
                    report_view_contact_persons: report_view_contact_persons,
                    report_view_auditor: report_view_auditor,
                    report_view_fsb_submissions: report_view_fsb_submissions,
                    report_view_fsp_details: report_view_fsp_details,
                    report_view_scope_of_licensing: report_view_scope_of_licensing,
                    report_view_clients: report_view_clients,
                    report_view_shareholders: report_view_shareholders,
                    report_view_directors: report_view_directors,
                    report_view_compliance_breaches: report_view_compliance_breaches,
                    report_view_key_individuals: report_view_key_individuals,
                    report_view_representatives: report_view_representatives,
                    report_view_third_party_admins: report_view_third_party_admins,
                    report_view_third_party_providers: report_view_third_party_providers,
                    report_view_external_auditor: report_view_external_auditor,
                    report_view_profile_changes: report_view_profile_changes,
                    report_view_operational_risk_matrix: report_view_operational_risk_matrix,
                    report_view_market_risk_matrix: report_view_market_risk_matrix,
                    report_view_regulatory_risk_matrix: report_view_regulatory_risk_matrix,
                    report_view_compliance_documents: report_view_compliance_documents,
                    attachments: attachments || [],
                    notes: notes || ''
                }
            };

            return $http(req);
        },

        editContactPerson: function editContactPerson(fspContactPersonId, name, last_name, email, cell_number, tel_number, fax_number, physical_address, postal_address, receive_emails, receive_profile_change_emails, report_view_contact_persons, report_view_auditor, report_view_fsb_submissions, report_view_fsp_details, report_view_scope_of_licensing, report_view_clients, report_view_shareholders, report_view_directors, report_view_compliance_breaches, report_view_key_individuals, report_view_representatives, report_view_third_party_admins, report_view_third_party_providers, report_view_external_auditor, report_view_profile_changes, report_view_operational_risk_matrix, report_view_market_risk_matrix, report_view_regulatory_risk_matrix, report_view_compliance_documents, attachments, notes, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_contact_person/' + fspContactPersonId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    name: name,
                    last_name: last_name,
                    email: email,
                    cell_number: cell_number,
                    tel_number: tel_number,
                    fax_number: fax_number,
                    physical_address: physical_address,
                    postal_address: postal_address,
                    receive_emails: receive_emails,
                    receive_profile_change_emails: receive_profile_change_emails,
                    report_view_contact_persons: report_view_contact_persons,
                    report_view_auditor: report_view_auditor,
                    report_view_fsb_submissions: report_view_fsb_submissions,
                    report_view_fsp_details: report_view_fsp_details,
                    report_view_scope_of_licensing: report_view_scope_of_licensing,
                    report_view_clients: report_view_clients,
                    report_view_shareholders: report_view_shareholders,
                    report_view_directors: report_view_directors,
                    report_view_compliance_breaches: report_view_compliance_breaches,
                    report_view_key_individuals: report_view_key_individuals,
                    report_view_representatives: report_view_representatives,
                    report_view_third_party_admins: report_view_third_party_admins,
                    report_view_third_party_providers: report_view_third_party_providers,
                    report_view_external_auditor: report_view_external_auditor,
                    report_view_profile_changes: report_view_profile_changes,
                    report_view_operational_risk_matrix: report_view_operational_risk_matrix,
                    report_view_market_risk_matrix: report_view_market_risk_matrix,
                    report_view_regulatory_risk_matrix: report_view_regulatory_risk_matrix,
                    report_view_compliance_documents: report_view_compliance_documents,
                    attachments: attachments || [],
                    notes: notes || ''
                }
            };

            return $http(req);
        },

        deleteContactPerson: function deleteContactPerson(fspContactPersonId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_contact_person/' + fspContactPersonId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSPDetailsController', function ($rootScope, $scope, $state, $controller, $timeout, FSPService, FirebaseStorageService, CategoriesService, FirebaseAuthService) {
    var _this = this;

    $scope.fspId = '';
    $scope.associatedFSPs = [];
    $scope.errorMessage = '';
    $scope.followUpList = [];
    $scope.showFollowUp = false;
    $scope.changeListStatuses = [];
    $scope.processing = true;

    $scope.privileges = {
        fsb_submissions: false,
        fsp_details: false,
        scope_of_licensing: false,
        contact_persons: false,
        clients: false,
        shareholders: false,
        directors: false,
        compliance_breaches: false,
        key_individuals: false,
        representatives: false,
        third_party_admins: false,
        external_auditor: false,
        profile_changes: false,
        operational_risk_matrix: false,
        market_risk_matrix: false,
        regulatory_risk_matrix: false,
        compliance_documents: false
    };

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $(document).ready(function () {
        $('#profile_change_status').material_select();
    });

    $scope.changeFSP = function () {

        var e = document.getElementById("selected_fsp");
        var fspId = e.options[e.selectedIndex].value;
        $scope.fspId = fspId;

        setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return $scope.retrieveFSPDetails();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        })), 200);
    };

    $scope.retrieveFSPDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tokenId, response1, response2, statuses, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, value, response3, response4, possibleCategories;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;

                        $scope.processing = true;
                        _context2.next = 4;
                        return FirebaseAuthService.getUserToken();

                    case 4:
                        tokenId = _context2.sent;

                        console.log($scope.fspId);

                        _context2.next = 8;
                        return FSPService.GetFSPDetails($scope.fspId, tokenId, $scope.visitorId);

                    case 8:
                        response1 = _context2.sent;

                        $scope.fspDetails = response1.data.fsp;
                        $scope.privileges = response1.data.privileges;
                        $scope.processing = false;

                        _context2.next = 14;
                        return FSPService.GetFSPChangeList($scope.fspId, tokenId, $scope.visitorId);

                    case 14:
                        response2 = _context2.sent;

                        $scope.changesList = response2.data.status_changes_list;

                        statuses = new Map();

                        $scope.changesList.forEach(function (item) {

                            if (statuses.has(item.status.name)) {
                                statuses.set(item.status.name, statuses.get(item.status.name) + 1);
                            } else {
                                statuses.set(item.status.name, 1);
                            }

                            var created = new Date(item.created);
                            created.setTime(created.getTime() - created.getTimezoneOffset() * 60 * 1000);
                            item.created = created;
                        });

                        $scope.statusTotals = [];
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context2.prev = 22;
                        for (_iterator = statuses[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];

                            $scope.statusTotals.push({
                                status: key,
                                count: value
                            });
                        }

                        _context2.next = 30;
                        break;

                    case 26:
                        _context2.prev = 26;
                        _context2.t0 = _context2['catch'](22);
                        _didIteratorError = true;
                        _iteratorError = _context2.t0;

                    case 30:
                        _context2.prev = 30;
                        _context2.prev = 31;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 33:
                        _context2.prev = 33;

                        if (!_didIteratorError) {
                            _context2.next = 36;
                            break;
                        }

                        throw _iteratorError;

                    case 36:
                        return _context2.finish(33);

                    case 37:
                        return _context2.finish(30);

                    case 38:
                        $scope.statusTotals.sort(function (a, b) {
                            return a.count - b.count;
                        });

                        _context2.next = 41;
                        return FSPService.GetFSPFollowUpList($scope.fspId, tokenId, $scope.visitorId);

                    case 41:
                        response3 = _context2.sent;

                        $scope.followUpList = response3.data.follow_up_list;
                        $scope.followUpList.sort(function (a, b) {
                            return new Date(a.follow_up_on).getTime() - new Date(b.follow_up_on).getTime();
                        });

                        $scope.followUpList.forEach(function (item) {

                            var created = new Date(item.created);
                            created.setTime(created.getTime() - created.getTimezoneOffset() * 60 * 1000);
                            item.created = created;

                            var follow_up_on = new Date(item.follow_up_on);
                            follow_up_on.setTime(follow_up_on.getTime() - follow_up_on.getTimezoneOffset() * 60 * 1000);
                            item.follow_up_on = follow_up_on;
                        });

                        _context2.next = 47;
                        return CategoriesService.getCategoriesListFromCode('profile_change_status', tokenId, $scope.visitorId);

                    case 47:
                        response4 = _context2.sent;
                        possibleCategories = [];

                        response4.data.categories.forEach(function (category) {
                            if ($scope.changesList.find(function (change) {
                                return change.status.id == category.id;
                            })) {
                                possibleCategories.push(category);
                            }
                        });

                        $scope.profileChangeStatusCategories = [].concat(possibleCategories);

                        $scope.profileChangeStatusCategories.sort(function (a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return textA < textB ? -1 : textA > textB ? 1 : 0;
                        });

                        $scope.$apply();

                        $timeout(function () {
                            $('.modal').modal();
                            $('select').material_select();
                            $('#profile_status').material_select();
                        }, 1000);

                        _context2.next = 59;
                        break;

                    case 56:
                        _context2.prev = 56;
                        _context2.t1 = _context2['catch'](0);

                        $scope.checkErrStatus(_context2.t1);

                    case 59:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this, [[0, 56], [22, 26, 30, 38], [31,, 33, 37]]);
    }));

    $scope.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var associatedFSPs;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:

                        try {
                            $scope.fspId = $state.params.fsp_id || '';
                            associatedFSPs = window.localStorage.getItem('associated_fsps');

                            if (associatedFSPs) {
                                $scope.associatedFSPs = JSON.parse(associatedFSPs);
                            }
                            angular.element(document).ready(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                if ($scope.associatedFSPs.length) {
                                                    $scope.fspId = $scope.associatedFSPs[0].id;
                                                }
                                                _context3.next = 3;
                                                return $scope.retrieveFSPDetails();

                                            case 3:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this2);
                            })));
                        } catch (err) {
                            $scope.checkErrStatus(err);
                        }

                    case 1:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    $scope.documentAdmin = function () {
        $state.transitionTo('admin-fsp-document-tree', {
            fsp_id: $scope.fspId,
            fsp_name: encodeURI($scope.fspDetails.name)
        });
    };

    $scope.complianceDocumentAdmin = function () {
        $state.transitionTo('admin-fsp-compliance-documents', {
            fsp_id: $scope.fspId,
            fsp_name: encodeURI($scope.fspDetails.name)
        });
    };

    $scope.riskProfileAdmin = function () {
        $state.transitionTo('admin-fsp-risk-profile', {
            fsp_id: $scope.fspId,
            fsp_name: encodeURI($scope.fspDetails.name)
        });
    };

    $scope.encodeItem = function (item) {
        return encodeURIComponent(item);
    };

    $scope.reportHistory = function () {
        $state.transitionTo('admin-fsp-report-history', {
            fsp_id: $scope.fspId,
            fsp_name: encodeURI($scope.fspDetails.name)
        });
    };

    $scope.addProfileChange = function () {
        $state.transitionTo('admin-fsp-profile-change', { fsp_id: $scope.fspId });
    };

    $scope.viewProfileChangeDetails = function (id) {
        if (!$rootScope.isSuperAdmin) {
            return;
        }
        $state.transitionTo('admin-fsp-profile-change-details', { profile_change_id: id, fsp_id: $scope.fspId });
    };

    $scope.followUpProfileChange = function (id) {
        $state.transitionTo('admin-fsp-follow-up-profile-change', { profile_change_id: id, fsp_id: $scope.fspId });
    };

    $scope.init();
});
;
'use strict';

angular.module('ics').controller('FSPDocsAdminController', function ($scope, $state, $controller, $timeout, CategoriesService, FSPDocsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.categoryTypeCode = $state.params.category_type_code;
    $scope.documentTypeTitle = $state.params.document_type_title;
    $scope.fspId = $state.params.fsp_id;
    $scope.selectedCategoryDocuments = [];
    $scope.selectedCategoryTitle = '';

    $scope.editing = false;
    $scope.viewing = false;
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        retrieveData();

        setTimeout(function () {

            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                docUploadControl.addEventListener('change', function (e) {
                    var file = e.target.files[0];
                    if (!file || !file.name) return;
                    $('.file-field #uploading-document').removeClass('ng-hide');
                    $('.file-field .btn').addClass('ng-hide');
                    FirebaseStorageService.uploadFileToCloudStorage('/fsp_documents/' + $scope.fspId, file, null).then(function (storageInfo) {
                        $('.file-field #uploading-document').addClass('ng-hide');
                        $('.file-field .btn').removeClass('ng-hide');
                        $scope.documentUrl = storageInfo.downloadUrl;
                        $scope.documentName = file.name;
                        $scope.$apply();
                    }, function (errMessage) {
                        $('.file-field #uploading-document').addClass('ng-hide');
                        $('.file-field .btn').removeClass('ng-hide');
                        alert(errMessage);
                    });
                });
            });
        }, 2000);
    };

    function retrieveData() {

        $scope.processing = true;
        $scope.editing = false;
        $scope.viewing = false;

        CategoriesService.getCategoriesListFromCode($scope.categoryTypeCode, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.categories = res.data.categories;

            if ($scope.categories.length == 0) {
                $scope.processing = false;
                return;
            }

            var typeId = $scope.categories[0].category_type.id;

            FSPDocsService.getDocumentsFromCategoryType($scope.fspId, typeId, $scope.tokenId, $scope.visitorId).then(function (res) {

                console.log(res);
                $scope.processing = false;
                $scope.documents = res.data.documents;

                $scope.categories.forEach(function (category) {
                    category.documents = $scope.documents.filter(function (document) {
                        return document.category.id === category.id;
                    });
                });
            });
        }, function (reject) {
            $scope.processing = false;
            if (reject.status === 403) {
                location.reload();
            }
        });
    }

    $scope.viewCategoryDocuments = function (index) {
        $('body').addClass('bg-grey-1');
        $scope.selectedCategoryId = $scope.categories[index].id;
        $scope.selectedCategoryTitle = $scope.categories[index].name;
        $scope.selectedCategoryDocuments = $scope.categories[index].documents;
        $scope.editing = false;
        $scope.viewing = true;
    };

    $scope.addDocument = function () {
        $('body').removeClass('bg-grey-1');
        $scope.editing = true;
        $scope.viewing = false;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveDocument = function (documentName, documentUrl, selectedCategoryId) {
        if (documentName.length === 0 || documentUrl.name === 0) {
            return;
        }

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;

            FSPDocsService.saveCategoryDocument($scope.fspId, selectedCategoryId, documentUrl, documentName, tokenId, $scope.visitorId).then(function (res) {

                retrieveData();
            }, function (reject) {
                $scope.processing = false;
                if (reject.status === 403) {
                    location.reload();
                }
            });
        });
    };

    $scope.cancelViewing = function () {
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.viewing = false;
    };

    $scope.cancelEditing = function () {
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.viewing = true;
    };

    $scope.deleteCategoryDocument = function (docId, index) {

        $('#modalConfirmHeader').html('Deleting Document');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteDoc = function deleteDoc() {

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                FSPDocsService.deleteCategoryDocument(docId, tokenId, $scope.visitorId).then(function () {
                    $scope.processing = false;
                    $scope.selectedCategoryDocuments.splice(index, 1);
                    reset();
                }, function (reject) {
                    if (reject.status === 403) {
                        $state.transitionTo('signin');
                    }
                });
            });
        };

        var deletionEvent = deleteDoc.bind({ docId: docId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };
});
'use strict';

angular.module('ics').factory('FSPDocsService', function ($http) {

    return {

        getDocumentsFromCategoryType: function getDocumentsFromCategoryType(fspId, categoryTypeId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp/documents/' + fspId + '/' + categoryTypeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        deleteCategoryDocument: function deleteCategoryDocument(docId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp/document/' + docId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        saveCategoryDocument: function saveCategoryDocument(fspId, categoryId, documentUrl, documentName, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp/document/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp_id: fspId,
                    category_id: categoryId,
                    document_url: documentUrl,
                    document_name: documentName
                }
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPDirectorsAdminController', function ($scope, $state, $controller, $timeout, FSPDirectorsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.directors = [];
    $scope.director = {
        id: 0,
        first_name: '',
        last_name: '',
        id_number: '',
        date_appointed: new Date(),
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer directors';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveDirectors();

        setTimeout(function () {
            $(document).ready(function () {

                // let $dateInput = $('#date_appointed').pickadate({
                //     selectMonths: true, // Creates a dropdown to control month
                //     selectYears: 100, // Creates a dropdown of 100 years to control year
                //     format: "yyyy-mm-dd"
                // });
                //
                // let datePicker = $dateInput.pickadate('picker');
                // datePicker.set('select', $scope.director.date_appointed);

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_director_attachments/' + $scope.fspId,
                    attachments: $scope.director.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.director.attachments.concat(attachments));
                    $scope.director.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 1000);
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveDirector($scope.director.id, $scope.director.first_name, $scope.director.last_name, $scope.director.id_number, $scope.director.attachments);
        }
    };

    function retrieveDirectors() {

        $scope.processing = true;
        $scope.editing = false;

        FSPDirectorsService.getDirectorsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.directors = res.data.directors;
            $scope.directors.sort(function (a, b) {
                var textA = a.last_name.toUpperCase();
                var textB = b.last_name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            $scope.directors.forEach(function (director) {
                director.attachments.sort(function (a, b) {
                    var textA = a.file_name.toUpperCase();
                    var textB = b.file_name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            });
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editDirector = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit director';

        var director = $scope.directors[index];
        $scope.director = {
            id: director.id,
            first_name: director.first_name,
            last_name: director.last_name,
            id_number: director.id_number,
            date_appointed: new Date(director.date_appointed),
            attachments: director.attachments

        };
        $scope.editing = true;
    };

    $scope.addDirector = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add director';

        $scope.director = {
            id: 0,
            first_name: '',
            last_name: '',
            id_number: '',
            date_appointed: new Date(),
            attachments: []
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer directors';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveDirector = function (id, first_name, last_name, id_number, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.director.date_appointed = $('#date_appointed').val();

            if (Math.abs(moment(new Date($scope.director.date_appointed)).diff(moment(), 'years')) > 100) {
                return alert('the date appointed field appears to be incorrect!');
            }

            $scope.processing = true;

            if (id) {

                FSPDirectorsService.editDirector(id, first_name, last_name, id_number, $scope.director.date_appointed, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPDirectorsService.createDirector($scope.fspId, first_name, last_name, id_number, $scope.director.date_appointed, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer directors';
    };

    $scope.deleteDirector = function (directorId, index) {

        $('#modalConfirmHeader').html('DELETING DIRECTOR');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPDirectorsService.deleteDirector(this.directorId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ directorId: directorId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPDirectorsService', function ($http) {

    return {

        getDirectorsList: function getDirectorsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_director_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createDirector: function createDirector(fspId, first_name, last_name, id_number, date_appointed, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_director/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editDirector: function editDirector(fspDirectorId, first_name, last_name, id_number, date_appointed, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_director/' + fspDirectorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteDirector: function deleteDirector(fspDirectorId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_director/' + fspDirectorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FSPDocumentTreeAdminController', function ($rootScope, $scope, $state, $q, $sce, $controller, $timeout, CategoriesService, FSPDocumentTreeService, FirebaseAuthService, FirebaseStorageService) {

    $scope.categoryTypeCode = $state.params.category_type_code;
    $scope.documentTypeTitle = $state.params.document_type_title;
    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.html = '';
    $scope.selectedFolderId = null;
    $scope.addFolderOrFile = false;
    $scope.processing = true;

    $scope.editFolderName = false;
    $scope.selectedEditFolderName = '';

    $scope.selectedFolderName = '';
    $scope.newSubfolder = '';
    var filesUploaded = [];

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        // retrieve folders and files from DB
        retrieveFSPFolders().then(prepareTreeStructure);

        $(document).ready(function () {

            // prepare doc upload control
            var docUploadControl = document.getElementById("documentUpload");

            docUploadControl.addEventListener('change', function (e) {

                var fileNames = [],
                    firebasePromises = [],
                    ndbPromises = [];

                if (!e.target.files || e.target.files.length === 0) {
                    return;
                }

                var _loop = function _loop() {
                    var file = e.target.files[i];
                    if (!file || !file.name) {
                        return 'continue';
                    }
                    if (filesUploaded.find(function (item) {
                        return item === file.name;
                    })) {
                        return 'continue';
                    }
                    filesUploaded.push(file.name);
                    fileNames.push(file.name);
                    firebasePromises.push(FirebaseStorageService.uploadFileToCloudStorage('/fsp_documents/' + $scope.selectedFolderId, file, null));
                };

                for (var i = 0; i < e.target.files.length; i++) {
                    var _ret = _loop();

                    if (_ret === 'continue') continue;
                }

                if (firebasePromises.length === 0) {
                    return;
                }

                $('#or_parent').hide();
                $('#add_folder_name_parent').hide();
                $('#cancel_button_parent').hide();
                $('.file-field #uploading-document').removeClass('ng-hide');
                $('.file-field .btn').addClass('ng-hide');
                $('.btn .width-fixed .bg-grey-5').addClass('ng-hide');

                Promise.all(firebasePromises).then(function (storageInfos) {

                    for (var _i = 0; _i < storageInfos.length; _i++) {
                        ndbPromises.push(FSPDocumentTreeService.createFile($scope.fspId, $scope.selectedFolderId, fileNames[_i], storageInfos[_i].downloadUrl, $scope.tokenId, $scope.visitorId));
                    }

                    Promise.all(ndbPromises).then(function () {
                        return location.reload();
                    }).catch(function (err) {

                        $('#or_parent').show();
                        $('#add_folder_name_parent').show();
                        $('#cancel_button_parent').show();
                        $('.file-field #uploading-document').addClass('ng-hide');
                        $('.file-field .btn').removeClass('ng-hide');
                        $('.btn .width-fixed .bg-grey-5').removeClass('ng-hide');
                        alert(err);
                    });
                });
            });
        });
    };

    $scope.goBack = function () {
        if ($scope.editFolderName) {
            $scope.editFolderName = false;
            return;
        }
        if ($scope.addFolderOrFile) {
            $scope.addFolderOrFile = false;
            return;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    // ********* F O L D E R  F U N C T I O N S **********

    $scope.clickFolder = function (folderId) {

        $('a[id ^= "addItem"]').each(function () {
            $(this).hide();
        });

        $('a[id ^= "deleteItem"]').each(function () {
            $(this).hide();
        });

        $('a[id ^= "editItem"]').each(function () {
            $(this).hide();
        });

        $('a[id ^= "viewFile"]').each(function () {
            $(this).hide();
        });

        $('a[id ^= "deleteFile"]').each(function () {
            $(this).hide();
        });

        $('.doc').each(function () {
            $(this).removeClass('bold').removeClass('clicked-folder');
        });

        $('li[role="treeitem"]').each(function () {
            $(this).find('p').removeClass('bold').removeClass('clicked-folder');
        });

        $('#caption' + folderId).addClass('bold').addClass('clicked-folder');

        if ($rootScope.isSuperAdmin) {
            $('#addItem' + folderId).show();
            $('#deleteItem' + folderId).show();
            $('#editItem' + folderId).show();
        }

        $scope.selectedFolderId = folderId;
    };

    $scope.addFolder = function (folderId) {

        $scope.selectedFolderId = folderId;
        $scope.addFolderOrFile = true;
        $scope.selectedFolderName = folderId ? '/' + $('#caption' + folderId).attr('title') : 'Create directory';
        if (folderId) {
            $scope.$apply();
        }
    };

    $scope.editFolder = function (folderId) {

        $scope.selectedFolderId = folderId;
        $scope.editFolderName = true;
        $scope.selectedEditFolderName = $('#caption' + folderId).attr('title');
        $scope.selectedFolderName = $scope.selectedEditFolderName;
        $scope.$applyAsync();
    };

    $scope.createSubFolder = function () {

        if ($scope.newSubfolder.trim().length === 0) {
            return;
        }
        var title = $scope.newSubfolder.trim() + '';
        $scope.processing = true;

        try {

            FSPDocumentTreeService.createFolder($scope.fspId, $scope.selectedFolderId, $scope.newSubfolder.trim(), $scope.tokenId, $scope.visitorId).then(function (res) {
                retrieveFSPFolders().then(prepareTreeStructure).then(function () {
                    $scope.selectedFolderId = res.data.fsp_document_folder.id;
                    $scope.addFolderOrFile = true;
                    $scope.processing = false;
                    $scope.$applyAsync();

                    $timeout(function () {
                        $('#selectedFolderName').html('/' + title);
                        $scope.$apply();
                    }, 500);
                });
            });
        } catch (e) {
            $scope.checkErrStatus(e);
        }
    };

    $scope.saveFolder = function () {

        if ($scope.selectedEditFolderName.trim().length === 0) {
            return;
        }

        FSPDocumentTreeService.editFolder($scope.fspId, $scope.selectedFolderId, $scope.selectedEditFolderName.trim(), $scope.tokenId, $scope.visitorId).then(function () {
            return location.reload();
        });
    };

    $scope.deleteFolder = function (id, folderName) {

        $('#modalConfirmHeader').html('DELETING FOLDER');
        $('#modalConfirmText').html('Are you sure you want to delete this folder - ' + folderName + '?');

        var deleteItemCallback = function deleteItemCallback() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                FSPDocumentTreeService.deleteFolder($scope.fspId, _this.id, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    // ********* F I L E  F U N C T I O N S **********

    $scope.clickFile = function (fileId) {

        $('a[id ^= "viewFile"]').each(function () {
            $(this).hide();
        });

        $('a[id ^= "deleteFile"]').each(function () {
            $(this).hide();
        });

        $('.doc').each(function () {
            $(this).removeClass('bold').removeClass('clicked-folder');
        });

        $('#viewFile' + fileId).show();

        if ($rootScope.isSuperAdmin) {
            $('#deleteFile' + fileId).show();
        }
        $('#' + fileId).addClass('bold').addClass('clicked-folder');
    };

    $scope.deleteFile = function (id, fileName) {

        $('#modalConfirmHeader').html('DELETING FILE');
        $('#modalConfirmText').html('Are you sure you want to delete this file - ' + fileName + '?');

        var deleteItemCallback = function deleteItemCallback() {
            var _this2 = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                FSPDocumentTreeService.deleteFile($scope.fspId, _this2.id, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.viewFile = function (url) {
        console.log(url);
        window.open(url);
    };

    // ********* T R E E  S T R U C T U R E  F U N C T I O N S **********

    function retrieveFSPFolders() {

        return $q(function (resolve, reject) {

            FSPDocumentTreeService.getFolders($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (folders) {

                $scope.folders = folders.data.fsp_document_folders;

                $scope.selectedFolderId = null;
                $scope.addFolderOrFile = false;
                $scope.newSubfolder = '';
                $scope.html = '<ul role="tree" aria-labelledby="tree1">';

                var parentFolders = $scope.folders.filter(function (folder) {
                    return folder.fsp_document_folder === null;
                }); //get all top-level folders

                parentFolders.sort(function (a, b) {
                    var textA = a.title.toUpperCase();
                    var textB = b.title.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                for (var i = 0; i < parentFolders.length; i++) {
                    displayFolderAndFiles(parentFolders[i], 1, parentFolders.length, i + 1);
                }

                $scope.html += '</ul>';
                $scope.trustedHtml = $sce.trustAsHtml($scope.html);
                $scope.$applyAsync();

                resolve();
            }).catch(function (err) {
                reject(err);
            });
        });
    }

    function prepareTreeStructure() {
        $scope.processing = false;
        setTimeout(function () {

            var trees = document.querySelectorAll('[role="tree"]');

            for (var i = 0; i < trees.length; i++) {
                var t = new Tree(trees[i]);
                t.init();
            }

            var treeItems = document.querySelectorAll('[role="treeitem"]');

            for (var _i2 = 0; _i2 < treeItems.length; _i2++) {

                treeItems[_i2].addEventListener('click', function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                });
            }

            $('a[id ^= "addItem"]').each(function () {
                $(this).hide();
            });
            $('a[id ^= "deleteItem"]').each(function () {
                $(this).hide();
            });

            $('li[role="treeitem"]').each(function () {
                $(this).removeClass('bold');
            });
        }, 500);
    }

    function displayFolderAndFiles(folder, level, size, position) {

        var childFolders = retrieveChildFolders(folder); // retrieve sub directories of this directory

        childFolders.sort(function (a, b) {
            var textA = a.title.toUpperCase();
            var textB = b.title.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        $scope.html += '<li style="margin-left:' + level * 20 + 'px" \n                role="treeitem" \n                id="' + folder.id + '"\n                aria-level="' + level + '"\n                aria-setsize="' + size + '"\n                aria-posinset="' + position + '"\n                aria-expanded="' + (childFolders.length > 0 || folder.fsp_document_files.length > 0) + '">\n                <p id="caption' + folder.id + '" title="' + folder.title + '" \n                ondblclick="angular.element(document.getElementById(\'' + folder.id + '\')).scope().addFolder(' + folder.id + ')" \n                onclick="angular.element(document.getElementById(\'' + folder.id + '\')).scope().clickFolder(' + folder.id + ')"> ' + folder.title + '\n                \n                <a class="hidden directory_tree_action" id="deleteItem' + folder.id + '"href="#" \n                onclick="angular.element(document.getElementById(\'' + folder.id + '\')).scope().deleteFolder(' + folder.id + ', \'' + folder.title + '\')">\n                <i class="material-icons">delete</i></a>\n                \n                <a class="hidden directory_tree_action" id="editItem' + folder.id + '" href="#" \n                onclick="angular.element(document.getElementById(\'' + folder.id + '\')).scope().editFolder(' + folder.id + ', \'' + folder.title + '\')">\n                <i class="material-icons">edit</i></a>\n                                \n                <a class="hidden directory_tree_action" id="addItem' + folder.id + '" href="#" \n                onclick="angular.element(document.getElementById(\'' + folder.id + '\')).scope().addFolder(' + folder.id + ')">\n                <i class="material-icons">add</i></a>\n                \n                </p>';

        if (childFolders.length > 0 || folder.fsp_document_files.length > 0) {
            $scope.html += '<ul role="group">';
        }

        // invoke function recursively for each sub directory
        for (var i = 0; i < childFolders.length; i++) {
            displayFolderAndFiles(childFolders[i], level, childFolders.length, i + 1);
        }

        // display line for each file in this directory
        for (var j = 0; j < folder.fsp_document_files.length; j++) {

            var _file = folder.fsp_document_files[j];

            $scope.html += '<li role="treeitem" style="margin-left:' + level * 20 + 'px"\n                    aria-level="' + (level + 1) + '"\n                    id="' + _file.id + '"\n                    aria-setsize="' + folder.fsp_document_files.length + '"\n                    aria-posinset="' + (j + childFolders.length + 1) + '"\n                    ondblclick="angular.element(document.getElementById(\'' + _file.id + '\')).scope().viewFile(\'' + _file.url + '\')"\n                    class="doc" onclick="angular.element(document.getElementById(\'' + _file.id + '\')).scope().clickFile(' + _file.id + ')"> ' + _file.title + '\n                    \n                    <a class="hidden directory_tree_action" id="deleteFile' + _file.id + '" href="#" \n                    onclick="angular.element(document.getElementById(\'' + _file.id + '\')).scope().deleteFile(' + _file.id + ', \'' + _file.title + '\')">\n                    <i class="material-icons">delete</i></a>\n                    \n                    <a class="hidden directory_tree_action" id="viewFile' + _file.id + '" href="#" \n                    onclick="angular.element(document.getElementById(\'' + _file.id + '\')).scope().viewFile(\'' + _file.url + '\')">\n                    <i class="material-icons">visibility</i></a>\n                    \n                    </li>';
        }

        if (childFolders.length > 0 || folder.fsp_document_files.length > 0) {
            $scope.html += '</ul>';
        }

        $scope.html += '</li>';
    }

    function retrieveChildFolders(parent) {
        return $scope.folders.filter(function (folder) {
            return folder.fsp_document_folder == parent.id;
        });
    }
});
'use strict';

angular.module('ics').factory('FSPDocumentTreeService', function ($http) {

    return {

        getFolders: function getFolders(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_document_folder/' + fspId + '/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createFolder: function createFolder(fspId, folderId, title, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_document_folder/' + fspId + '/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    title: title,
                    fsp_parent_document_folder_id: folderId || null
                }
            };

            return $http(req);
        },

        editFolder: function editFolder(fspId, folderId, title, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_document_folder/' + fspId + '/' + folderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    title: title
                }
            };

            return $http(req);
        },

        deleteFolder: function deleteFolder(fspId, folderId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_document_folder/' + fspId + '/' + folderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createFile: function createFile(fspId, folderId, title, url, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_document_file/' + fspId + '/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp_document_folder_id: folderId,
                    title: title,
                    url: url
                }
            };

            return $http(req);
        },

        editFile: function editFile(fspId, fileId, title, url, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_document_file/' + fspId + '/' + fileId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    title: title,
                    url: url
                }
            };

            return $http(req);
        },

        deleteFile: function deleteFile(fspId, fileId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_document_file/' + fspId + '/' + fileId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSBSubmissionDatesAdminController', function ($scope, $state, $controller, $timeout, FSBSubmissionDatesService, CategoriesService, FirebaseAuthService) {
    var retrieveSubmissionDates = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var res, res2, res3;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;


                            $scope.processing = true;
                            $scope.editing = false;
                            $scope.adding = false;

                            _context.next = 6;
                            return FSBSubmissionDatesService.getSubmissionDatesList($scope.fspId, $scope.tokenId, $scope.visitorId);

                        case 6:
                            res = _context.sent;


                            $scope.submission_dates = res.data.fsb_submission_dates;
                            $scope.submission_dates.forEach(function (date) {
                                date.submissions.forEach(function (submission) {
                                    submission.submission_date = new Date(submission.submission_date);
                                });
                                date.submissions.sort(function (a, b) {
                                    return b.submission_date.getTime() - a.submission_date.getTime();
                                });
                            });
                            $scope.processing = false;

                            _context.next = 12;
                            return CategoriesService.getCategoriesListFromCode('SUB', $scope.tokenId, $scope.visitorId);

                        case 12:
                            res2 = _context.sent;

                            $scope.submission_types = res2.data.categories;

                            $scope.submission_types.sort(function (a, b) {
                                return a.name.toUpperCase() - b.name.toUpperCase();
                            });

                            _context.next = 17;
                            return FSBSubmissionDatesService.getSubmissionRemindersEmailList($scope.tokenId, $scope.visitorId);

                        case 17:
                            res3 = _context.sent;

                            $scope.email_templates = res3.data.templates;

                            $scope.processing = false;
                            $timeout(function () {

                                // let $dateInput = $ ('#new_submission_date').pickadate ({
                                //     selectMonths: true, // Creates a dropdown to control month
                                //     selectYears: 100, // Creates a dropdown of 100 years to control year
                                //     format: "yyyy-mm-dd"
                                // });
                                //
                                // let datePicker = $dateInput.pickadate ('picker');
                                // datePicker.set ('select', new Date ());

                                $('select').material_select();
                            });

                            _context.next = 26;
                            break;

                        case 23:
                            _context.prev = 23;
                            _context.t0 = _context['catch'](0);

                            $scope.checkErrStatus(_context.t0);

                        case 26:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 23]]);
        }));

        return function retrieveSubmissionDates() {
            return _ref.apply(this, arguments);
        };
    }();

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.submission_types = [];
    var now = new Date();

    $scope.submission_date = {
        id: 0,
        submission_type: null,
        submissions: [],
        submissions_to_delete: [],
        due_date_day: now.getDate(),
        due_date_month: now.getMonth(),
        is_recurring: '',
        frequency: '',
        send_email_reminder: '',
        reminder_date: new Date(),
        email_reminder_to: 'submissions@complianceservices.co.za',
        email_reminder_subject: '',
        email_reminder_body: '',
        due_date_year: now.getFullYear(),
        is_submitted: false,
        email_template: null,
        notes: ''
    };

    $scope.editing = false;
    $scope.adding = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - Deadlines and Submissions';
    $scope.processing = true;

    $scope.days = [];
    for (var i = 1; i <= 31; i++) {
        $scope.days.push(i);
    }$scope.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    $scope.years = [];
    for (var _i = now.getFullYear() - 20; _i <= now.getFullYear() + 5; _i++) {
        $scope.years.push(_i);
    }angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveSubmissionDates();

        setTimeout(function () {
            $(document).ready(function () {
                $('select').material_select();
            });
        }, 500);
    };

    $scope.submitSubmissionDateForm = function ($form) {
        if ($form.$valid) {
            $scope.saveSubmissionDate();
        }
    };

    $scope.submitSubmissionForm = function ($form) {
        if ($form.$valid) {
            $scope.saveSubmission();
        }
    };

    $scope.editSubmissionDate = function (index) {
        $scope.title = 'Edit Submission Date';

        $scope.submission_date = Object.assign({}, $scope.submission_dates[index]);

        $scope.submission_date.submission_type = $scope.submission_date.submission_type.id.toString();
        $scope.submission_date.due_date_day = $scope.submission_date.due_date_day.toString();
        $scope.submission_date.due_date_month = $scope.submission_date.due_date_month.toString();
        $scope.submission_date.due_date_year = $scope.submission_date.due_date_year ? $scope.submission_date.due_date_year.toString() : now.getFullYear().toString();
        $scope.submission_date.is_submitted = !!$scope.submission_date.is_submitted;
        $scope.submission_date.notes = $scope.submission_date.notes || '';
        $scope.submission_date.submissions_to_delete = [];
        $scope.submission_date.reminder_date = $scope.submission_date.reminder_date ? new Date($scope.submission_date.reminder_date) : new Date();
        $scope.submission_date.email_template = $scope.submission_date.email_template ? $scope.submission_date.email_template.id.toString() : null;

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
        $scope.adding = false;
    };

    $scope.addSubmissionDate = function () {
        $scope.title = 'Add submission date';

        $scope.submission_date = {
            id: 0,
            submission_type: null,
            submissions: [],
            submissions_to_delete: [],
            due_date_day: now.getDate().toString(),
            due_date_month: now.getMonth().toString(),
            due_date_year: now.getFullYear().toString(),
            is_recurring: true,
            is_submitted: false,
            send_email_reminder: true,
            reminder_date: new Date(),
            email_reminder_to: 'submissions@complianceservices.co.za',
            email_reminder_subject: '',
            email_reminder_body: '',
            notes: '',
            frequency: '',
            email_template: null
        };
        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
        $scope.adding = false;
    };

    $scope.addSubmission = function (id, $index) {
        $scope.selectedSubmission = $scope.submission_dates[$index];
        $scope.new_submission_date = new Date();
        $scope.new_submission_extension_granted = false;

        $scope.editing = false;
        $scope.adding = true;
    };

    $scope.goBack = function () {
        if ($scope.editing) {
            $scope.editing = false;
        } else {
            $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
        }
    };

    $scope.saveSubmissionDate = function () {

        if (!$scope.submission_date.submission_type) {
            return;
        }

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.submission_date.reminder_date = $('#reminder_date').val();
            if ($scope.submission_date.send_email_reminder) {
                if (Math.abs(moment(new Date($scope.submission_date.reminder_date)).diff(moment(), 'years')) > 100) {
                    return alert('The reminder date appears to be incorrect!');
                }
            }

            $scope.processing = true;

            if ($scope.submission_date.id) {

                FSBSubmissionDatesService.editSubmissionDate($scope.submission_date.id, $scope.submission_date.submission_type, $scope.submission_date.submissions_to_delete, $scope.submission_date.due_date_day, $scope.submission_date.due_date_month, $scope.submission_date.is_recurring, $scope.submission_date.send_email_reminder, $scope.submission_date.reminder_date, $scope.submission_date.email_reminder_to, $scope.submission_date.email_reminder_subject, $scope.submission_date.email_reminder_body, $scope.submission_date.due_date_year, $scope.submission_date.is_submitted, $scope.submission_date.notes, $scope.submission_date.email_template, $scope.submission_date.frequency, tokenId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSBSubmissionDatesService.createSubmissionDate($scope.fspId, $scope.submission_date.submission_type, $scope.submission_date.due_date_day, $scope.submission_date.due_date_month, $scope.submission_date.is_recurring, $scope.submission_date.send_email_reminder, $scope.submission_date.reminder_date, $scope.submission_date.email_reminder_to, $scope.submission_date.email_reminder_subject, $scope.submission_date.email_reminder_body, $scope.submission_date.due_date_year, $scope.submission_date.is_submitted, $scope.submission_date.notes, $scope.submission_date.email_template, $scope.submission_date.frequency, tokenId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.saveSubmission = function () {

        if (!$scope.selectedSubmission) return;

        FSBSubmissionDatesService.addSubmissionOnDate($scope.selectedSubmission.id, $('#new_submission_date').val(), $scope.new_submission_extension_granted, $scope.tokenId, $scope.visitorId).then(function (res) {
            location.reload();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.adding = false;
        $scope.title = $scope.fspName + ' - administer submission dates';
    };

    $scope.deleteSubmissionDate = function (fsbSubmissionDateId, index) {

        $('#modalConfirmHeader').html('DELETING SUBMISSION DATE');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSBSubmissionDatesService.deleteSubmissionDate(this.fsbSubmissionDateId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ fsbSubmissionDateId: fsbSubmissionDateId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.deleteSubmission = function (id, $index) {

        if (!$scope.submission_date.submissions_to_delete) {
            $scope.submission_date.submissions_to_delete = [id];
        } else {
            $scope.submission_date.submissions_to_delete.push(id);
        }

        $scope.submission_date.submissions.splice($index, 1);
    };
});
'use strict';

angular.module('ics').factory('FSBSubmissionDatesService', function ($http) {

    return {

        getSubmissionDatesList: function getSubmissionDatesList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsb_submission_dates_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createSubmissionDate: function createSubmissionDate(fspId, submission_type, due_date_day, due_date_month, is_recurring, send_email_reminder, reminder_date, email_reminder_to, email_reminder_subject, email_reminder_body, due_date_year, is_submitted, notes, email_template, frequency, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsb_sub_date/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    submission_type: submission_type,
                    due_date_day: due_date_day,
                    due_date_month: due_date_month,
                    is_recurring: is_recurring,
                    send_email_reminder: send_email_reminder,
                    reminder_date: reminder_date,
                    email_reminder_to: email_reminder_to,
                    email_reminder_subject: email_reminder_subject,
                    email_reminder_body: email_reminder_body,
                    due_date_year: due_date_year,
                    is_submitted: is_submitted,
                    notes: notes,
                    email_template: email_template,
                    frequency: frequency
                }
            };

            return $http(req);
        },

        editSubmissionDate: function editSubmissionDate(fsbSubmissionDateId, submission_type, submissions_to_delete, due_date_day, due_date_month, is_recurring, send_email_reminder, reminder_date, email_reminder_to, email_reminder_subject, email_reminder_body, due_date_year, is_submitted, notes, email_template, frequency, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsb_sub_date/' + fsbSubmissionDateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    submissions: submissions_to_delete,
                    submission_type: submission_type,
                    due_date_day: due_date_day,
                    due_date_month: due_date_month,
                    is_recurring: is_recurring,
                    send_email_reminder: send_email_reminder,
                    reminder_date: reminder_date,
                    email_reminder_to: email_reminder_to,
                    email_reminder_subject: email_reminder_subject,
                    email_reminder_body: email_reminder_body,
                    due_date_year: due_date_year,
                    is_submitted: is_submitted,
                    notes: notes,
                    email_template: email_template,
                    frequency: frequency
                }
            };

            return $http(req);
        },

        deleteSubmissionDate: function deleteSubmissionDate(fsbSubmissionDateId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsb_sub_date/' + fsbSubmissionDateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        addSubmissionOnDate: function addSubmissionOnDate(submission_date_id, submission_date, extension_granted, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsb_sub_add',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    submission_date_id: submission_date_id,
                    submission_date: submission_date,
                    extension_granted: extension_granted
                }
            };

            return $http(req);
        },

        getSubmissionRemindersEmailList: function getSubmissionRemindersEmailList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsca_submission_reminder_email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSPKeyIndividualsAdminController', function ($scope, $state, $controller, $timeout, FSPKeyIndividualsService, CategoriesService, SubCategoriesService, FirebaseAuthService, FirebaseStorageService) {
    var _this = this;

    var init = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return retrieveKeyIndividuals();

                        case 2:

                            setTimeout(function () {
                                $(document).ready(function () {

                                    var docUploadControl = document.getElementById("documentUpload");

                                    var fileDetails = {
                                        folder: '/fsp_key_individual_attachments/' + $scope.fspId,
                                        attachments: $scope.key_individual.attachments
                                    };

                                    var eventDelegator = $scope.fileUploader.bind(fileDetails);
                                    docUploadControl.addEventListener('change', eventDelegator);

                                    $scope.$on('filesUploaded', function (event, attachments) {
                                        var combined = new Set($scope.key_individual.attachments.concat(attachments));
                                        $scope.key_individual.attachments = [].concat(_toConsumableArray(combined));
                                        $scope.$apply();
                                    });
                                });
                            }, 1000);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function init() {
            return _ref2.apply(this, arguments);
        };
    }();

    var retrieveKeyIndividuals = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var res, res1, res2, res3, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, category, subCategoriesRes, subClassesOfBusiness;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;


                            $scope.processing = true;
                            $scope.editing = false;

                            _context3.next = 5;
                            return FSPKeyIndividualsService.getKeyIndividualsList($scope.fspId, $scope.tokenId, $scope.visitorId);

                        case 5:
                            res = _context3.sent;


                            $scope.key_individuals = res.data.key_individuals;

                            $scope.key_individuals.forEach(function (key_individual) {
                                key_individual.attachments.sort(function (a, b) {
                                    var textA = a.file_name.toUpperCase();
                                    var textB = b.file_name.toUpperCase();
                                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                                });
                            });

                            _context3.next = 10;
                            return CategoriesService.getCategoriesListFromCode('licencing_categories', $scope.tokenId, $scope.visitorId);

                        case 10:
                            res1 = _context3.sent;

                            $scope.licensingCategories = res1.data.categories;

                            $scope.licensingCategories.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                return item.selected = false;
                            });

                            _context3.next = 15;
                            return CategoriesService.getCategoriesListFromCode('financial_products', $scope.tokenId, $scope.visitorId);

                        case 15:
                            res2 = _context3.sent;

                            $scope.financialProducts = res2.data.categories;

                            $scope.financialProducts.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                return item.selected = false;
                            });

                            _context3.next = 20;
                            return CategoriesService.getCategoriesListFromCode('COB', $scope.tokenId, $scope.visitorId);

                        case 20:
                            res3 = _context3.sent;

                            $scope.classesOfBusiness = res3.data.categories;

                            $scope.classesOfBusiness.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                item.selected = false;
                                item.subClasses = [];
                            });

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context3.prev = 26;
                            _iterator = $scope.classesOfBusiness[Symbol.iterator]();

                        case 28:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context3.next = 40;
                                break;
                            }

                            category = _step.value;
                            _context3.next = 32;
                            return SubCategoriesService.getSubCategoriesList(category.id, $scope.tokenId, $scope.visitorId);

                        case 32:
                            subCategoriesRes = _context3.sent;
                            subClassesOfBusiness = [];

                            subClassesOfBusiness = subClassesOfBusiness.concat(subCategoriesRes.data.sub_categories || []);
                            subClassesOfBusiness.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                return item.selected = false;
                            });
                            category.subClasses = subClassesOfBusiness || [];

                        case 37:
                            _iteratorNormalCompletion = true;
                            _context3.next = 28;
                            break;

                        case 40:
                            _context3.next = 46;
                            break;

                        case 42:
                            _context3.prev = 42;
                            _context3.t0 = _context3['catch'](26);
                            _didIteratorError = true;
                            _iteratorError = _context3.t0;

                        case 46:
                            _context3.prev = 46;
                            _context3.prev = 47;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 49:
                            _context3.prev = 49;

                            if (!_didIteratorError) {
                                _context3.next = 52;
                                break;
                            }

                            throw _iteratorError;

                        case 52:
                            return _context3.finish(49);

                        case 53:
                            return _context3.finish(46);

                        case 54:

                            $timeout(function () {
                                $('select').material_select();
                            });

                            $scope.processing = false;

                            _context3.next = 61;
                            break;

                        case 58:
                            _context3.prev = 58;
                            _context3.t1 = _context3['catch'](0);

                            $scope.checkErrStatus(_context3.t1);

                        case 61:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 58], [26, 42, 46, 54], [47,, 49, 53]]);
        }));

        return function retrieveKeyIndividuals() {
            return _ref3.apply(this, arguments);
        };
    }();

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.category_of_licensing = null;

    $scope.licensingCategories = [];
    $scope.financialProducts = [];
    $scope.classesOfBusiness = [];
    $scope.subClassesOfBusiness = [];
    $scope.key_individuals = [];

    $scope.key_individual = {
        id: 0,
        first_name: '',
        last_name: '',
        id_number: '',
        categories_of_licensing: [],
        financial_products: [],
        date_appointed: new Date(),
        classes_of_business: [],
        sub_classes_of_business: [],
        attachments: [],
        passed_re1: false,
        passed_re3: false,
        passed_re5: false,
        has_qualification: false,
        qualification_code: '',
        qualification_name: ''
    };

    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer key individuals';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tokenId) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            $scope.tokenId = tokenId;
                            _context.next = 3;
                            return init();

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }());

    $scope.editKeyIndividual = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit key individual';

        var key_individual = $scope.key_individuals[index];

        $scope.licensingCategories.forEach(function (item) {
            return item.selected = false;
        });
        $scope.financialProducts.forEach(function (item) {
            return item.selected = false;
        });
        $scope.classesOfBusiness.forEach(function (item) {
            item.selected = false;
            item.subClasses.forEach(function (item2) {
                return item2.selected = false;
            });
        });

        key_individual.categories_of_licensing.forEach(function (item) {
            var licensingCategory = $scope.licensingCategories.find(function (category) {
                return category.id === item.id;
            });
            if (licensingCategory) {
                licensingCategory.selected = true;
            }
        });

        key_individual.financial_products.forEach(function (item) {
            var financialProduct = $scope.financialProducts.find(function (product) {
                return product.id === item.id;
            });
            if (financialProduct) {
                financialProduct.selected = true;
            }
        });

        key_individual.classes_of_business.forEach(function (item) {
            var classOfBusiness = $scope.classesOfBusiness.find(function (businessClass) {
                return businessClass.id === item.id;
            });
            if (classOfBusiness) {
                classOfBusiness.selected = true;

                (key_individual.sub_classes_of_business || []).forEach(function (item) {

                    var subClassOfBusiness = classOfBusiness.subClasses.find(function (businessClass) {
                        return businessClass.id === item.id;
                    });
                    if (subClassOfBusiness) {
                        subClassOfBusiness.selected = true;
                    }
                });
            }
        });

        $scope.key_individual = {
            id: key_individual.id,
            first_name: key_individual.first_name,
            last_name: key_individual.last_name,
            id_number: key_individual.id_number,
            date_appointed: new Date(key_individual.date_appointed),
            attachments: key_individual.attachments,
            passed_re1: key_individual.passed_re1 || false,
            passed_re3: key_individual.passed_re3 || false,
            passed_re5: key_individual.passed_re5 || false,
            has_qualification: key_individual.has_qualification || false,
            qualification_code: key_individual.qualification_code || '',
            qualification_name: key_individual.qualification_name || ''
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
    };

    $scope.addKeyIndividual = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add key individual';

        $scope.licensingCategories.forEach(function (item) {
            return item.selected = false;
        });
        $scope.financialProducts.forEach(function (item) {
            return item.selected = false;
        });
        $scope.classesOfBusiness.forEach(function (item) {
            item.selected = false;
            (item.subClasses || []).forEach(function (item2) {
                return item2.selected = false;
            });
        });

        $scope.key_individual = {
            id: 0,
            first_name: '',
            last_name: '',
            id_number: '',
            date_appointed: new Date(),
            attachments: [],
            classes_of_business: [],
            sub_classes_of_business: [],
            passed_re1: false,
            passed_re3: false,
            passed_re5: false,
            has_qualification: false,
            qualification_code: '',
            qualification_name: ''
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer key individuals';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.submitForm = function ($form) {

        if ($form.$valid) {
            $scope.saveKeyIndividual();
        }
    };

    $scope.saveKeyIndividual = function () {

        try {

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                $scope.processing = true;
                $scope.key_individual.date_appointed = $('#date_appointed').val();

                var dateYear = new Date($scope.key_individual.date_appointed).getFullYear();
                if (dateYear < 1900) {
                    $scope.errorMessage = 'Please ensure all dates are valid (i.e. after 1900)';
                    $scope.processing = false;
                    $scope.$applyAsync();
                    return;
                }

                var selectedLicensingCategories = $scope.licensingCategories.filter(function (item) {
                    return item.selected === true;
                }).map(function (item) {
                    return item.id;
                });

                var selectedFinancialProducts = $scope.financialProducts.filter(function (item) {
                    return item.selected === true;
                }).map(function (item) {
                    return item.id;
                });

                var selectedClassesOfBusiness = $scope.classesOfBusiness.filter(function (item) {
                    return item.selected === true;
                }).map(function (item) {
                    return item.id;
                });

                var selectedSubClassesOfBusiness = [];
                $scope.classesOfBusiness.filter(function (item) {
                    return item.selected === true;
                }).forEach(function (cob) {
                    selectedSubClassesOfBusiness = selectedSubClassesOfBusiness.concat(cob.subClasses.filter(function (item) {
                        return item.selected === true;
                    }).map(function (item) {
                        return item.id;
                    }));
                });

                if ($scope.key_individual.id) {

                    FSPKeyIndividualsService.editKeyIndividual($scope.key_individual.id, $scope.key_individual.first_name, $scope.key_individual.last_name, $scope.key_individual.id_number, $scope.key_individual.date_appointed, selectedLicensingCategories, selectedFinancialProducts, selectedClassesOfBusiness, selectedSubClassesOfBusiness, $scope.key_individual.attachments, $scope.key_individual.passed_re1, $scope.key_individual.passed_re3, $scope.key_individual.passed_re5, $scope.key_individual.has_qualification, $scope.key_individual.qualification_code, $scope.key_individual.qualification_name, tokenId, $scope.visitorId).then(function () {
                        return location.reload();
                    }).catch(function (err) {
                        return $scope.checkErrStatus(err);
                    });
                } else {

                    FSPKeyIndividualsService.createKeyIndividual($scope.fspId, $scope.key_individual.first_name, $scope.key_individual.last_name, $scope.key_individual.id_number, $scope.key_individual.date_appointed, selectedLicensingCategories, selectedFinancialProducts, selectedClassesOfBusiness, selectedSubClassesOfBusiness, $scope.key_individual.attachments, $scope.key_individual.passed_re1, $scope.key_individual.passed_re3, $scope.key_individual.passed_re5, $scope.key_individual.has_qualification, $scope.key_individual.qualification_code, $scope.key_individual.qualification_name, tokenId, $scope.visitorId).then(function () {
                        return location.reload();
                    }).catch(function (err) {
                        return $scope.checkErrStatus(err);
                    });
                }
            });
        } catch (e) {
            $scope.checkErrStatus(e);
        }
    };

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer key individuals';
    };

    $scope.deleteKeyIndividual = function (keyIndividualId, index) {

        $('#modalConfirmHeader').html('DELETING KEY INDIVIDUAL');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPKeyIndividualsService.deleteKeyIndividual(this.keyIndividualId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ keyIndividualId: keyIndividualId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPKeyIndividualsService', function ($http) {

    return {

        getKeyIndividualsList: function getKeyIndividualsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_key_individual_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createKeyIndividual: function createKeyIndividual(fspId, first_name, last_name, id_number, date_appointed, categories_of_licensing, financial_products, classes_of_business, sub_classes_of_business, attachments, passed_re1, passed_re3, passed_re5, has_qualification, qualification_code, qualification_name, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_key_individual/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    categories_of_licensing: categories_of_licensing,
                    financial_products: financial_products,
                    classes_of_business: classes_of_business,
                    sub_classes_of_business: sub_classes_of_business,
                    passed_re1: passed_re1,
                    passed_re3: passed_re3,
                    passed_re5: passed_re5,
                    has_qualification: has_qualification,
                    qualification_code: qualification_code,
                    qualification_name: qualification_name,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editKeyIndividual: function editKeyIndividual(fspKeyIndividualId, first_name, last_name, id_number, date_appointed, categories_of_licensing, financial_products, classes_of_business, sub_classes_of_business, attachments, passed_re1, passed_re3, passed_re5, has_qualification, qualification_code, qualification_name, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_key_individual/' + fspKeyIndividualId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    categories_of_licensing: categories_of_licensing,
                    financial_products: financial_products,
                    classes_of_business: classes_of_business,
                    sub_classes_of_business: sub_classes_of_business,
                    passed_re1: passed_re1,
                    passed_re3: passed_re3,
                    passed_re5: passed_re5,
                    has_qualification: has_qualification,
                    qualification_code: qualification_code,
                    qualification_name: qualification_name,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteKeyIndividual: function deleteKeyIndividual(fspKeyIndividualId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_key_individual/' + fspKeyIndividualId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FSPFollowUpProfileChangeController', function ($scope, $state, $controller, $timeout, FSPService, CategoriesService, FollowUpEmailTemplatesService, FirebaseAuthService, FirebaseStorageService) {

    $scope.profileChangeId = '';
    $scope.fspId = '';
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.profileChangeStatusCategories = [];
    $scope.processing = false;
    $scope.emailTemplatesFullList = [];
    $scope.emailTemplates = [];
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $(document).ready(function () {

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            $scope.tokenId = tokenId;
            $scope.processing = true;

            $scope.profileChangeId = $state.params.profile_change_id;
            $scope.fspId = $state.params.fsp_id;

            FirebaseAuthService.getUserToken().then(function () {

                FSPService.GetFSPChangeDetails($scope.profileChangeId, $scope.tokenId, $scope.visitorId).then(function (response) {

                    $scope.fspChangeDetails = response.data.status_change;
                    $scope.fspChangeDetails.follow_up_yn = false;
                    $scope.fspChangeDetails.follow_up_on = $scope.fspChangeDetails.follow_up_on ? new Date($scope.fspChangeDetails.follow_up_on) : new Date();

                    $timeout(function () {
                        $('textarea').trigger('autoresize');
                        $('#email_body').trigger('autoresize');
                    });

                    $scope.processing = false;

                    // let $followedUpDateInput = $('#followed_up_date').pickadate({
                    //     selectMonths: true, // Creates a dropdown to control month
                    //     selectYears: 20, // Creates a dropdown of 20 years to control year
                    //     format: "yyyy-mm-dd"
                    // });
                    //
                    // let datePicker = $followedUpDateInput.pickadate('picker');
                    // datePicker.set('select', new Date($scope.fspChangeDetails.follow_up_on));

                    CategoriesService.getCategoriesListFromCode('profile_change_status', $scope.tokenId, $scope.visitorId).then(function (res) {
                        $scope.profileChangeStatusCategories = res.data.categories;
                        $timeout(function () {
                            $('select').material_select();
                        });
                    });

                    FollowUpEmailTemplatesService.getFollowUpEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {

                        response.data.follow_up_email_templates.forEach(function (template) {

                            template.profile_change_types.forEach(function (changeType) {
                                if (parseInt(changeType.id, 10) === parseInt($scope.fspChangeDetails.type.id)) {

                                    $scope.emailTemplatesFullList.push(template);
                                    $scope.emailTemplates.push(template);
                                }
                            });
                        });

                        $timeout(function () {
                            $('select').material_select();
                        });
                    });

                    var docUploadControl = document.getElementById("documentUpload");

                    docUploadControl.addEventListener('change', function (e) {
                        var file = e.target.files[0];
                        if (!file || !file.name) return;
                        $('.file-field #uploading-document').removeClass('ng-hide');
                        $('.file-field .btn').addClass('ng-hide');
                        FirebaseStorageService.uploadFileToCloudStorage("/fsp_profile_change_attachments/", file, null).then(function (storageInfo) {
                            $('.file-field #uploading-document').addClass('ng-hide');
                            $('.file-field .btn').removeClass('ng-hide');
                            $scope.fspChangeDetails.attachments.push({
                                file_url: storageInfo.downloadUrl,
                                file_name: file.name,
                                attach_to_email: true,
                                id: ''
                            });
                            $scope.$apply();
                        }, function (errMessage) {
                            $('.file-field #uploading-document').addClass('ng-hide');
                            $('.file-field .btn').removeClass('ng-hide');
                            console.log(errMessage);
                            alert("An error occurred, please try again");
                            $scope.processing = false;
                        });
                    });
                });
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    });

    $scope.selectEmailTemplate = function () {
        $scope.email_subject = '';
        $scope.email_body = '';

        $scope.emailTemplates.forEach(function (template) {
            if (template.id === $scope.email_template) {
                $scope.email_subject = template.email_subject;
                $scope.email_body = template.email_body;
                $timeout(function () {
                    $('textarea').trigger('autoresize');
                    $('#email_body').trigger('autoresize');
                }, 500);
            }
        });
    };

    $scope.sendEmail = function () {

        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.followed_up_date = $('#followed_up_date').val();

            FSPService.followUpFSPProfileChange($scope.fspId, $scope.fspChangeDetails.id, $scope.fspChangeDetails.status.id, $scope.fspChangeDetails.follow_up_yn, $scope.followed_up_date, $scope.fspChangeDetails.description, $scope.fspChangeDetails.attachments, $scope.email_subject, $scope.email_body, $scope.fspChangeDetails.email_body, tokenId, $scope.visitorId).then(function () {

                $scope.processing = false;

                $('#modalInfoHeader').html('Thank you');
                $('#modalInfoText').html('The follow up has been submitted.');
                $('#information_modal').modal('open');

                setTimeout(function () {
                    $('#information_modal').modal('close');
                    $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
                }, 2000);
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        });
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPProfileChangeDetailsController', function ($scope, $state, $controller, $timeout, FSPService, CategoriesService, FirebaseAuthService, FirebaseStorageService) {

    $scope.profileChangeId = '';
    $scope.fspId = '';
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.profileChangeStatusCategories = [];
    $scope.processing = false;
    $scope.verify_email_send = false;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $(document).ready(function () {

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            $scope.tokenId = tokenId;
            $scope.processing = true;

            $scope.profileChangeId = $state.params.profile_change_id;
            $scope.fspId = $state.params.fsp_id;

            FSPService.GetFSPChangeDetails($scope.profileChangeId, $scope.tokenId, $scope.visitorId).then(function (response) {

                $scope.fspChangeDetails = response.data.status_change;
                $scope.logs = response.data.logs || [];
                $scope.processing = false;
                $scope.fspChangeDetails.follow_up_on = $scope.fspChangeDetails.follow_up_on ? new Date($scope.fspChangeDetails.follow_up_on) : new Date();
                $scope.fspChangeDetails.submission_date = $scope.fspChangeDetails.submission_date ? new Date($scope.fspChangeDetails.submission_date) : new Date();
                $scope.fspChangeDetails.implemented_on = $scope.fspChangeDetails.implemented_on ? new Date($scope.fspChangeDetails.implemented_on) : new Date();
                $scope.fspChangeDetails.notes = $scope.fspChangeDetails.notes || '';

                $scope.fspChangeDetails.followed_up_with_fsp_yn = !!$scope.fspChangeDetails.followed_up_with_fsp_yn;
                $scope.fspChangeDetails.followed_up_with_fsca_yn = !!$scope.fspChangeDetails.followed_up_with_fsca_yn;
                $scope.fspChangeDetails.followed_up_with_fsp_on = $scope.fspChangeDetails.followed_up_with_fsp_on ? new Date($scope.fspChangeDetails.followed_up_with_fsp_on) : new Date();
                $scope.fspChangeDetails.followed_up_with_fsca_on = $scope.fspChangeDetails.followed_up_with_fsca_on ? new Date($scope.fspChangeDetails.followed_up_with_fsca_on) : new Date();

                CategoriesService.getCategoriesListFromCode('profile_change_status', $scope.tokenId, $scope.visitorId).then(function (res) {
                    $scope.profileChangeStatusCategories = res.data.categories;
                    $timeout(function () {
                        $('select').material_select();
                    });
                });

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: "/fsp_profile_change_attachments/",
                    attachments: $scope.fspChangeDetails.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    console.log(attachments);
                    var combined = new Set($scope.fspChangeDetails.attachments.concat(attachments));
                    $scope.fspChangeDetails.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    });

    $scope.saveChanges = function () {

        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.followed_up_date = $('#followed_up_date').val();
            $scope.submission_date = $('#submission_date').val();
            $scope.implemented_on = $('#implemented_on').val();
            $scope.followed_up_with_fsp_on = $('#followed_up_with_fsp_on').val();
            $scope.followed_up_with_fsca_on = $('#followed_up_with_fsca_on').val();

            FSPService.editFSPProfileChange($scope.fspId, $scope.fspChangeDetails.id, $scope.fspChangeDetails.status.id, $scope.fspChangeDetails.follow_up_yn, $scope.followed_up_date, $scope.fspChangeDetails.implemented_yn, $scope.implemented_on, $scope.fspChangeDetails.submitted_yn, $scope.submission_date, $scope.fspChangeDetails.description, $scope.fspChangeDetails.notes || '', $scope.fspChangeDetails.attachments, $scope.fspChangeDetails.email_subject, $scope.fspChangeDetails.email_body, $scope.verify_email_send, $scope.fspChangeDetails.followed_up_with_fsp_yn, $scope.followed_up_with_fsp_on, $scope.fspChangeDetails.followed_up_with_fsca_yn, $scope.followed_up_with_fsca_on, tokenId, $scope.visitorId).then(function () {

                $scope.processing = false;

                $('#modalInfoHeader').html('Thank you');
                $('#modalInfoText').html($scope.verify_email_send ? 'The profile change has been saved, and emails sent.' : 'The profile change has been saved.');
                $('#information_modal').modal('open');

                setTimeout(function () {
                    $('#information_modal').modal('close');
                    $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
                }, 2000);
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitProfileChanges = function () {
        $state.transitionTo('admin-fbp-submit-profile-change', {
            fsp_id: $scope.fspId,
            profile_change_id: $scope.profileChangeId
        });
    };

    $scope.deleteProfileChange = function () {

        $('#modalConfirmHeader').html('DELETING PROFILE CHANGE');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPService.deleteFSPProfileChange(this.profileChangeId, $scope.tokenId, $scope.visitorId).then(function () {
                return $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ profileChangeId: $scope.profileChangeId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPProfileChangeController', function ($scope, $state, $controller, $timeout, FSPService, CategoriesService, ComplianceDocumentsService, FirebaseAuthService, EmailTemplatesService) {

    $scope.fspId = '';
    $scope.errorMessage = '';
    $scope.followed_up_date = new Date();
    $scope.submission_date = new Date();
    $scope.attachments = [];
    $scope.email_subject = '';
    $scope.email_body = '';
    $scope.email_template = null;
    $scope.follow_up_yn = false;
    $scope.submitted_yn = false;
    $scope.email_send = true;
    $scope.tokenId = '';
    $scope.processing = true;
    $scope.verify_email_send = false;
    $scope.notes = '';

    $scope.implemented_yn = false;
    $scope.implemented_on = new Date();

    $scope.followed_up_with_fsp_yn = false;
    $scope.followed_up_with_fsp_on = new Date();

    $scope.followed_up_with_fsca_yn = false;
    $scope.followed_up_with_fsca_on = new Date();

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.processing = true;

        $scope.fspId = $state.params.fsp_id;

        FSPService.GetFSPDetails($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (response) {

            $scope.fspDetails = response.data.fsp;

            // let $followedUpDateInput = $('#followed_up_date').pickadate({
            //     selectMonths: true, // Creates a dropdown to control month
            //     selectYears: 20, // Creates a dropdown of 20 years to control year
            //     format: "yyyy-mm-dd"
            // });
            //
            // let $submissionDateInput = $('#submission_date').pickadate({
            //     selectMonths: true, // Creates a dropdown to control month
            //     selectYears: 20, // Creates a dropdown of 20 years to control year
            //     format: "yyyy-mm-dd"
            // });
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('profile_change_status', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeStatusCategories = res.data.categories;

                $scope.profileChangeStatusCategories.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                $timeout(function () {
                    $('select').material_select();
                });
            });
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('profile_change_type', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.profileChangeTypeCategories = res.data.categories;

                $scope.profileChangeTypeCategories.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                $timeout(function () {
                    $('select').material_select();
                });
            });
        }).then(function () {

            ComplianceDocumentsService.getFullDocumentTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
                $scope.documentTemplatesFullList = response.data.document_templates;
                $scope.documentTemplates = response.data.document_templates;

                $timeout(function () {
                    $('select').material_select();
                });
            });
        }).then(function () {

            EmailTemplatesService.getEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
                $scope.emailTemplatesFullList = response.data.email_templates;
                $scope.emailTemplates = response.data.email_templates;
                $scope.processing = false;

                $(document).ready(function () {

                    $('body').removeClass('bg-grey-1');

                    $timeout(function () {
                        $('select').material_select();
                        $('textarea').trigger('autoresize');

                        var docUploadControl = document.getElementById("documentUpload");

                        var fileDetails = {
                            folder: "/fsp_profile_change_attachments/",
                            attachments: $scope.attachments
                        };

                        var eventDelegator = $scope.fileUploader.bind(fileDetails);
                        docUploadControl.addEventListener('change', eventDelegator);

                        $scope.$on('filesUploaded', function (event, attachments) {
                            var combined = new Set($scope.attachments.concat(attachments));
                            $scope.attachments = [].concat(_toConsumableArray(combined));
                            $scope.$apply();
                        });
                    });
                });
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.selectEmailTemplate = function () {

        $scope.emailTemplates.forEach(function (template) {
            if (template.id === $scope.email_template) {
                $scope.email_subject = template.email_subject;
                $scope.email_body = template.email_body;
                $timeout(function () {
                    $('select').material_select();
                    $('textarea').trigger('autoresize');
                    $('#email_body').trigger('autoresize');
                }, 500);
            }
        });
    };

    $scope.backToDetailsPage = function () {
        $('body').addClass('bg-grey-1');
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.deleteAttachment = function (e, index) {

        e.preventDefault();
        $scope.attachments.splice(index, 1);
    };

    $scope.submitForm = function ($form) {

        if ($form.$valid) {

            if ($scope.verify_email_send) {

                $('#modalConfirmHeader').html('Please confirm');
                $('#modalConfirmText').html('Are you sure you want to email the client at this time?');
                $(document).ready(function () {
                    $('#modalAgreeLink').click(function () {
                        $scope.saveProfileChange();
                        $('#are_you_sure_modal').modal('close');
                    });
                    $('#are_you_sure_modal').modal('open');
                });
            } else {
                $scope.saveProfileChange();
            }
        }
    };

    $scope.changeProfileSettings = function () {

        $scope.documentTemplates = [];
        $scope.emailTemplates = [];

        var statusRecord = $scope.profileChangeStatusCategories.find(function (item) {
            return item.id == $scope.profile_change_status;
        });
        if (statusRecord && statusRecord.name.toLowerCase() === 'implemented') {
            $scope.implemented_yn = true;
        } else {
            $scope.implemented_yn = false;
        }

        if (!!$scope.documentTemplatesFullList && $scope.documentTemplatesFullList.length > 0) {

            $scope.documentTemplatesFullList.forEach(function (template) {

                for (var i = 0; i < template.profile_change_types.length; i++) {
                    if (template.profile_change_types[i].id === $scope.profile_change_type) {
                        $scope.documentTemplates.push(template);
                    }
                }
            });
        }

        var newTemplateList = [];
        if ($scope.emailTemplatesFullList && $scope.emailTemplatesFullList.length > 0) {
            $scope.emailTemplatesFullList.forEach(function (template) {

                for (var i = 0; i < template.profile_change_types.length; i++) {
                    if (template.profile_change_types[i].id === $scope.profile_change_type) {
                        newTemplateList.push(template);
                    }
                }
            });
        }

        $timeout(function () {
            $scope.emailTemplates = newTemplateList;

            $timeout(function () {
                $('select').material_select();
            });
            $scope.$applyAsync();
        }, 500);
    };

    $scope.removeDocumentTemplate = function (e, index) {

        e.preventDefault();
        $scope.documentTemplates.splice(index, 1);
        $scope.$applyAsync();
    };

    $scope.saveProfileChange = function () {

        var selected_attachments = [];

        $scope.documentTemplates.forEach(function (template) {
            selected_attachments.push({
                file_url: template.firebase_storage_uri,
                file_name: template.template_name,
                attach_to_email: template.attach_to_email
            });
        });

        selected_attachments = selected_attachments.concat($scope.attachments);

        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.followed_up_date = $('#followed_up_date').val();
            $scope.submission_date = $('#submission_date').val();
            $scope.followed_up_with_fsp_on = $('#followed_up_with_fsp_on').val();
            $scope.followed_up_with_fsca_on = $('#followed_up_with_fsca_on').val();
            $scope.implemented_on = $('#implemented_on').val();

            FSPService.createFSPProfileChange($scope.fspId, $scope.profile_change_type, $scope.profile_change_status, $scope.follow_up_yn, $scope.followed_up_date, $scope.implemented_yn, $scope.implemented_on, $scope.submitted_yn, $scope.submission_date, $scope.description, $scope.notes || '', $scope.email_send, $scope.email_subject, $scope.email_body, selected_attachments, $scope.verify_email_send, $scope.followed_up_with_fsp_yn, $scope.followed_up_with_fsp_on, $scope.followed_up_with_fsca_yn, $scope.followed_up_with_fsca_on, tokenId, $scope.visitorId).then(function () {

                $('#modalInfoHeader').html('Thank you');
                $('#modalInfoText').html($scope.verify_email_send ? 'The profile change has been saved, and emails sent.' : 'The profile change has been saved.');
                $('#information_modal').modal('open');

                setTimeout(function () {
                    $('#information_modal').modal('close');
                    $scope.backToDetailsPage();
                }, 2000);
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSPRepresentativesAdminController', function ($scope, $state, $controller, $timeout, FSPRepresentativesService, FirebaseAuthService, FSPScopeOfLicensingService, FirebaseStorageService) {
    var _this = this;

    var retrieveRepresentatives = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var res;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:

                            $scope.processing = true;
                            $scope.editing = false;
                            _context2.next = 4;
                            return FSPRepresentativesService.getRepresentativesList($scope.fspId, $scope.tokenId, $scope.visitorId);

                        case 4:
                            res = _context2.sent;

                            $scope.representatives = res.data.representatives;
                            $scope.processing = false;

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function retrieveRepresentatives() {
            return _ref2.apply(this, arguments);
        };
    }();

    var retrieveScopesOfLicensing = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var res;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return FSPScopeOfLicensingService.getScopeOfLicensing($scope.fspId, $scope.tokenId, $scope.visitorId);

                        case 2:
                            res = _context3.sent;

                            $scope.scope_of_licensing_items = res.data.fsp_scope_of_licensing.scope_of_licensing_items || [];

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function retrieveScopesOfLicensing() {
            return _ref3.apply(this, arguments);
        };
    }();

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.representatives = [];
    $scope.financialProducts = [];
    $scope.supervisionFinancialProducts = [];

    $scope.representative = {
        id: 0,
        first_name: '',
        last_name: '',
        id_number: '',

        date_appointed: new Date(),
        date_of_first_appointment: new Date(),

        passed_re1: false,
        passed_re3: false,
        passed_re5: false,
        re5_exempt: false,
        re5_due_date: new Date(),

        license_items: [],
        qualification: false,
        supervisor: '',
        qualification_name: '',
        qualification_code: '',
        qualification_due_date: new Date(),
        attachments: [],
        key_individual_id: '',
        key_individual_name: '',
        cob: 'N/A',
        cob_due_date: new Date()
    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer representatives';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return FirebaseAuthService.getUserToken();

                    case 3:
                        $scope.tokenId = _context.sent;
                        _context.next = 6;
                        return retrieveRepresentatives();

                    case 6:
                        _context.next = 8;
                        return retrieveScopesOfLicensing();

                    case 8:

                        $timeout(function () {
                            $(document).ready(function () {

                                var docUploadControl = document.getElementById("documentUpload");

                                var fileDetails = {
                                    folder: '/fsp_representatives_attachments/' + $scope.fspId,
                                    attachments: $scope.representative.attachments
                                };

                                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                                docUploadControl.addEventListener('change', eventDelegator);

                                $scope.$on('filesUploaded', function (event, attachments) {
                                    var combined = new Set($scope.representative.attachments.concat(attachments));
                                    $scope.representative.attachments = [].concat(_toConsumableArray(combined));
                                    $scope.$apply();
                                });
                            });
                        }, 1000);

                        _context.next = 14;
                        break;

                    case 11:
                        _context.prev = 11;
                        _context.t0 = _context['catch'](0);

                        $scope.checkErrStatus(_context.t0);

                    case 14:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[0, 11]]);
    }));
    $scope.init();

    $scope.cat1Filter = function (item) {
        return item.category_name === 'Category I';
    };
    $scope.cat2Filter = function (item) {
        return item.category_name === 'Category II';
    };
    $scope.cat2aFilter = function (item) {
        return item.category_name === 'Category IIA';
    };

    $scope.editRepresentative = function (index) {

        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit representative';

        var representative = $scope.representatives[index];
        var licenseItems = [].concat(representative.license_items || []);
        var finalLicenseItems = [];

        $scope.scope_of_licensing_items.forEach(function (item) {

            var repLicenseItem = licenseItems.find(function (i) {
                return i.category_id == item.category_id && i.financial_product_id == item.financial_product_id;
            });

            if (repLicenseItem) {
                repLicenseItem.advice_date = new Date(repLicenseItem.advice_date);
                repLicenseItem.intermediary_date = new Date(repLicenseItem.intermediary_date);
                repLicenseItem.discretion_date = new Date(repLicenseItem.discretion_date);
                repLicenseItem.sus_date = new Date(repLicenseItem.sus_date);
            } else {

                repLicenseItem = {
                    category_id: item.category_id,
                    financial_product_id: item.financial_product_id,
                    category_name: item.category_name,
                    financial_product_name: item.financial_product_name,
                    advice_date: new Date(),
                    intermediary_date: new Date(),
                    discretion_date: new Date(),
                    sus_date: new Date(),
                    advice: false,
                    intermediary: false,
                    discretion: false,
                    sus: false
                };
            }

            finalLicenseItems.push(repLicenseItem);
        });

        $scope.representative = {
            id: representative.id,
            first_name: representative.first_name,
            last_name: representative.last_name,
            id_number: representative.id_number,
            date_appointed: new Date(representative.date_appointed),
            date_of_first_appointment: new Date(representative.date_of_first_appointment),
            license_items: finalLicenseItems,
            passed_re1: !!representative.passed_re1,
            passed_re3: !!representative.passed_re3,
            passed_re5: !!representative.passed_re5,
            re5_exempt: !!representative.re5_exempt,
            re5_due_date: representative.re5_due_date ? new Date(representative.re5_due_date) : new Date(),
            qualification: !!representative.qualification,
            supervisor: representative.supervisor,
            qualification_name: representative.qualification_name,
            qualification_code: representative.qualification_code,
            qualification_due_date: representative.qualification_due_date ? new Date(representative.qualification_due_date) : new Date(),
            attachments: representative.attachments,
            key_individual_id: representative.key_individual_id || '',
            key_individual_name: representative.key_individual_name || '',
            cob: representative.cob || 'N/A',
            cob_due_date: representative.cob_due_date ? new Date(representative.cob_due_date) : new Date()
        };

        $scope.editing = true;

        $timeout(function () {
            $('select').material_select();
            $('#category_of_licensing').material_select();
            $('#financial_products').material_select();
            $('#supervision_financial_products').material_select();
        });
    };

    $scope.addRepresentative = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add representative';

        var finalLicenseItems = [];

        $scope.scope_of_licensing_items.forEach(function (item) {

            finalLicenseItems.push({
                category_id: item.category_id,
                financial_product_id: item.financial_product_id,
                category_name: item.category_name,
                financial_product_name: item.financial_product_name,
                advice_date: new Date(),
                intermediary_date: new Date(),
                discretion_date: new Date(),
                sus_date: new Date(),
                advice: false,
                intermediary: false,
                discretion: false,
                sus: false
            });
        });

        $scope.financialProducts.forEach(function (item) {
            return item.selected = false;
        });
        $scope.supervisionFinancialProducts.forEach(function (item) {
            return item.selected = false;
        });

        $scope.representative = {
            id: 0,
            first_name: '',
            last_name: '',
            id_number: '',
            date_appointed: new Date(),
            date_of_first_appointment: new Date(),
            license_items: finalLicenseItems,
            passed_re1: false,
            passed_re3: false,
            passed_re5: false,
            re5_exempt: false,
            re5_due_date: new Date(),
            qualification: false,
            supervisor: '',
            qualification_name: '',
            qualification_code: '',
            qualification_due_date: new Date(),
            attachments: [],
            key_individual_id: '',
            key_individual_name: '',
            cob: 'N/A',
            cob_due_date: new Date()
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer representatives';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.submitForm = function ($form) {

        if ($form.$valid) {
            $scope.saveRepresentative();
        }
    };

    $scope.saveRepresentative = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var error;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return FirebaseAuthService.getUserToken();

                    case 2:
                        $scope.tokenId = _context4.sent;
                        error = false;

                        $scope.representative.license_items.forEach(function (item) {
                            if (isNaN(item.advice_date.getTime())) {
                                item.advice_date = new Date();
                            }
                            if (isNaN(item.intermediary_date.getTime())) {
                                item.intermediary_date = new Date();
                            }
                            if (isNaN(item.discretion_date.getTime())) {
                                item.discretion_date = new Date();
                            }
                            if (isNaN(item.sus_date.getTime())) {
                                item.sus_date = new Date();
                            }

                            if (Math.abs(moment(item.advice_date).diff(moment(), 'years')) > 100) {
                                error = true;
                            }
                            if (Math.abs(moment(item.discretion_date).diff(moment(), 'years')) > 100) {
                                error = true;
                            }
                            if (Math.abs(moment(item.sus_date).diff(moment(), 'years')) > 100) {
                                error = true;
                            }
                        });

                        if (!error) {
                            _context4.next = 7;
                            break;
                        }

                        return _context4.abrupt('return', alert('Please check your dates, 1 or more appear to be invalid.'));

                    case 7:

                        $scope.representative.license_items.forEach(function (item) {
                            item.advice_date = moment(item.advice_date).format('YYYY-MM-DD');
                            item.intermediary_date = moment(item.intermediary_date).format('YYYY-MM-DD');
                            item.discretion_date = moment(item.discretion_date).format('YYYY-MM-DD');
                            item.sus_date = moment(item.sus_date).format('YYYY-MM-DD');
                        });

                        $scope.processing = true;
                        $scope.representative.date_appointed = $('#date_appointed').val();
                        $scope.representative.date_of_first_appointment = $('#date_of_first_appointment').val();
                        $scope.representative.qualification_due_date = $('#qualification_due_date').val();
                        $scope.representative.re5_due_date = $('#re5_due_date').val();
                        $scope.representative.cob_due_date = $('#cob_due_date').val();

                        if (!$scope.representative.id) {
                            _context4.next = 19;
                            break;
                        }

                        _context4.next = 17;
                        return FSPRepresentativesService.editRepresentative($scope.representative.id, $scope.representative.first_name, $scope.representative.last_name, $scope.representative.id_number, $scope.representative.date_appointed, $scope.representative.date_of_first_appointment, $scope.representative.license_items, $scope.representative.qualification, $scope.representative.passed_re1, $scope.representative.passed_re3, $scope.representative.passed_re5, $scope.representative.re5_exempt, $scope.representative.re5_due_date, $scope.representative.supervisor, $scope.representative.qualification_name, $scope.representative.qualification_code, $scope.representative.qualification_due_date, $scope.representative.attachments, $scope.representative.key_individual_id, $scope.representative.key_individual_name, $scope.representative.cob, $scope.representative.cob_due_date, $scope.tokenId, $scope.visitorId).then(function () {
                            location.reload();
                        }).catch(function (err) {
                            return $scope.checkErrStatus(err);
                        });

                    case 17:
                        _context4.next = 20;
                        break;

                    case 19:

                        FSPRepresentativesService.createRepresentative($scope.fspId, $scope.representative.first_name, $scope.representative.last_name, $scope.representative.id_number, $scope.representative.date_appointed, $scope.representative.date_of_first_appointment, $scope.representative.license_items, $scope.representative.qualification, $scope.representative.passed_re1, $scope.representative.passed_re3, $scope.representative.passed_re5, $scope.representative.re5_exempt, $scope.representative.re5_due_date, $scope.representative.supervisor, $scope.representative.qualification_name, $scope.representative.qualification_code, $scope.representative.qualification_due_date, $scope.representative.attachments, $scope.representative.key_individual_id, $scope.representative.key_individual_name, $scope.representative.cob, $scope.representative.cob_due_date, $scope.tokenId, $scope.visitorId).then(function () {
                            location.reload();
                        }).catch(function (err) {
                            return $scope.checkErrStatus(err);
                        });

                    case 20:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    $scope.cancelEditing = function ($event) {
        $('body').addClass('bg-grey-1');
        $event.preventDefault();

        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer representatives';
    };

    $scope.deleteRepresentative = function (representativeId, index) {

        $('#modalConfirmHeader').html('DELETING REPRESENTATIVE');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPRepresentativesService.deleteRepresentative(this.representativeId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ representativeId: representativeId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPRepresentativesService', function ($http) {

    return {

        getRepresentativesList: function getRepresentativesList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_representative_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createRepresentative: function createRepresentative(fspId, first_name, last_name, id_number, date_appointed, date_of_first_appointment, license_items, qualification, passed_re1, passed_re3, passed_re5, re5_exempt, re5_due_date, supervisor, qualification_name, qualification_code, qualification_due_date, attachments, key_individual_id, key_individual_name, cob, cob_due_date, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_representative/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    date_of_first_appointment: date_of_first_appointment,
                    license_items: license_items,
                    qualification: !!qualification,
                    passed_re1: !!passed_re1,
                    passed_re3: !!passed_re3,
                    passed_re5: !!passed_re5,
                    re5_exempt: !!re5_exempt,
                    re5_due_date: re5_due_date,
                    supervisor: supervisor,
                    qualification_name: qualification_name,
                    qualification_code: qualification_code,
                    qualification_due_date: qualification_due_date,
                    attachments: attachments || [],
                    key_individual_id: key_individual_id || '',
                    key_individual_name: key_individual_name || '',
                    cob: cob || 'N/A',
                    cob_due_date: cob_due_date
                }
            };

            return $http(req);
        },

        editRepresentative: function editRepresentative(fspRepresentativeId, first_name, last_name, id_number, date_appointed, date_of_first_appointment, license_items, qualification, passed_re1, passed_re3, passed_re5, re5_exempt, re5_due_date, supervisor, qualification_name, qualification_code, qualification_due_date, attachments, key_individual_id, key_individual_name, cob, cob_due_date, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_representative/' + fspRepresentativeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    first_name: first_name,
                    last_name: last_name,
                    id_number: id_number,
                    date_appointed: date_appointed,
                    date_of_first_appointment: date_of_first_appointment,
                    license_items: license_items,
                    qualification: !!qualification,
                    passed_re1: !!passed_re1,
                    passed_re3: !!passed_re3,
                    passed_re5: !!passed_re5,
                    re5_exempt: !!re5_exempt,
                    re5_due_date: re5_due_date,
                    supervisor: supervisor,
                    qualification_name: qualification_name,
                    qualification_code: qualification_code,
                    qualification_due_date: qualification_due_date,
                    attachments: attachments || [],
                    key_individual_id: key_individual_id || '',
                    key_individual_name: key_individual_name || '',
                    cob: cob || 'N/A',
                    cob_due_date: cob_due_date
                }
            };

            return $http(req);
        },

        deleteRepresentative: function deleteRepresentative(fspRepresentativeId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_representative/' + fspRepresentativeId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSPReportGenerateController', function ($scope, $state, $controller, $timeout, FSPService, FirebaseStorageService, FSPReportsService, FSPContactPersonsService, ReportEmailTemplatesService, FirebaseAuthService) {

    $scope.processing = true;
    $scope.selectAllItems = false;
    $scope.email_template = null;
    $scope.subject = 'Your compliance report';
    $scope.body = 'Dear {fsp_contact}\n\nAttached is the {fsp_name} compliance report to be discussed at the upcoming compliance review meeting.\n\nIf you have any specific questions that relate to the report please contact us on ics@complianceservices.co.za\n\nRegards,\n{user_name}';

    $scope.cc = '';
    $scope.to = '';

    // if (typeof(Storage) !== "undefined") {
    //     if (localStorage.getItem("ics_report_email_subject")) $scope.subject = localStorage.getItem("ics_report_email_subject");
    //     if (localStorage.getItem("ics_report_email_body")) $scope.body = localStorage.getItem("ics_report_email_body");
    // }

    $scope.includeFinProds = false;
    $scope.reportDate = new Date();

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.viewFSPDetails = function ($event, fspId) {
        $event.preventDefault();
        $state.transitionTo('admin-fsp-details', { fsp_id: fspId });
    };

    $scope.init = function () {
        var _this = this;

        $scope.processing = true;

        FSPService.GetFSPList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.fspList = response.data.fsps;
            $scope.processing = false;
        }).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var resp, resp2, contactPersons;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return ReportEmailTemplatesService.getReportEmailTemplatesList($scope.tokenId, $scope.visitorId);

                        case 2:
                            resp = _context.sent;

                            $scope.emailTemplates = resp.data.report_email_templates;

                            $timeout(function () {
                                $('select').material_select();
                                $('textarea').trigger('autoresize');
                            });

                            _context.next = 7;
                            return FSPContactPersonsService.getContactPersonEmailRecipients($scope.tokenId, $scope.visitorId);

                        case 7:
                            resp2 = _context.sent;
                            contactPersons = resp2.data.contact_persons;

                            $scope.fspList.forEach(function (fsp) {
                                fsp.selected = false;
                                fsp.contactPersons = contactPersons.filter(function (person) {
                                    return person.fsp_id == fsp.id;
                                });
                            });

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.previewReport = function ($event, fspId) {
        $event.preventDefault();
        FirebaseAuthService.getUserToken().then(function (tokenId) {
            $scope.tokenId = tokenId;
            $scope.processing = true;
            FSPReportsService.previewReport(fspId, $scope.includeFinProds, moment($scope.reportDate).format('YYYY-MM-DD'), $scope.tokenId, $scope.visitorId).then(function (response) {
                $state.transitionTo('fsp-report', { fsp_report_id: response.data.report.id });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.sendReport = function ($event, fspId) {

        $event.preventDefault();
        $scope.fspList.forEach(function (fsp) {
            fsp.selected = parseInt(fsp.id, 10) === parseInt(fspId);
        });
        $scope.selectAllItems = false;
        $scope.generateReport();
    };

    $scope.selectEmailTemplate = function () {
        $scope.emailTemplates.forEach(function (template) {
            if (template.id == $scope.email_template) {
                $scope.subject = template.email_subject;
                $scope.body = template.email_body;
                setTimeout(function () {
                    return $scope.$applyAsync();
                }, 0);
            }
        });
    };

    $scope.selectAll = function () {
        $scope.fspList.forEach(function (fsp) {
            if (fsp.contactPersons.length > 0) {
                fsp.selected = !$scope.selectAllItems;
            } else {
                fsp.selected = false;
            }
        });
        $scope.selectAllItems = !$scope.selectAllItems;
    };

    $scope.generateReport = function () {
        if ($scope.subject.trim().length === 0 || $scope.body.trim().length === 0) return;
        var idList = $scope.fspList.filter(function (fsp) {
            return fsp.selected === true;
        });
        if (!idList || idList.length === 0) {
            $('#modalInfoHeader').html('ERROR');
            $('#modalInfoText').html('Please select at least one service provider.');
            $('#information_modal').modal('open');
            setTimeout(function () {
                $('#information_modal').modal('close');
            }, 2000);
            return;
        }

        idList = idList.map(function (fsp) {
            return {
                id: fsp.id
            };
        });

        var cc = $scope.cc.split(',');
        cc = (cc || []).map(function (item) {
            return item.trim();
        }).join(',');

        var to = $scope.to.split(',');
        to = (to || []).map(function (item) {
            return item.trim();
        }).join(',');

        localStorage.setItem("ics_report_email_subject", $scope.subject.trim());
        localStorage.setItem("ics_report_email_body", $scope.body.trim());

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            $scope.tokenId = tokenId;
            $scope.processing = true;
            FSPReportsService.generateReport(idList, $scope.subject.trim(), $scope.body.trim(), $scope.includeFinProds, cc || '', to || '', moment($scope.reportDate).format('YYYY-MM-DD'), $scope.tokenId, $scope.visitorId).then(function (response) {
                console.log(response);
                $scope.processing = false;
                $scope.fspList.forEach(function (fsp) {
                    return fsp.selected = false;
                });
                $scope.selectAllItems = false;
                $('#modalInfoHeader').html('THANK YOU');
                $('#modalInfoText').html('Your reports are being generated and sent.');
                $('#information_modal').modal('open');
                setTimeout(function () {
                    $('#information_modal').modal('close');
                }, 2000);
                return;
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };
});
'use strict';

angular.module('ics').controller('FSPReportHistoryController', function ($scope, $state, FirebaseAuthService, FSPReportsService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.reports = [];
    $scope.processing = true;

    function init() {

        FirebaseAuthService.getUserToken().then(function (tokenId) {
            FSPReportsService.getReportHistory($scope.fspId, tokenId, $scope.visitorId).then(function (details) {
                $scope.reports = details.data.reports;
                $scope.processing = false;
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $(document).ready(function () {
        init();
    });

    $scope.goBack = function () {
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };
});
'use strict';

angular.module('ics').controller('FSPReportController', function ($scope, $state, $controller, $window, FSPReportsService, FirebaseAuthService) {

    $scope.reportId = $state.params.fsp_report_id;
    $scope.errorMessage = '';
    $scope.report = {};
    $scope.emailAudit = [];
    $scope.processing = true;
    $scope.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    function init() {

        FSPReportsService.getFSPReport($scope.reportId).then(function (details) {
            $scope.report = details.data.report;
            console.log(details.data.report);
            $scope.emailAudit = details.data.email_audit;

            $scope.report.representatives.forEach(function (representative) {

                var cat1LicenceItems = representative.license_items.filter(function (item) {
                    return item.category_name.toUpperCase().trim() === 'CATEGORY I';
                });
                var cat2LicenceItems = representative.license_items.filter(function (item) {
                    return item.category_name.toUpperCase().trim() === 'CATEGORY II';
                });
                var cat2ALicenceItems = representative.license_items.filter(function (item) {
                    return item.category_name.toUpperCase().trim() === 'CATEGORY IIA';
                });

                var cat1Items = [];
                var cat2Items = [];
                var cat2AItems = [];
                cat1LicenceItems.forEach(function (categoryLicenseItem) {
                    return formatLicensingCategories(cat1Items, categoryLicenseItem);
                });
                cat2LicenceItems.forEach(function (categoryLicenseItem) {
                    return formatLicensingCategories(cat2Items, categoryLicenseItem);
                });
                cat2ALicenceItems.forEach(function (categoryLicenseItem) {
                    return formatLicensingCategories(cat2AItems, categoryLicenseItem);
                });

                representative.cat1Items = cat1Items;
                representative.cat2Items = cat2Items;
                representative.cat2AItems = cat2AItems;
            });

            function formatLicensingCategories(catItems, categoryLicenseItem) {

                if (categoryLicenseItem.advice || categoryLicenseItem.intermediary || categoryLicenseItem.sus) {

                    var services = [];
                    var doa = '';

                    if (categoryLicenseItem.intermediary) {
                        services.push('I');
                        if (categoryLicenseItem.intermediary_date) {
                            doa = moment(categoryLicenseItem.intermediary_date).format('DD/MM/YYYY');
                        }
                    }
                    if (categoryLicenseItem.sus) {
                        services.push('SuS');
                        if (categoryLicenseItem.sus_date) {
                            doa = moment(categoryLicenseItem.sus_date).format('DD/MM/YYYY');
                        }
                    }
                    if (categoryLicenseItem.advice) {
                        services.push('A');
                        if (categoryLicenseItem.advice_date) {
                            doa = moment(categoryLicenseItem.advice_date).format('DD/MM/YYYY');
                        }
                    }

                    var item = {
                        product: categoryLicenseItem.financial_product_name,
                        services: services.join(', '),
                        doa: doa
                    };

                    catItems.push(item);
                }
            }

            if ($scope.report.fsb_submissions) {
                $scope.report.fsb_submissions.sort(function (a, b) {
                    return new Date(b.submission_date).getTime() - new Date(a.submission_date).getTime();
                });
            }

            if ($scope.report.fsb_submission_dates) {
                $scope.report.fsb_submission_dates.forEach(function (date) {
                    return date.due_date_month = $scope.months[date.due_date_month];
                });
            }

            if ($scope.report.profile_change_pipeline) {
                $scope.report.profile_change_pipeline.sort(function (a, b) {
                    return new Date(b.created).getTime() - new Date(a.created).getTime();
                });
            }
            if ($scope.report.implemented_profile_changes && $scope.report.implemented_profile_changes.length) {
                $scope.report.implemented_profile_changes.slice(0, 30).sort(function (a, b) {
                    return new Date(b.submission_date).getTime() - new Date(a.submission_date).getTime();
                });
            }
            $scope.processing = false;
        }).catch(function (err) {
            console.log(err);
            throw err;
        });
    }

    $(document).ready(function () {
        init();
    });

    $scope.historyBack = function () {
        $window.history.back();
    };

    $scope.digitallySignDocument = function ($event) {

        $event.preventDefault();

        $('#modalConfirmHeader').html('You are about to digitally sign this report');
        $('#modalConfirmText').html('Are you sure you wish to proceed?');

        var digitallySignReport = function digitallySignReport() {
            $scope.processing = true;
            FirebaseAuthService.getUserToken().then(function (tokenId) {
                return FSPReportsService.digitallySignReport($scope.reportId, $scope.visitorId, tokenId);
            }).then(function () {
                return init();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $(document).ready(function () {
            $('#modalAgreeLink').click(function () {
                digitallySignReport();
                $('#are_you_sure_modal').modal('close');
            });
            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.filterCategories = function (value) {
        return value.advice || value.intermediary || value.discretion || value.sus;
    };
});
'use strict';

angular.module('ics').factory('FSPReportsService', function ($http) {

    return {

        getFSPReport: function getFSPReport(fspReportId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_report/' + fspReportId,
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 8000
            };

            return $http(req);
        },

        getReportHistory: function getReportHistory(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_report_history/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 20000
            };

            return $http(req);
        },

        previewReport: function previewReport(fspId, includeFinProds, reportDate, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_report_preview',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: { fsp_id: fspId, include_fin_prods: includeFinProds, report_date: reportDate }
            };

            return $http(req);
        },

        generateReport: function generateReport(fspIds, emailSubject, emailBody, includeFinProds, cc, to, reportDate, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_report/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp_ids: fspIds,
                    email_subject: emailSubject,
                    email_body: emailBody,
                    include_fin_prods: includeFinProds,
                    cc: cc,
                    to: to,
                    report_date: reportDate
                }
            };

            return $http(req);
        },

        digitallySignReport: function digitallySignReport(reportId, visitorId, firebaseTokenId) {
            var req = {
                method: 'GET',
                url: '/api/fsp_report_digitally_sign/' + reportId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 10000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('ExternalAuditorDetailsAdminController', function ($scope, $state, $controller, $timeout, FSPListsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.itemId = $state.params.item_id;
    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = $state.params.fsp_name;
    $scope.errorMessage = '';
    $scope.item = {

        id: $scope.itemId,
        name: '',
        responsible_partner: '',
        contact_number: '',
        practice_number: '',
        appointment_date: new Date(),
        attachments: []

    };
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    function init() {

        return new Promise(function (resolve, reject) {

            if ($scope.itemId) {

                FirebaseAuthService.getUserToken().then(function (tokenId) {

                    FSPListsService.getExternalAuditorDetails($scope.itemId, tokenId, $scope.visitorId).then(function (res) {

                        var item = res.data.item;

                        $scope.item.name = item.name;
                        $scope.item.responsible_partner = item.responsible_partner;
                        $scope.item.contact_number = item.contact_number;
                        $scope.item.practice_number = item.practice_number;
                        $scope.item.appointment_date = new Date(item.appointment_date);
                        $scope.item.attachments = item.attachments;
                        resolve($scope.item);
                    });
                });
            } else {
                resolve($scope.item);
            }
        });
    }

    $(document).ready(function () {

        init().then(function (tokenId) {

            $scope.processing = false;

            var $appointmentDateInput = $('#appointment_date').pickadate({
                selectMonths: true, // Creates a dropdown to control month
                selectYears: 20, // Creates a dropdown of 20 years to control year
                format: "yyyy-mm-dd"
            });

            var datePicker = $appointmentDateInput.pickadate('picker');
            datePicker.set('select', new Date($scope.item.appointment_date));

            var docUploadControl = document.getElementById("documentUpload");

            docUploadControl.addEventListener('change', function (e) {
                var file = e.target.files[0];
                if (!file || !file.name) return;
                jQuery('#uploading-document').removeClass('hidden');
                FirebaseStorageService.uploadFileToCloudStorage("/external_auditor_attachments/", file, null).then(function (storageInfo) {

                    jQuery('#uploading-document').addClass('hidden');
                    $scope.item.attachments.push({
                        file_url: storageInfo.downloadUrl,
                        file_name: file.name,
                        attach_to_email: true
                    });
                    $scope.$apply();
                }, function (errMessage) {
                    jQuery('#uploading-document').addClass('hidden');
                    console.log(errMessage);
                    alert("An error occurred, please try again");
                    $scope.processing = false;
                });
            });
        }, function (error) {
            alert('An error occurred, please try again');
            $scope.processing = false;
        });
    });

    $scope.removeDoc = function (index) {
        $scope.item.attachments.splice(index, 1);
    };

    $scope.saveItem = function (id, name, responsible_partner, contact_number, practice_number) {

        $scope.processing = true;

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            var appointment_date = $('#appointment_date').val();

            if ($scope.item.id) {

                FSPListsService.editExternalAuditor($scope.item.id, $scope.fspId, name, responsible_partner, contact_number, practice_number, appointment_date, $scope.item.attachments, tokenId, $scope.visitorId).then(function (res) {
                    success(false);
                });
            } else {

                FSPListsService.createExternalAuditor($scope.fspId, name, responsible_partner, contact_number, practice_number, appointment_date, $scope.item.attachments, tokenId, $scope.visitorId).then(function (res) {
                    success(true);
                });
            }
        });
    };

    function success(added) {

        $('#modalInfoHeader').html('THANK YOU');
        $('#modalInfoText').html('The auditor has been ' + (added ? 'added.' : 'edited.'));
        $('#information_modal').modal('open');

        setTimeout(function () {
            $('#information_modal').modal('close');
            $('body').addClass('bg-grey-1');
            $state.transitionTo('external-auditor-list', { fsp_id: $scope.fspId, fsp_name: $scope.fspName });
        }, 2000);
    }
});
'use strict';

angular.module('ics').controller('ExternalAuditorListAdminController', function ($scope, $state, $controller, FirebaseAuthService, FSPListsService) {

    $scope.items = [];
    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    init();

    function init() {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            FSPListsService.getExternalAuditorList($scope.fspId, tokenId, $scope.visitorId).then(function (res) {

                $scope.items = res.data.items;
            });
        });
    }

    $scope.editItem = function (id) {
        $('body').removeClass('bg-grey-1');
        $state.transitionTo('external-auditor-details', {
            fsp_id: $scope.fspId,
            fsp_name: $scope.fspName,
            item_id: id
        });
    };

    $scope.addItem = function () {
        $('body').removeClass('bg-grey-1');
        $state.transitionTo('external-auditor-details', {
            fsp_id: $scope.fspId,
            fsp_name: $scope.fspName,
            item_id: null
        });
    };

    $scope.deleteItem = function (id) {

        $('#modalConfirmHeader').html('DELETING EXTERNAL AUDITOR');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {
            var _this = this;

            FirebaseAuthService.getUserToken().then(function (tokenId) {

                FSPListsService.deleteExternalAuditor(_this.id, tokenId, $scope.visitorId).then(function (response) {
                    location.reload();
                }, function (reject) {
                    $scope.errorMessage = reject.message;
                    if (reject.status === 403) {
                        $state.transitionTo('signin');
                    }
                });
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').controller('MarketRiskMatrixAdminController', function ($scope, $state, $controller, $timeout, FSPListsService, CategoriesService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    $scope.mktRiskCategories = [];
    $scope.items = [];

    $scope.itemCategory = {};

    $scope.item = {
        id: 0,
        item_category: '',
        relevant: false,
        implementation: false,
        third_party: ''
    };

    $scope.errorMessage = '';
    $scope.tokenId = '';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;

        FSPListsService.getMarketRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {
            $scope.items = response.data.items;

            $scope.items.sort(function (a, b) {
                var textA = a.item_category.name.toUpperCase();
                var textB = b.item_category.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });

            reset();
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('market_rist_mgt', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.mktRiskCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
            }, function (reject) {
                if (reject.status === 403) {
                    $state.transitionTo('signin');
                }
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.saveItem = function (id, item_category, relevant, implementation, third_party) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.id === 0) {

            FSPListsService.createMarketRiskMatrixItem($scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {

            FSPListsService.updateMarketRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteMarketRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {
            deleteItemCallback.bind({ id: id })();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editItem = function (id, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: $scope.items[index].id,
            item_category: $scope.items[index].item_category.id,
            relevant: !!$scope.items[index].relevant,
            implementation: $scope.items[index].implementation,
            third_party: $scope.items[index].third_party
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
    };

    $scope.addItem = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editing = true;
        $scope.errorMessage = '';
    };

    $scope.cancelSaveItem = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editing = false;
        $scope.errorMessage = '';
    }
});
'use strict';

angular.module('ics').controller('OperationalRiskMatrixAdminController', function ($scope, $state, $controller, $timeout, FSPListsService, CategoriesService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    $scope.operationalRiskCategories = [];
    $scope.items = [];

    $scope.itemCategory = {};

    $scope.item = {
        id: 0,
        item_category: '',
        relevant: false,
        implementation: false,
        third_party: ''
    };

    $scope.errorMessage = '';
    $scope.tokenId = '';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;

        FSPListsService.getOperationalRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {
            $scope.items = response.data.items;

            $scope.items.sort(function (a, b) {
                var textA = a.item_category.name.toUpperCase();
                var textB = b.item_category.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });

            reset();
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('fsp_risk_mgt', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.operationalRiskCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.saveItem = function (id, item_category, relevant, implementation, third_party) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.id === 0) {
            FSPListsService.createOperationalRiskMatrixItem($scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSPListsService.updateOperationalRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteOperationalRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editItem = function (id, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: $scope.items[index].id,
            item_category: $scope.items[index].item_category.id,
            relevant: !!$scope.items[index].relevant,
            implementation: $scope.items[index].implementation,
            third_party: $scope.items[index].third_party
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
    };

    $scope.addItem = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editing = true;
        $scope.errorMessage = '';
    };

    $scope.cancelSaveItem = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editing = false;
        $scope.errorMessage = '';
    }
});
'use strict';

angular.module('ics').controller('RegRiskMatrixAdminController', function ($scope, $state, $controller, $timeout, FSPListsService, CategoriesService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    $scope.regRiskCategories = [];
    $scope.items = [];

    $scope.itemCategory = {};

    $scope.item = {
        id: 0,
        item_category: '',
        relevant: false,
        responsible_party: '',
        risk_of_non_compliance: '',
        impact_of_non_compliance: ''
    };

    $scope.errorMessage = '';
    $scope.tokenId = '';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;

        FSPListsService.getRegRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {
            $scope.items = response.data.items;

            $scope.items.sort(function (a, b) {
                var textA = a.item_category.name.toUpperCase();
                var textB = b.item_category.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
            reset();
        }).then(function () {

            CategoriesService.getCategoriesListFromCode('reg_risk_acts', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.regRiskCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.saveItem = function (id, item_category, relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.id === 0) {
            FSPListsService.createRegRiskMatrixItem($scope.fspId, item_category, !!relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSPListsService.updateRegRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteRegRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editItem = function (id, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: $scope.items[index].id,
            item_category: $scope.items[index].item_category.id,
            relevant: !!$scope.items[index].relevant,
            responsible_party: $scope.items[index].responsible,
            risk_of_non_compliance: $scope.items[index].risk_of_non_compliance,
            impact_of_non_compliance: $scope.items[index].impact_of_non_compliance
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editing = true;
    };

    $scope.addItem = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            responsible_party: '',
            risk_of_non_compliance: '',
            impact_of_non_compliance: ''
        };

        $scope.editing = true;
        $scope.errorMessage = '';
    };

    $scope.cancelSaveItem = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.item = {
            id: 0,
            item_category: '',
            relevant: false,
            responsible_party: '',
            risk_of_non_compliance: '',
            impact_of_non_compliance: ''
        };
        $scope.editing = false;
        $scope.errorMessage = '';
    }
});
'use strict';

angular.module('ics').controller('RiskMatricesAdminController', function ($scope, $state, $controller, $timeout, $q, FSPListsService, CategoriesService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    // operational risk variables
    $scope.operationalRiskCategories = [];
    $scope.operationalRiskItems = [];
    $scope.operationalRiskItemCategory = {};
    $scope.operationalRiskItem = {
        id: 0,
        item_category: '',
        relevant: false,
        implementation: false,
        third_party: ''
    };

    // regulatory risk variables
    $scope.regulatoryRiskCategories = [];
    $scope.regulatoryRiskItems = [];
    $scope.regulatoryRiskItemCategory = {};
    $scope.regulatoryRiskItem = {
        id: 0,
        item_category: '',
        relevant: false,
        implementation: false,
        third_party: ''
    };

    // market risk variables
    $scope.marketRiskCategories = [];
    $scope.marketRiskItems = [];
    $scope.marketRiskItemCategory = {};
    $scope.marketRiskItem = {
        id: 0,
        item_category: '',
        relevant: false,
        implementation: false,
        third_party: ''
    };

    $scope.tokenId = '';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    });

    $scope.init = function () {

        $scope.processing = true;
        retrieveOperationalRiskData().then(retrieveOperationalRiskCategories).then(retrieveRegulatoryRiskData).then(retrieveRegulatoryRiskCategories).then(retrieveMarketRiskData).then(retrieveMarketRiskCategories).then(function () {

            resetOperationalRisk();
            resetRegulatoryRisk();
            resetMarketRisk();

            $('select').material_select();
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.goBack = function () {

        if ($scope.editingRegulatory) {
            resetRegulatoryRisk();
        } else if ($scope.editingOperational) {
            resetOperationalRisk();
        } else if ($scope.editingMarket) {
            resetMarketRisk();
        } else {
            $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
        }
    };

    // ****** O P E R A T I O N A L  R I S K  F U N C T I O N S ******

    function retrieveOperationalRiskData() {

        return $q(function (resolve) {

            FSPListsService.getOperationalRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {

                $scope.operationalRiskItems = response.data.items;

                $scope.operationalRiskItems.sort(function (a, b) {
                    var textA = a.item_category.name.toUpperCase();
                    var textB = b.item_category.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                resolve();
            }).catch(function (err) {
                return reject(err);
            });
        });
    }

    function retrieveOperationalRiskCategories() {

        return $q(function (resolve) {

            CategoriesService.getCategoriesListFromCode('fsp_risk_mgt', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.operationalRiskCategories = res.data.categories;
                $('select').material_select();
                resolve();
            });
        });
    }

    $scope.submitRiskMgtForm = function ($form) {
        if ($form.$valid) {
            $scope.saveOperationalRiskItem($scope.operationalRiskItem.id, $scope.operationalRiskItem.item_category, $scope.operationalRiskItem.relevant, $scope.operationalRiskItem.implementation, $scope.operationalRiskItem.third_party);
        }
    };

    $scope.saveOperationalRiskItem = function (id, item_category, relevant, implementation, third_party) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.operationalRiskItem.id === 0) {
            FSPListsService.createOperationalRiskMatrixItem($scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSPListsService.updateOperationalRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteOperationalRiskItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteOperationalRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editOperationalRiskItem = function (id, index) {
        // $('body').removeClass('bg-grey-1');
        $scope.operationalRiskItem = {
            id: $scope.operationalRiskItems[index].id,
            item_category: $scope.operationalRiskItems[index].item_category.id,
            relevant: !!$scope.operationalRiskItems[index].relevant,
            implementation: $scope.operationalRiskItems[index].implementation,
            third_party: $scope.operationalRiskItems[index].third_party
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editingOperational = true;
    };

    $scope.addOperationalRiskItem = function () {
        // $('body').removeClass('bg-grey-1');
        $scope.operationalRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $('select').material_select();
        $scope.editingOperational = true;
        $scope.errorMessage = '';
    };

    $scope.cancelOperationalRiskSaveItem = function () {
        // $('body').addClass('bg-grey-1');
        resetOperationalRisk();
    };

    function resetOperationalRisk() {
        $scope.processing = false;
        $scope.operationalRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editingOperational = false;
        $scope.errorMessage = '';
    }

    // ****** R E G U L A T O R Y  R I S K  F U N C T I O N S ******


    function retrieveRegulatoryRiskData() {

        return $q(function (resolve) {

            FSPListsService.getRegRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {
                $scope.regulatoryRiskItems = response.data.items;

                $scope.regulatoryRiskItems.sort(function (a, b) {
                    var textA = a.item_category.name.toUpperCase();
                    var textB = b.item_category.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                resolve();
            });
        });
    }

    function retrieveRegulatoryRiskCategories() {

        return $q(function (resolve) {

            CategoriesService.getCategoriesListFromCode('reg_risk_acts', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.regRiskCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
                resolve();
            });
        });
    }

    $scope.submitRegulatoryRiskForm = function ($form) {

        if ($form.$valid) {
            $scope.saveRegulatoryRiskItem($scope.regulatoryRiskItem.id, $scope.regulatoryRiskItem.item_category, $scope.regulatoryRiskItem.relevant, $scope.regulatoryRiskItem.responsible_party, $scope.regulatoryRiskItem.risk_of_non_compliance, $scope.regulatoryRiskItem.impact_of_non_compliance);
        }
    };

    $scope.saveRegulatoryRiskItem = function (id, item_category, relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance) {

        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.regulatoryRiskItem.id === 0) {
            FSPListsService.createRegRiskMatrixItem($scope.fspId, item_category, !!relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSPListsService.updateRegRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteRegulatoryRiskItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteRegRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editRegulatoryRiskItem = function (id, index) {
        // $('body').removeClass('bg-grey-1');
        $scope.regulatoryRiskItem = {
            id: $scope.regulatoryRiskItems[index].id,
            item_category: $scope.regulatoryRiskItems[index].item_category.id,
            relevant: !!$scope.regulatoryRiskItems[index].relevant,
            responsible_party: $scope.regulatoryRiskItems[index].responsible_party,
            risk_of_non_compliance: $scope.regulatoryRiskItems[index].risk_of_non_compliance,
            impact_of_non_compliance: $scope.regulatoryRiskItems[index].impact_of_non_compliance
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editingRegulatory = true;
    };

    $scope.addRegulatoryRiskItem = function () {
        // $('body').removeClass('bg-grey-1');
        $scope.regulatoryRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            responsible_party: '',
            risk_of_non_compliance: '',
            impact_of_non_compliance: ''
        };

        $scope.editingRegulatory = true;
        $scope.errorMessage = '';
    };

    $scope.cancelRegulatoryRiskSaveItem = function () {
        // $('body').addClass('bg-grey-1');
        resetRegulatoryRisk();
    };

    function resetRegulatoryRisk() {
        $scope.processing = false;
        $scope.regulatoryRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            responsible_party: '',
            risk_of_non_compliance: '',
            impact_of_non_compliance: ''
        };
        $scope.editingRegulatory = false;
        $scope.errorMessage = '';
    }

    // ****** M A R K E T  R I S K  F U N C T I O N S ******

    function retrieveMarketRiskData() {

        return $q(function (resolve) {

            FSPListsService.getMarketRiskMatrixList($scope.tokenId, $scope.fspId).then(function (response) {
                $scope.marketRiskItems = response.data.items;

                $scope.marketRiskItems.sort(function (a, b) {
                    var textA = a.item_category.name.toUpperCase();
                    var textB = b.item_category.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                resolve();
            });
        });
    }

    function retrieveMarketRiskCategories() {

        return $q(function (resolve) {

            CategoriesService.getCategoriesListFromCode('market_rist_mgt', $scope.tokenId, $scope.visitorId).then(function (res) {
                $scope.marketRiskCategories = res.data.categories;
                $timeout(function () {
                    $('select').material_select();
                });
            });

            resolve();
        });
    }

    $scope.submitMktRiskForm = function ($form) {
        if ($form.$valid) {
            saveMarketRiskItem($scope.marketRiskItem.id, $scope.marketRiskItem.item_category, $scope.marketRiskItem.relevant, $scope.marketRiskItem.implementation, $scope.marketRiskItem.third_party);
        }
    };

    $scope.saveMarketRiskItem = function (id, item_category, relevant, implementation, third_party) {

        $scope.errorMessage = '';
        $scope.processing = true;

        if ($scope.marketRiskItem.id === 0) {
            FSPListsService.createMarketRiskMatrixItem($scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            FSPListsService.updateMarketRiskMatrixItem(id, $scope.fspId, item_category, !!relevant, !!implementation, third_party, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteMarketRiskItem = function (id, index) {

        $('#modalConfirmHeader').html('DELETING ITEM');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteItemCallback = function deleteItemCallback() {

            FSPListsService.deleteMarketRiskMatrixItem(this.id, $scope.tokenId, $scope.visitorId).then(function () {
                location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        $('#modalAgreeLink').click(function () {

            deleteItemCallback.bind({ id: id })();

            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.editMarketRiskItem = function (id, index) {
        // $('body').removeClass('bg-grey-1');
        $scope.marketRiskItem = {
            id: $scope.marketRiskItems[index].id,
            item_category: $scope.marketRiskItems[index].item_category.id,
            relevant: !!$scope.marketRiskItems[index].relevant,
            implementation: $scope.marketRiskItems[index].implementation,
            third_party: $scope.marketRiskItems[index].third_party
        };

        $timeout(function () {
            $('select').material_select();
        });

        $scope.editingMarket = true;
    };

    $scope.addMarketRiskItem = function () {
        // $('body').removeClass('bg-grey-1');
        $scope.marketRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editingMarket = true;
        $scope.errorMessage = '';
    };

    $scope.cancelMarketRiskSaveItem = function () {
        // $('body').addClass('bg-grey-1');
        resetMarketRisk();
    };

    function resetMarketRisk() {
        $scope.processing = false;
        $scope.marketRiskItem = {
            id: 0,
            item_category: '',
            relevant: false,
            implementation: false,
            third_party: ''
        };
        $scope.editingMarket = false;
        $scope.errorMessage = '';
    }
});
'use strict';

angular.module('ics').factory('FSPListsService', function ($http) {

    return {

        getRegRiskMatrixList: function getRegRiskMatrixList(firebaseTokenId, fspId) {

            var req = {
                method: 'GET',
                url: '/api/reg_risk_matrix/list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createRegRiskMatrixItem: function createRegRiskMatrixItem(fsp_id, item_category, relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/reg_risk_matrix/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    responsible_party: responsible_party,
                    risk_of_non_compliance: risk_of_non_compliance,
                    impact_of_non_compliance: impact_of_non_compliance
                }
            };

            return $http(req);
        },

        updateRegRiskMatrixItem: function updateRegRiskMatrixItem(item_id, fsp_id, item_category, relevant, responsible_party, risk_of_non_compliance, impact_of_non_compliance, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/reg_risk_matrix/' + item_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    responsible_party: responsible_party,
                    risk_of_non_compliance: risk_of_non_compliance,
                    impact_of_non_compliance: impact_of_non_compliance
                }
            };

            return $http(req);
        },

        deleteRegRiskMatrixItem: function deleteRegRiskMatrixItem(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/reg_risk_matrix/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getMarketRiskMatrixList: function getMarketRiskMatrixList(firebaseTokenId, fspId) {

            var req = {
                method: 'GET',
                url: '/api/mkt_risk_matrix/list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createMarketRiskMatrixItem: function createMarketRiskMatrixItem(fsp_id, item_category, relevant, implementation, third_party, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/mkt_risk_matrix/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    implementation: implementation,
                    third_party: third_party
                }
            };

            return $http(req);
        },

        updateMarketRiskMatrixItem: function updateMarketRiskMatrixItem(item_id, fsp_id, item_category, relevant, implementation, third_party, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/mkt_risk_matrix/' + item_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    implementation: implementation,
                    third_party: third_party
                }
            };

            return $http(req);
        },

        deleteMarketRiskMatrixItem: function deleteMarketRiskMatrixItem(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/mkt_risk_matrix/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getOperationalRiskMatrixList: function getOperationalRiskMatrixList(firebaseTokenId, fspId) {

            var req = {
                method: 'GET',
                url: '/api/operational_risk_matrix/list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createOperationalRiskMatrixItem: function createOperationalRiskMatrixItem(fsp_id, item_category, relevant, implementation, third_party, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/operational_risk_matrix/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    implementation: implementation,
                    third_party: third_party
                }
            };

            return $http(req);
        },

        updateOperationalRiskMatrixItem: function updateOperationalRiskMatrixItem(item_id, fsp_id, item_category, relevant, implementation, third_party, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/operational_risk_matrix/' + item_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    item_category: item_category,
                    fsp_id: fsp_id,
                    relevant: relevant,
                    implementation: implementation,
                    third_party: third_party
                }
            };

            return $http(req);
        },

        deleteOperationalRiskMatrixItem: function deleteOperationalRiskMatrixItem(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/operational_risk_matrix/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getExternalAuditorList: function getExternalAuditorList(fsp_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/external_auditor/list/' + fsp_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        getExternalAuditorDetails: function getExternalAuditorDetails(item_id, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/external_auditor/' + item_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createExternalAuditor: function createExternalAuditor(fsp_id, name, responsible_partner, contact_number, practice_number, appointment_date, attachments, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/external_auditor/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp_id: fsp_id,
                    name: name,
                    responsible_partner: responsible_partner,
                    contact_number: contact_number,
                    practice_number: practice_number,
                    appointment_date: appointment_date,
                    attachments: attachments
                }
            };

            return $http(req);
        },

        editExternalAuditor: function editExternalAuditor(item_id, fsp_id, name, responsible_partner, contact_number, practice_number, appointment_date, attachments, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/external_auditor/' + item_id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp_id: fsp_id,
                    name: name,
                    responsible_partner: responsible_partner,
                    contact_number: contact_number,
                    practice_number: practice_number,
                    appointment_date: appointment_date,
                    attachments: attachments
                }
            };

            return $http(req);
        },

        deleteExternalAuditor: function deleteExternalAuditor(id, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                url: '/api/external_auditor/' + id,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('FSPRiskProfileAdminController', function ($scope, $state, $controller, $timeout, FSPRiskProfileService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    $scope.risk_profile_scope_of_license = [];
    $scope.risk_profile_fit_and_proper = [];
    $scope.risk_profile_operational_ability = [];
    $scope.risk_profile_financial_soundness = [];
    $scope.risk_profile_code_of_conduct = [];
    $scope.risk_profile_representatives = [];
    $scope.risk_profile_honesty_and_integrity = [];
    $scope.risk_profile_discretionary = [];
    $scope.risk_profile_general = [];

    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        retrieveRiskProfile();
    });
    if ($scope.risk_profile_scope_of_license.length === 0) {
        retrieveRiskProfile();
    }

    function retrieveRiskProfile() {

        $scope.processing = true;
        $scope.editing = false;

        FSPRiskProfileService.getRiskProfile($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.risk_profile_scope_of_license = res.data.risk_profile_scope_of_license;
            $scope.risk_profile_fit_and_proper = res.data.risk_profile_fit_and_proper;
            $scope.risk_profile_operational_ability = res.data.risk_profile_operational_ability;
            $scope.risk_profile_financial_soundness = res.data.risk_profile_financial_soundness;
            $scope.risk_profile_code_of_conduct = res.data.risk_profile_code_of_conduct;
            $scope.risk_profile_representatives = res.data.risk_profile_representatives;
            $scope.risk_profile_honesty_and_integrity = res.data.risk_profile_honesty_and_integrity;
            $scope.risk_profile_discretionary = res.data.risk_profile_discretionary;
            $scope.risk_profile_general = res.data.risk_profile_general;

            $scope.title_scope_of_license = res.data.title_scope_of_license;
            $scope.title_fit_and_proper = res.data.title_fit_and_proper;
            $scope.title_operational_ability = res.data.title_operational_ability;
            $scope.title_financial_soundness = res.data.title_financial_soundness;
            $scope.title_code_of_conduct = res.data.title_code_of_conduct;
            $scope.title_representatives = res.data.title_representatives;
            $scope.title_honesty_and_integrity = res.data.title_honesty_and_integrity;
            $scope.title_discretionary = res.data.title_discretionary;
            $scope.title_general = res.data.title_general;

            $scope.processing = false;

            $timeout(function () {
                $('select').material_select();
            });
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.saveRiskProfile = function () {
        $scope.processing = true;
        FSPRiskProfileService.saveRiskProfile($scope.fspId, $scope.risk_profile_scope_of_license, $scope.risk_profile_fit_and_proper, $scope.risk_profile_operational_ability, $scope.risk_profile_financial_soundness, $scope.risk_profile_code_of_conduct, $scope.risk_profile_representatives, $scope.risk_profile_honesty_and_integrity, $scope.risk_profile_discretionary, $scope.risk_profile_general, $scope.tokenId, $scope.visitorId).then(function () {
            $scope.processing = false;
            $scope.goBack();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.updateRiskRating = function (item) {
        if (item.probability === "N/A" || item.impact === "N/A") {
            item.inherent_risk_rating = "N/A";
            $scope.updateResidualRisk(item);
            $scope.$applyAsync();
            return;
        }

        if (!item.probability || !item.impact) {
            item.inherent_risk_rating = "";
            $scope.updateResidualRisk(item);
            return;
        }

        var probability = item.probability;
        var impact = item.impact;

        if (probability === "Possible" && impact === "Minor") {
            item.inherent_risk_rating = "Moderate";
        } else if (probability === "Possible" && impact === "Major") {
            item.inherent_risk_rating = "High";
        } else if (probability === "Possible" && impact === "Moderate") {
            item.inherent_risk_rating = "Moderate";
        } else if (probability === "Likely" && impact === "Major") {
            item.inherent_risk_rating = "High";
        } else if (probability === "Likely" && impact === "Moderate") {
            item.inherent_risk_rating = "High";
        } else if (probability === "Likely" && impact === "Minor") {
            item.inherent_risk_rating = "Low";
        } else if (probability === "Unlikely" && impact === "Minor") {
            item.inherent_risk_rating = "Low";
        } else if (probability === "Unlikely" && impact === "Moderate") {
            item.inherent_risk_rating = "Low";
        } else if (probability === "Unlikely" && impact === "Major") {
            item.inherent_risk_rating = "Moderate";
        } else {
            item.inherent_risk_rating = "";
        }

        $scope.updateResidualRisk(item);
        $scope.$applyAsync();
    };

    $scope.updateResidualRisk = function (item) {
        if (item.inherent_risk_rating === "N/A" || item.control_rating === "N/A" || item.control === "Currently N/A – Awaiting FSCA finalisation") {
            item.residual_risk_rating = "N/A";
            return;
        }

        if (!item.inherent_risk_rating || !item.control_rating) {
            item.residual_risk_rating = "";
            return;
        }

        var inherentRisk = item.inherent_risk_rating;
        var controlEffectiveness = item.control_rating;

        if (inherentRisk === "High" && controlEffectiveness === "Effective") {
            item.residual_risk_rating = "Moderate";
        } else if (inherentRisk === "High" && controlEffectiveness === "Somewhat effective") {
            item.residual_risk_rating = "High";
        } else if (inherentRisk === "High" && controlEffectiveness === "Very effective") {
            item.residual_risk_rating = "Low";
        } else if (inherentRisk === "Moderate" && controlEffectiveness === "Effective") {
            item.residual_risk_rating = "Moderate";
        } else if (inherentRisk === "Moderate" && controlEffectiveness === "Somewhat effective") {
            item.residual_risk_rating = "Moderate";
        } else if (inherentRisk === "Moderate" && controlEffectiveness === "Very effective") {
            item.residual_risk_rating = "Low";
        } else if (inherentRisk === "Low" && controlEffectiveness === "Effective") {
            item.residual_risk_rating = "Low";
        } else if (inherentRisk === "Low" && controlEffectiveness === "Somewhat effective") {
            item.residual_risk_rating = "Low";
        } else if (inherentRisk === "Low" && controlEffectiveness === "Very effective") {
            item.residual_risk_rating = "Low";
        } else {
            item.residual_risk_rating = "";
        }
    };
});
'use strict';

angular.module('ics').factory('FSPRiskProfileService', function ($http) {

    return {

        getRiskProfile: function getRiskProfile(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_risk_profile/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        saveRiskProfile: function saveRiskProfile(fspId, risk_profile_scope_of_license, risk_profile_fit_and_proper, risk_profile_operational_ability, risk_profile_financial_soundness, risk_profile_code_of_conduct, risk_profile_representatives, risk_profile_honesty_and_integrity, risk_profile_discretionary, risk_profile_general, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_risk_profile/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    risk_profile_scope_of_license: risk_profile_scope_of_license,
                    risk_profile_fit_and_proper: risk_profile_fit_and_proper,
                    risk_profile_operational_ability: risk_profile_operational_ability,
                    risk_profile_financial_soundness: risk_profile_financial_soundness,
                    risk_profile_code_of_conduct: risk_profile_code_of_conduct,
                    risk_profile_representatives: risk_profile_representatives,
                    risk_profile_honesty_and_integrity: risk_profile_honesty_and_integrity,
                    risk_profile_discretionary: risk_profile_discretionary,
                    risk_profile_general: risk_profile_general
                }
            };

            return $http(req);
        }
    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPShareholdersAdminController', function ($scope, $state, $controller, $timeout, FSPShareholdersService, FirebaseStorageService, FirebaseAuthService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.shareholders = [];
    $scope.shareholder = {
        id: 0,
        first_name: '',
        last_name: '',
        id_reg_number: '',
        date_obtained: new Date(),
        percentage: 0,
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - administer shareholding';

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {
        retrieveShareholders();

        $(document).ready(function () {
            initiateDateControl();
        });
    }

    function initiateDateControl() {
        setTimeout(function () {

            // const $dateInput = $(`#date_obtained`).pickadate({
            //     selectMonths: true, // Creates a dropdown to control month
            //     selectYears: 100, // Creates a dropdown of 100 years to control year
            //     format: "yyyy-mm-dd"
            // });
            //
            // let datePicker = $dateInput.pickadate('picker');
            // datePicker.set('select', $scope.shareholder.date_obtained);

            var docUploadControl = document.getElementById("documentUpload");

            var fileDetails = {
                folder: '/fsp_shareholder_attachments/' + $scope.fspId,
                attachments: $scope.shareholder.attachments
            };

            var eventDelegator = $scope.fileUploader.bind(fileDetails);
            docUploadControl.addEventListener('change', eventDelegator);

            $scope.$on('filesUploaded', function (event, attachments) {
                var combined = new Set($scope.shareholder.attachments.concat(attachments));
                $scope.shareholder.attachments = [].concat(_toConsumableArray(combined));
                $scope.$apply();
            });
        }, 500);
    }

    function retrieveShareholders() {

        $scope.processing = true;
        $scope.editing = false;

        FSPShareholdersService.getShareholdersList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.shareholders = res.data.shareholders;
            $scope.shareholders.sort(function (a, b) {
                return parseFloat(b.percentage) - parseFloat(a.percentage);
            });
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editShareholder = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit shareholding';

        var shareholder = Object.assign({}, $scope.shareholders[index]);

        $scope.shareholder = {
            id: shareholder.id,
            first_name: shareholder.first_name,
            last_name: shareholder.last_name,
            id_reg_number: shareholder.id_reg_number,
            date_obtained: new Date(shareholder.date_obtained),
            percentage: !isNaN(shareholder.percentage) ? parseFloat(shareholder.percentage) : 0,
            attachments: shareholder.attachments

        };
        initiateDateControl();
        $scope.editing = true;
    };

    $scope.addShareholder = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add shareholding';

        $scope.shareholder = {
            id: 0,
            first_name: '',
            last_name: '',
            id_reg_number: '',
            date_obtained: new Date(),
            percentage: '',
            attachments: []

        };
        initiateDateControl();
        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer shareholding';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveShareholder($scope.shareholder.id, $scope.shareholder.first_name, $scope.shareholder.last_name, $scope.shareholder.id_reg_number, $scope.shareholder.percentage, $scope.shareholder.attachments);
        }
    };

    $scope.saveShareholder = function (id, first_name, last_name, id_reg_number, percentage, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;

            percentage = parseFloat(percentage);

            var dateObtained = $('#date_obtained').val();
            if (isNaN(percentage)) {
                percentage = 0;
            }

            if (Math.abs(moment(dateObtained).diff(moment(), 'years')) > 100) {
                dateObtained = moment().format('YYYY-MM-DD');
            }

            if (id) {

                FSPShareholdersService.editShareholder(id, first_name, last_name, id_reg_number, dateObtained, percentage, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPShareholdersService.createShareholder($scope.fspId, first_name, last_name, id_reg_number, dateObtained, percentage, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {

        $event.preventDefault();
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.title = $scope.fspName + ' - administer shareholding';
    };

    $scope.deleteShareholder = function (shareholderId, index) {

        $('#modalConfirmHeader').html('DELETING SHAREHOLDING');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPShareholdersService.deleteShareholder(this.shareholderId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ shareholderId: shareholderId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };
});
'use strict';

angular.module('ics').factory('FSPShareholdersService', function ($http) {

    return {

        getShareholdersList: function getShareholdersList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_shareholder/list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createShareholder: function createShareholder(fspId, first_name, last_name, id_reg_number, date_obtained, percentage, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_shareholder/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    first_name: first_name,
                    last_name: last_name,
                    id_reg_number: id_reg_number,
                    date_obtained: date_obtained,
                    percentage: percentage,
                    attachments: attachments
                }
            };

            return $http(req);
        },

        editShareholder: function editShareholder(shareholderId, first_name, last_name, id_reg_number, date_obtained, percentage, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_shareholder/' + shareholderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    name: name,
                    first_name: first_name,
                    last_name: last_name,
                    id_reg_number: id_reg_number,
                    date_obtained: date_obtained,
                    percentage: percentage,
                    attachments: attachments
                }
            };

            return $http(req);
        },

        deleteShareholder: function deleteShareholder(shareholderId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_shareholder/' + shareholderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPThirdPartyAdministratorsAdminController', function ($scope, $state, $controller, $timeout, FSPThirdPartyAdministratorsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.third_party_administrators = [];
    $scope.third_party_administrator = {
        id: 0,
        lisps: '',
        client_administered: '',
        contact_person: '',
        date_appointed: new Date(),
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - third-party administrators';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveThirdPartyAdministrators();

        setTimeout(function () {
            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_third_party_administrator_attachments/' + $scope.fspId,
                    attachments: $scope.third_party_administrator.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.third_party_administrator.attachments.concat(attachments));
                    $scope.third_party_administrator.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 1000);
    };

    function retrieveThirdPartyAdministrators() {

        $scope.processing = true;
        $scope.editing = false;

        FSPThirdPartyAdministratorsService.getThirdPartyAdministratorsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.third_party_administrators = res.data.third_party_administrators;
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editThirdPartyAdministrator = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit third party administrator';

        var third_party_administrator = $scope.third_party_administrators[index];
        $scope.third_party_administrator = {
            id: third_party_administrator.id,
            lisps: third_party_administrator.lisps,
            client_administered: third_party_administrator.client_administered,
            contact_person: third_party_administrator.contact_person,
            attachments: third_party_administrator.attachments

        };
        $scope.editing = true;
    };

    $scope.addThirdPartyAdministrator = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add third party administrator';

        $scope.third_party_administrator = {
            id: 0,
            lisps: '',
            client_administered: '',
            contact_person: '',
            attachments: []
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - third-party administrators';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveThirdPartyAdministrator = function (id, lisps, client_administered, contact_person, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;
            $scope.third_party_administrator.date_appointed = $('#date_appointed').val();

            if (id) {

                FSPThirdPartyAdministratorsService.editThirdPartyAdministrator(id, lisps, client_administered, contact_person, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPThirdPartyAdministratorsService.createThirdPartyAdministrator($scope.fspId, lisps, client_administered, contact_person, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {

        $event.preventDefault();
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.title = $scope.fspName + ' - third_party_administrators';
    };

    $scope.deleteThirdPartyAdministrator = function (third_party_administratorId, index) {

        $('#modalConfirmHeader').html('DELETING ADMINISTRATOR');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPThirdPartyAdministratorsService.deleteThirdPartyAdministrator(this.third_party_administratorId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            });
        };

        var deletionEvent = deleteType.bind({ third_party_administratorId: third_party_administratorId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.removeAttachment = function (index) {
        var filesUploadedIndex = filesUploaded.findIndex(function (item) {
            return item === $scope.third_party_administrator.attachments[index].file_name;
        });
        if (filesUploadedIndex !== -1) {
            filesUploaded.splice(filesUploadedIndex, 1);
        }
        $scope.third_party_administrator.attachments.splice(index, 1);
    };
});
'use strict';

angular.module('ics').factory('FSPThirdPartyAdministratorsService', function ($http) {

    return {

        getThirdPartyAdministratorsList: function getThirdPartyAdministratorsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_third_party_administrator_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createThirdPartyAdministrator: function createThirdPartyAdministrator(fspId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_third_party_administrator/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    lisps: lisps,
                    client_administered: client_administered,
                    contact_person: contact_person,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editThirdPartyAdministrator: function editThirdPartyAdministrator(fspThirdPartyAdministratorId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_third_party_administrator/' + fspThirdPartyAdministratorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    lisps: lisps,
                    client_administered: client_administered,
                    contact_person: contact_person,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteThirdPartyAdministrator: function deleteThirdPartyAdministrator(fspThirdPartyAdministratorId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_third_party_administrator/' + fspThirdPartyAdministratorId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('ics').controller('FSPScopeOfLicensingAdminController', function ($scope, $state, $controller, $timeout, FSPScopeOfLicensingService, CategoriesService, SubCategoriesService, FirebaseAuthService) {
    var _this = this;

    var retrieveScopesOfLicensing = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var res, res2, res3, res4, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, category, subCategoriesRes, subClassesOfBusiness;

            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;


                            $scope.processing = true;
                            $scope.editing = false;

                            _context2.next = 5;
                            return FSPScopeOfLicensingService.getScopeOfLicensing($scope.fspId, $scope.tokenId, $scope.visitorId);

                        case 5:
                            res = _context2.sent;


                            if (res.data.fsp_scope_of_licensing && res.data.fsp_scope_of_licensing.id) {
                                $scope.scope_of_licensing = res.data.fsp_scope_of_licensing;
                            }

                            _context2.next = 9;
                            return CategoriesService.getCategoriesListFromCode('licencing_categories', $scope.tokenId, $scope.visitorId);

                        case 9:
                            res2 = _context2.sent;


                            $scope.licencingCategories = res2.data.categories.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            });

                            _context2.next = 13;
                            return CategoriesService.getCategoriesListFromCode('financial_products', $scope.tokenId, $scope.visitorId);

                        case 13:
                            res3 = _context2.sent;


                            $scope.licensingItems = [];
                            $scope.financialProducts = res3.data.categories.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            });

                            // loop through each fin product
                            $scope.financialProducts.forEach(function (product) {

                                // loop through each licensing category
                                $scope.licencingCategories.forEach(function (category) {

                                    // financial instrument category must match licensing category
                                    if (category.code.toUpperCase() === product.code.toUpperCase()) {

                                        $scope.licensingItems.push({
                                            category_id: category.id,
                                            category_code: category.code,
                                            category_name: category.name,
                                            financial_product_id: product.id,
                                            financial_product_name: product.name,
                                            date_approved_by_fcsa: new Date(),
                                            date_approved: new Date(),
                                            advice: false,
                                            intermediary: false,
                                            discretion: false
                                        });
                                    }
                                });
                            });

                            if ($scope.scope_of_licensing.scope_of_licensing_items.length > 0) {

                                // update to reflect the FSP's existing scope of licensing if applicable
                                $scope.scope_of_licensing.scope_of_licensing_items.forEach(function (item) {
                                    var foundItem = $scope.licensingItems.find(function (i) {
                                        return i.category_id == item.category_id && i.financial_product_id == item.financial_product_id;
                                    });
                                    if (foundItem) {
                                        foundItem.date_approved_by_fcsa = new Date(item.date_approved_by_fcsa);
                                        foundItem.date_approved = new Date(item.date_approved);
                                        foundItem.advice = item.advice;
                                        foundItem.intermediary = item.intermediary;
                                        foundItem.discretion = item.discretion;
                                    }
                                });
                            }

                            _context2.next = 20;
                            return CategoriesService.getCategoriesListFromCode('COB', $scope.tokenId, $scope.visitorId);

                        case 20:
                            res4 = _context2.sent;

                            $scope.classesOfBusiness = res4.data.categories;

                            $scope.classesOfBusiness.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                item.selected = false;
                                item.subClasses = [];
                            });

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 26;
                            _iterator = $scope.classesOfBusiness[Symbol.iterator]();

                        case 28:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 40;
                                break;
                            }

                            category = _step.value;
                            _context2.next = 32;
                            return SubCategoriesService.getSubCategoriesList(category.id, $scope.tokenId, $scope.visitorId);

                        case 32:
                            subCategoriesRes = _context2.sent;
                            subClassesOfBusiness = [];

                            subClassesOfBusiness = subClassesOfBusiness.concat(subCategoriesRes.data.sub_categories || []);
                            subClassesOfBusiness.sort(function (a, b) {
                                return a.display_order - b.display_order;
                            }).forEach(function (item) {
                                return item.selected = false;
                            });
                            category.subClasses = subClassesOfBusiness || [];

                        case 37:
                            _iteratorNormalCompletion = true;
                            _context2.next = 28;
                            break;

                        case 40:
                            _context2.next = 46;
                            break;

                        case 42:
                            _context2.prev = 42;
                            _context2.t0 = _context2['catch'](26);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 46:
                            _context2.prev = 46;
                            _context2.prev = 47;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 49:
                            _context2.prev = 49;

                            if (!_didIteratorError) {
                                _context2.next = 52;
                                break;
                            }

                            throw _iteratorError;

                        case 52:
                            return _context2.finish(49);

                        case 53:
                            return _context2.finish(46);

                        case 54:

                            ($scope.scope_of_licensing.classes_of_business || []).forEach(function (item) {
                                var classOfBusiness = $scope.classesOfBusiness.find(function (businessClass) {
                                    return businessClass.id === item.id;
                                });
                                if (classOfBusiness) {
                                    classOfBusiness.selected = true;

                                    ($scope.scope_of_licensing.sub_classes_of_business || []).forEach(function (item) {

                                        var subClassOfBusiness = classOfBusiness.subClasses.find(function (businessClass) {
                                            return businessClass.id === item.id;
                                        });
                                        if (subClassOfBusiness) {
                                            subClassOfBusiness.selected = true;
                                        }
                                    });
                                }
                            });

                            $scope.processing = false;
                            $scope.$applyAsync();

                            setTimeout(function () {

                                $(document).ready(function () {

                                    var docUploadControl = document.getElementById("documentUpload");

                                    var fileDetails = {
                                        folder: '/fsp_scope_of_licensing_attachments/' + $scope.fspId,
                                        attachments: $scope.scope_of_licensing.attachments
                                    };

                                    var eventDelegator = $scope.fileUploader.bind(fileDetails);
                                    docUploadControl.addEventListener('change', eventDelegator);

                                    $scope.$on('filesUploaded', function (event, attachments) {
                                        var combined = new Set($scope.scope_of_licensing.attachments.concat(attachments));
                                        $scope.scope_of_licensing.attachments = [].concat(_toConsumableArray(combined));
                                        $scope.$apply();
                                    });
                                });
                            }, 1000);

                            $scope.processing = false;

                            _context2.next = 64;
                            break;

                        case 61:
                            _context2.prev = 61;
                            _context2.t1 = _context2['catch'](0);

                            $scope.checkErrStatus(_context2.t1);

                        case 64:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 61], [26, 42, 46, 54], [47,, 49, 53]]);
        }));

        return function retrieveScopesOfLicensing() {
            return _ref2.apply(this, arguments);
        };
    }();

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);

    $scope.scope_of_licensing = {
        id: 0,
        category_i_applicable: false,
        category_ii_applicable: false,
        category_iia_applicable: false,
        scope_of_licensing_items: [],
        classes_of_business: [],
        sub_classes_of_business: [],
        attachments: []
    };

    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - scope of licensing';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    $scope.init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return FirebaseAuthService.getUserToken();

                    case 2:
                        $scope.tokenId = _context.sent;
                        _context.next = 5;
                        return retrieveScopesOfLicensing();

                    case 5:
                        // Materialise Modal
                        $('.modal').modal({
                            opacity: .8,
                            startingTop: '4%',
                            endingTop: '25%'
                        });

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    $scope.cat1Filter = function (item) {
        return item.category_code === 'Category I';
    };
    $scope.cat2Filter = function (item) {
        return item.category_code === 'Category II';
    };
    $scope.cat2aFilter = function (item) {
        return item.category_code === 'Category IIA';
    };

    $scope.submitForm = function ($form) {

        if ($form.$valid) {
            $scope.saveItems();
        }
    };

    $scope.saveItems = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var finalItems, error, selectedClassesOfBusiness, selectedSubClassesOfBusiness;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.prev = 0;
                        finalItems = $scope.licensingItems.filter(function (item) {
                            return item.advice || item.intermediary || item.discretion;
                        });
                        error = false;

                        finalItems.forEach(function (item) {
                            if (isNaN(item.date_approved.getTime())) {
                                item.date_approved = new Date();
                            }
                            if (isNaN(item.date_approved_by_fcsa.getTime())) {
                                item.date_approved_by_fcsa = new Date();
                            }
                            if (Math.abs(moment(item.date_approved).diff(moment(), 'years')) > 100) {
                                error = true;
                            }
                            if (Math.abs(moment(item.date_approved_by_fcsa).diff(moment(), 'years')) > 100) {
                                error = true;
                            }
                        });

                        if (!error) {
                            _context3.next = 6;
                            break;
                        }

                        return _context3.abrupt('return', alert('Please check your dates, 1 or more appear to be invalid.'));

                    case 6:

                        finalItems.forEach(function (item) {
                            item.date_approved = moment(item.date_approved).format('YYYY-MM-DD');
                            item.date_approved_by_fcsa = moment(item.date_approved_by_fcsa).format('YYYY-MM-DD');
                        });

                        $scope.processing = true;
                        selectedClassesOfBusiness = $scope.classesOfBusiness.filter(function (item) {
                            return item.selected === true;
                        }).map(function (item) {
                            return item.id;
                        });
                        selectedSubClassesOfBusiness = [];

                        $scope.classesOfBusiness.filter(function (item) {
                            return item.selected === true;
                        }).forEach(function (cob) {
                            selectedSubClassesOfBusiness = selectedSubClassesOfBusiness.concat(cob.subClasses.filter(function (item) {
                                return item.selected === true;
                            }).map(function (item) {
                                return item.id;
                            }));
                        });

                        _context3.next = 13;
                        return FirebaseAuthService.getUserToken();

                    case 13:
                        $scope.tokenId = _context3.sent;
                        _context3.next = 16;
                        return FSPScopeOfLicensingService.postScopeOfLicensing($scope.fspId, $scope.scope_of_licensing.category_i_applicable || false, $scope.scope_of_licensing.category_ii_applicable || false, $scope.scope_of_licensing.category_iia_applicable || false, finalItems || [], $scope.scope_of_licensing.attachments, selectedClassesOfBusiness, selectedSubClassesOfBusiness, $scope.tokenId, $scope.visitorId);

                    case 16:
                        $scope.processing = false;
                        $('#modalInfoHeader').html('Thank you');
                        $('#modalInfoText').html('The changes have been saved.');
                        $('#information_modal').modal('open');

                        setTimeout(function () {
                            $('#information_modal').modal('close');
                            $scope.goBack();
                        }, 2000);

                        _context3.next = 27;
                        break;

                    case 23:
                        _context3.prev = 23;
                        _context3.t0 = _context3['catch'](0);

                        $scope.processing = false;
                        $scope.checkErrStatus(_context3.t0);

                    case 27:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this, [[0, 23]]);
    }));

    $scope.init();

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - administer scope of licensing';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };
});
'use strict';

angular.module('ics').factory('FSPScopeOfLicensingService', function ($http) {

    return {

        getScopeOfLicensing: function getScopeOfLicensing(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_scope_of_licensing/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        postScopeOfLicensing: function postScopeOfLicensing(fspId, category_i_applicable, category_ii_applicable, category_iia_applicable, scope_of_licensing_items, attachments, classes_of_business, sub_classes_of_business, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_scope_of_licensing/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    scope_of_licensing_items: scope_of_licensing_items || [],
                    category_i_applicable: category_i_applicable,
                    category_ii_applicable: category_ii_applicable,
                    category_iia_applicable: category_iia_applicable,
                    classes_of_business: classes_of_business,
                    sub_classes_of_business: sub_classes_of_business,
                    attachments: attachments || []
                }
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPThirdPartyLispsAdminController', function ($scope, $state, $controller, $timeout, FSPThirdPartyLispsService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = $state.params.fsp_name;
    $scope.third_party_lisps = [];
    $scope.third_party_lisp = {
        id: 0,
        lisps: '',
        client_administered: '',
        contact_person: '',
        date_appointed: new Date(),
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - third-party LISPs';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveThirdPartyLisps();

        setTimeout(function () {
            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_third_party_lisp_attachments/' + $scope.fspId,
                    attachments: $scope.third_party_lisp.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.third_party_lisp.attachments.concat(attachments));
                    $scope.third_party_lisp.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 1000);
    };

    function retrieveThirdPartyLisps() {

        $scope.processing = true;
        $scope.editing = false;

        FSPThirdPartyLispsService.getThirdPartyLispsList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.third_party_lisps = res.data.third_party_lisps;
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editThirdPartyLisp = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit third party LISP';

        var third_party_lisp = $scope.third_party_lisps[index];
        $scope.third_party_lisp = {
            id: third_party_lisp.id,
            lisps: third_party_lisp.lisps,
            client_administered: third_party_lisp.client_administered,
            contact_person: third_party_lisp.contact_person,
            attachments: third_party_lisp.attachments

        };
        $scope.editing = true;
    };

    $scope.addThirdPartyLisp = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add third party lisp';

        $scope.third_party_lisp = {
            id: 0,
            lisps: '',
            client_administered: '',
            contact_person: '',
            attachments: []
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - third-party LISPs';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveThirdPartyLisp = function (id, lisps, client_administered, contact_person, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;
            $scope.third_party_lisp.date_appointed = $('#date_appointed').val();

            if (id) {

                FSPThirdPartyLispsService.editThirdPartyLisp(id, lisps, client_administered, contact_person, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPThirdPartyLispsService.createThirdPartyLisp($scope.fspId, lisps, client_administered, contact_person, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {

        $event.preventDefault();
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.title = $scope.fspName + ' - third_party_lisps';
    };

    $scope.deleteThirdPartyLisp = function (third_party_lispId, index) {

        $('#modalConfirmHeader').html('DELETING ADMINISTRATOR');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPThirdPartyLispsService.deleteThirdPartyLisp(this.third_party_lispId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            });
        };

        var deletionEvent = deleteType.bind({ third_party_lispId: third_party_lispId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.removeAttachment = function (index) {
        var filesUploadedIndex = filesUploaded.findIndex(function (item) {
            return item === $scope.third_party_lisp.attachments[index].file_name;
        });
        if (filesUploadedIndex !== -1) {
            filesUploaded.splice(filesUploadedIndex, 1);
        }
        $scope.third_party_lisp.attachments.splice(index, 1);
    };
});
'use strict';

angular.module('ics').factory('FSPThirdPartyLispsService', function ($http) {

    return {

        getThirdPartyLispsList: function getThirdPartyLispsList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_third_party_lisp_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createThirdPartyLisp: function createThirdPartyLisp(fspId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_third_party_lisp/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    lisps: lisps,
                    client_administered: client_administered,
                    contact_person: contact_person,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editThirdPartyLisp: function editThirdPartyLisp(fspThirdPartyLispId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_third_party_lisp/' + fspThirdPartyLispId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    lisps: lisps,
                    client_administered: client_administered,
                    contact_person: contact_person,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteThirdPartyLisp: function deleteThirdPartyLisp(fspThirdPartyLispId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_third_party_lisp/' + fspThirdPartyLispId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('ics').controller('FSPThirdPartyProvidersAdminController', function ($scope, $state, $controller, $timeout, FSPThirdPartyProvidersService, FirebaseAuthService, FirebaseStorageService) {

    $scope.fspId = $state.params.fsp_id;
    $scope.fspName = decodeURIComponent($state.params.fsp_name);
    $scope.third_party_providers = [];
    $scope.third_party_provider = {
        id: 0,
        name: '',
        client_administered: '',
        notes: '',
        date_appointed: new Date(),
        attachments: []

    };
    $scope.editing = false;
    $scope.tokenId = '';
    $scope.title = $scope.fspName + ' - third-party providers';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        init();
    });

    function init() {

        retrieveThirdPartyProviders();

        setTimeout(function () {
            $(document).ready(function () {

                var docUploadControl = document.getElementById("documentUpload");

                var fileDetails = {
                    folder: '/fsp_third_party_provider_attachments/' + $scope.fspId,
                    attachments: $scope.third_party_provider.attachments
                };

                var eventDelegator = $scope.fileUploader.bind(fileDetails);
                docUploadControl.addEventListener('change', eventDelegator);

                $scope.$on('filesUploaded', function (event, attachments) {
                    var combined = new Set($scope.third_party_provider.attachments.concat(attachments));
                    $scope.third_party_provider.attachments = [].concat(_toConsumableArray(combined));
                    $scope.$apply();
                });
            });
        }, 1000);
    };

    function retrieveThirdPartyProviders() {

        $scope.processing = true;
        $scope.editing = false;

        FSPThirdPartyProvidersService.getThirdPartyProvidersList($scope.fspId, $scope.tokenId, $scope.visitorId).then(function (res) {

            $scope.third_party_providers = res.data.third_party_providers;
            $scope.processing = false;
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    }

    $scope.editThirdPartyProvider = function (index) {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Edit third party provider';

        var third_party_provider = $scope.third_party_providers[index];
        $scope.third_party_provider = {
            id: third_party_provider.id,
            name: third_party_provider.name,
            client_administered: third_party_provider.client_administered,
            notes: third_party_provider.notes,
            attachments: third_party_provider.attachments

        };
        $scope.editing = true;
    };

    $scope.addThirdPartyProvider = function () {
        $('body').removeClass('bg-grey-1');
        $scope.title = 'Add third party provider';

        $scope.third_party_provider = {
            id: 0,
            name: '',
            client_administered: '',
            notes: '',
            attachments: []
        };

        $scope.editing = true;
    };

    $scope.goBack = function () {
        $('body').addClass('bg-grey-1');
        if ($scope.editing) {
            $scope.title = $scope.fspName + ' - third-party providers';
            return $scope.editing = false;
        }
        $state.transitionTo('admin-fsp-details', { fsp_id: $scope.fspId });
    };

    $scope.saveThirdPartyProvider = function (id, name, client_administered, notes, attachments) {

        FirebaseAuthService.getUserToken().then(function (tokenId) {

            $scope.processing = true;
            $scope.third_party_provider.date_appointed = $('#date_appointed').val();

            if (id) {

                FSPThirdPartyProvidersService.editThirdPartyProvider(id, name, client_administered, notes, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            } else {

                FSPThirdPartyProvidersService.createThirdPartyProvider($scope.fspId, name, client_administered, notes, attachments, tokenId, $scope.visitorId).then(function () {
                    return location.reload();
                }).catch(function (err) {
                    return $scope.checkErrStatus(err);
                });
            }
        });
    };

    $scope.cancelEditing = function ($event) {

        $event.preventDefault();
        $('body').addClass('bg-grey-1');
        $scope.editing = false;
        $scope.title = $scope.fspName + ' - third_party_providers';
    };

    $scope.deleteThirdPartyProvider = function (third_party_providerId, index) {

        $('#modalConfirmHeader').html('DELETING ADMINISTRATOR');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            FSPThirdPartyProvidersService.deleteThirdPartyProvider(this.third_party_providerId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            });
        };

        var deletionEvent = deleteType.bind({ third_party_providerId: third_party_providerId });

        $('#modalAgreeLink').click(function () {
            deletionEvent();
            $('#are_you_sure_modal').modal('close');
        });

        $('#are_you_sure_modal').modal('open');
    };

    $scope.removeAttachment = function (index) {
        var filesUploadedIndex = filesUploaded.findIndex(function (item) {
            return item === $scope.third_party_provider.attachments[index].file_name;
        });
        if (filesUploadedIndex !== -1) {
            filesUploaded.splice(filesUploadedIndex, 1);
        }
        $scope.third_party_provider.attachments.splice(index, 1);
    };
});
'use strict';

angular.module('ics').factory('FSPThirdPartyProvidersService', function ($http) {

    return {

        getThirdPartyProvidersList: function getThirdPartyProvidersList(fspId, firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/fsp_third_party_provider_list/' + fspId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createThirdPartyProvider: function createThirdPartyProvider(fspId, name, client_administered, notes, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'POST',
                url: '/api/fsp_third_party_provider/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    fsp: fspId,
                    name: name,
                    client_administered: client_administered,
                    notes: notes,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        editThirdPartyProvider: function editThirdPartyProvider(fspThirdPartyProviderId, name, client_administered, notes, attachments, firebaseTokenId, visitorId) {

            var req = {
                method: 'PUT',
                url: '/api/fsp_third_party_provider/' + fspThirdPartyProviderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    name: name,
                    client_administered: client_administered,
                    notes: notes,
                    attachments: attachments || []
                }
            };

            return $http(req);
        },

        deleteThirdPartyProvider: function deleteThirdPartyProvider(fspThirdPartyProviderId, firebaseTokenId, visitorId) {

            var req = {
                method: 'DELETE',
                url: '/api/fsp_third_party_provider/' + fspThirdPartyProviderId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        }

    };
});
'use strict';

angular.module('ics').controller('ReportEmailTemplatesAdminController', function ($scope, $state, $controller, $timeout, ReportEmailTemplatesService, FirebaseAuthService) {
    $scope.item = {

        emailTemplateId: '',
        templateName: '',
        emailSubject: '',
        emailBody: ''

    };

    $scope.editing = false;
    $scope.errorMessage = '';
    $scope.tokenId = '';
    $scope.processing = true;

    angular.extend(this, $controller('BaseAdminController', { $scope: $scope }));

    FirebaseAuthService.getUserToken().then(function (tokenId) {
        $scope.tokenId = tokenId;
        $scope.init();
    }).catch(function (err) {
        return $scope.checkErrStatus(err);
    });

    $scope.init = function () {
        $scope.processing = true;

        ReportEmailTemplatesService.getReportEmailTemplatesList($scope.tokenId, $scope.visitorId).then(function (response) {
            $scope.emailTemplatesList = response.data.report_email_templates;
            reset();
        }).catch(function (err) {
            return $scope.checkErrStatus(err);
        });
    };

    $scope.submitForm = function ($form) {
        if ($form.$valid) {
            $scope.saveEmailTemplate($scope.item.templateName, $scope.item.emailSubject, $scope.item.emailBody);
        }
    };

    $scope.saveEmailTemplate = function (templateName, emailSubject, emailBody) {
        $scope.errorMessage = '';
        $scope.processing = true;
        if ($scope.item.emailTemplateId === '') {
            ReportEmailTemplatesService.createReportEmailTemplate(templateName, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        } else {
            ReportEmailTemplatesService.editReportEmailTemplate($scope.item.emailTemplateId, templateName, emailSubject, emailBody, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        }
    };

    $scope.deleteEmailTemplate = function (emailTemplateId, index) {
        $('#modalConfirmHeader').html('Deleting Email Template');
        $('#modalConfirmText').html('Are you sure you want to delete this item?');

        var deleteType = function deleteType() {

            ReportEmailTemplatesService.deleteReportEmailTemplate(this.emailTemplateId, $scope.tokenId, $scope.visitorId).then(function () {
                return location.reload();
            }).catch(function (err) {
                return $scope.checkErrStatus(err);
            });
        };

        var deletionEvent = deleteType.bind({ emailTemplateId: emailTemplateId });

        $(document).ready(function () {

            $('#modalAgreeLink').click(function () {
                deletionEvent();
                $('#are_you_sure_modal').modal('close');
            });

            $('#are_you_sure_modal').modal('open');
        });
    };

    $scope.editEmailTemplate = function (emailTemplateId, index) {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = emailTemplateId;
        $scope.item.templateName = $scope.emailTemplatesList[index].template_name;
        $scope.item.emailSubject = $scope.emailTemplatesList[index].email_subject;
        $scope.item.emailBody = $scope.emailTemplatesList[index].email_body;

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });

        $scope.editing = true;
    };

    $scope.addEmailTemplate = function () {
        $('body').removeClass('bg-grey-1');
        $scope.item.emailTemplateId = '';
        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';

        $scope.editing = true;
        $scope.errorMessage = '';

        $timeout(function () {
            $('select').material_select();
            $('textarea').trigger('autoresize');
        });
    };

    $scope.cancelSaveEmailTemplate = function () {
        $('body').addClass('bg-grey-1');
        reset();
    };

    function reset() {
        $scope.processing = false;
        $scope.editing = false;
        $scope.errorMessage = '';

        $scope.item.templateName = '';
        $scope.item.emailSubject = '';
        $scope.item.emailBody = '';
    }
});
'use strict';

angular.module('ics').factory('ReportEmailTemplatesService', function ($http) {

    return {

        getReportEmailTemplatesList: function getReportEmailTemplatesList(firebaseTokenId, visitorId) {

            var req = {
                method: 'GET',
                url: '/api/report_email_template/list',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000
            };

            return $http(req);
        },

        createReportEmailTemplate: function createReportEmailTemplate(templateName, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'POST',
                url: '/api/report_email_template/',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject
                }
            };

            return $http(req);
        },

        editReportEmailTemplate: function editReportEmailTemplate(emailTemplateId, templateName, emailSubject, emailBody, firebaseTokenId, visitorId) {
            var req = {
                method: 'PUT',
                url: '/api/report_email_template/' + emailTemplateId,
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                timeout: 8000,
                data: {
                    'template_name': templateName,
                    'email_body': emailBody,
                    'email_subject': emailSubject
                }
            };

            return $http(req);
        },

        deleteReportEmailTemplate: function deleteReportEmailTemplate(emailTemplateId, firebaseTokenId, visitorId) {
            var req = {
                method: 'DELETE',
                headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                url: '/api/report_email_template/' + emailTemplateId,
                timeout: 8000
            };

            return $http(req);
        }
    };
});